const INCREASE_BUTTON_DISABLED_CLASSNAME = 'disabled';
const OUT_OF_STOCK_CLASSNAME = 'cart__out-of-stock';
const OUT_OF_STOCK_MESSAGE = 'Ďalšie kusy nie sú na sklade. K dispozícii je len %d ks.';
const INVENTORY_POLICY_DENY = "deny";
const GO_TO_CART_WHEN_ADDING_PRODUCT_TRASHOLD = 992;

function addOutOfStockMessage(wrapper, available) {
    if (wrapper.find('.' + OUT_OF_STOCK_CLASSNAME).length === 0) {
        wrapper.append(buildOutOffStockMessage(available));
    }
}

function addItemAJAX(prodId, prodQuantity) {
    jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { id: prodId, quantity: prodQuantity },
        success: function (response) {
          console.log("Details saved successfully!!!");
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log(xhr.status);
            console.log(thrownError);
        }
      });

    // jQuery.post('cart/add.js', { id: prodId, quantity: prodQuantity }, function(){
    //     alert("success");
    // })
    
}

function removeOutOfStockMessage(wrapper) {
    wrapper.find('.' + OUT_OF_STOCK_CLASSNAME).remove();
}

function buildOutOffStockMessage(available) {
    return `
        <span class="${OUT_OF_STOCK_CLASSNAME}">
            ${OUT_OF_STOCK_MESSAGE.replaceAll("%d", available)}
        </span>`;
}

function buildEmptyCart(myCart, emptyCart) {
    return `
        <div class="nav-cart-empty">
            <h3 style="opacity: 0.5">${ myCart }</h3>
            <p>${ emptyCart }</p>
        </div>`;
}

function buildCart(data) {
    return `
        <div class="drawer-heading">   
            <h3>${ data.heading }</h3>
            <!--zavreni cartu-->
            <a class="js-cart-close" ghef="#">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.6">
                    <path d="M20 4L4 20" stroke="black" stroke-width="1.5"/>
                    <path d="M4 4L20 20" stroke="black" stroke-width="1.5"/>
                    </g>
                    </svg>
            
            </a>
        </div> 
        <div class="cart-drawer-overflow">
            <div class="cart-discount-center cart-discount-center--drawer hidden"></div>
            <table class="cart-items clean limoniapps-discountninja-cart-root">
                <tbody id="cart">
                </tbody>
            </table>
            <div class="drawer-suggestion ${ data.productSuggestion.id ? '' : 'hidden'}">
                <h5>${ data.productSuggestion.text }</h5>
                <div class="drawer-suggestion__product">
                    <div class="drawer-suggestion__img">
                        <img src="${ data.productSuggestion.image }">
                    </div>
                    <div class="drawer-suggestion__text">
                        <div class="drawer-suggestion__product_info">
                            <div class="cart-title mabry">${ data.productSuggestion.title }</div>
                            <div class="cart-variant fs-12 fs-10-m lh120" style="margin: 5px 0;">${ data.productSuggestion.ml }</div>
                            <div class="money">${ data.productSuggestion.price }</div>
                        </div>
                        <button onclick="addItemAJAX(${ data.productSuggestion.id }, 1)"> ${ data.productSuggestion.add_to_cart } </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="drawer-bottom-info-wrapper">
            <div class="cart-prices-wrapper">
                <div class="cart-price cart-price--mezi">
                    <span id="ie-custom-currency" class="tw-hidden">${ data.currency }</span>
                    <span id="cart-subtotal" class="money__description fs-14">
                        ${ data.subtotalHeading }:
                    </span>
                    <div class="tw-flex tw-gap-[10px] tw-items-start">
                    <s class="fs-16 money tw-opacity-50" id="ie-custom-subtotal-drawer"></s>
                    <span class="money fs-16"> ${ data.subtotal }</span>
                    </div>
                </div>
                <div class="cart-price cart-price--discounts hidden">
                    <span class="fs-14 mabry orange_text">
                        ${ data.discountHeading }:
                    </span>
                    <span class="money fs-16 orange_text">${ data.discount }</span>
                </div>
                <div class="cart-price cart-price--logistics">
                    <span class="money__description fs-14"></span>
                    <span class="money fs-16"></span>
                </div>
                <div class="cart-price cart-price--total">
                    <span id="cart-subtotal" class="money__description fs-18">
                        ${ data.totalHeading }:
                    </span>
                    <span class="money fs-24">${ data.total }</span>
                </div>
            </div>
            <div style="margin-top:20px;" class="limoniapps-discountninja-cartdiscountfield-placeholder"></div>
            <style>.limoniapps-discountninja-cartdiscountfield-input { max-width: none !important;}</style>
    <div class="drawer-btns">
    <button class="drawer-button drawer-button--cart" onclick="location.href='/cart'">
            ${ data.show }
    </button>
        <button class="drawer-button drawer-button--checkout" onclick="location.href='/checkout'">
            ${ data.completeOrder }
            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5"
                d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                fill="white" />
        </svg>
        </button>
        </div>
        
        
        </div>`;
}

function buildCartRow(item) {
    let imageSrc = item.imgSrc.replace(/(\.[a-z]+\?v=\d+$)/, "_220x\$1");
    let imageSrcSet = item.imgSrc.replace(/(\.[a-z]+\?v=\d+$)/, "_220x220\$1 1x, ")
        + item.imgSrc.replace(/(\.[a-z]+\?v=\d+$)/, "_440x440\$1 2x, ")
    ;

    let disabledLogic = (variantAvailability[item.variantId].policy === INVENTORY_POLICY_DENY && variantAvailability[item.variantId].quantity < (item.quantity + 1)) || item.type == 'Trial'
    
    let unavailable = outOfStock = disabledInput = '';

    if (disabledLogic) {
        unavailable = ' ' + INCREASE_BUTTON_DISABLED_CLASSNAME;
        outOfStock = buildOutOffStockMessage(variantAvailability[item.variantId].quantity);
        disabledInput = 'disabled';
    }

    return `
<tr class="cart-item variant-${item.variantId}" data-variant="${item.variantId}" data-title="${item.title}" data-url="${item.url}">
    <td class="cart-item-product">
        <div class="cart-image-wrap">
            <a class="cart-image" href="${item.url}">
                <img src="${imageSrc}" alt="${item.title}" srcset="${imageSrcSet}">
            </a>
        </div>
                
        <div class="cart-item-product-wrap">
            <span class="cart-title mabry"><a href="${item.url}">${item.getTitle()}</a></span>
            <span class="cart-variant">${ item.getDescription() }${ item.getVariantText() && item.getDescription() ? ', ' : ''}${ item.getVariantText() ? item.getVariantText() : "" }</span>
            <div class="cart-item-total-wrap ie-custom-product-price">
            <div class="money">
                ${ item.priceOriginal ? "<span class='original-price'>" + item.priceOriginal + "</span>" : ''}
                <span class="new-price">${item.price}</span>
            </div>
            <div class="cart-item__container--remove">
            <div class="cart-item-quantity">
                <span class="cart-item-decrease icon"></span>
                <input type="text" ${ disabledInput } name="updates[]" class="input-field cart-item-quantity-display" value="${item.quantity}" size="1">
                <span class="cart-item-increase icon${unavailable}"></span>
            </div>
            
           <a class="cart-item-remove js-cart-item-remove" href="#">
                Odstranit
            </a>
            ${outOfStock}
            <div class="cart-item-remove--mobile">
            <a class=" js-cart-item-remove" href="#">
                Odstranit
            </a>
        </div>
        </div>
        </div>
        </div>
                                                




    </td>
</tr>`;
}

var Twitter,
    slice = [].slice,
    extend = function (child, parent) {
        for (var key in parent) {
            if (hasProp.call(parent, key)) child[key] = parent[key];
        }

        function ctor() {
            this.constructor = child;
        }

        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    },
    hasProp = {}.hasOwnProperty;

window.ThemeUtils = {
    extend: function () {
        var dest, j, k, len, obj, objs, v;
        dest = arguments[0], objs = 2 <= arguments.length ? slice.call(arguments, 1) : [];
        for (j = 0, len = objs.length; j < len; j++) {
            obj = objs[j];
            for (k in obj) {
                v = obj[k];
                dest[k] = v;
            }
        }
        return dest;
    },
    windowWidth: function () {
        var documentWidth, width, windowWidth;
        documentWidth = document.documentElement.clientWidth;
        windowWidth = window.innerWidth;
        width = documentWidth < windowWidth ? windowWidth : documentWidth;
        return width;
    },
    debounce: function (func, wait, immediate) {
        var timeout;
        timeout = null;
        return function () {
            var args, callNow, context, later;
            context = this;
            args = arguments;
            later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    },
    inViewport: function (el) {
        var rect, viewportHeight, viewportWidth;
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
        rect = el.getBoundingClientRect();
        if (document.documentElement.clientWidth < window.innerWidth) {
            viewportWidth = document.documentElement.clientWidth;
        } else {
            viewportWidth = window.innerHeight;
        }
        if (document.documentElement.clientHeight < window.innerHeight) {
            viewportHeight = document.documentElement.clientHeight;
        } else {
            viewportHeight = window.innerHeight;
        }
        return rect.bottom >= 0 && rect.right >= 0 && rect.top <= viewportHeight && rect.left <= viewportWidth;
    },
    externalLinks: function ($el) {
        var anchors;
        anchors = $el.find('a[href^="http"]').filter((function (_this) {
            return function (i, el) {
                return el.href.indexOf(location.hostname) === -1;
            };
        })(this));
        return anchors.attr('target', '_blank');
    },
    unique: function (array) {
        var j, key, output, ref, results, value;
        output = {};
        for (key = j = 0, ref = array.length; 0 <= ref ? j < ref : j > ref; key = 0 <= ref ? ++j : --j) {
            output[array[key]] = array[key];
        }
        results = [];
        for (key in output) {
            value = output[key];
            results.push(value);
        }
        return results;
    },
    scrollTarget: function ($el) {
        if (!($el instanceof jQuery)) {
            $el = $($el);
        }
        return $('html, body').animate({
            scrollTop: $el.offset().top
        }, 500, 'linear');
    }
};

window.NavigationView = (function (superClass) {
    extend(NavigationView, superClass);

    function NavigationView() {
        return NavigationView.__super__.constructor.apply(this, arguments);
    }

    NavigationView.prototype.events = {
        'click .header-drawer .has-dropdown > a .dropdown-toggle': 'toggleNavigation'
    };

    NavigationView.prototype.initialize = function () {
        this.megaNav = this.$('.mega-nav');
        this.secondaryTier = this.megaNav.find('.secondary');
        return $(document.body).on('click', (function (_this) {
            return function (e) {
                if (!$(e.target).closest('.navigation').length) {
                    _this.$('.navigation .open').removeClass('open');
                    if (_this.megaNav.length) {
                        return _this.resetMegaNav();
                    }
                }
            };
        })(this));
    };

    NavigationView.prototype.toggleNavigation = function (e) {
        var button, megaNavHeight, target;
        e.preventDefault();
        target = $(e.currentTarget);
        button = $(e.currentTarget).children('.dropdown-toggle');
        if (target.hasClass('dropdown-toggle')) {
            button = target;
            target = target.parent();
        }
        megaNavHeight = this.megaNav.outerHeight();
        if (target.parent().hasClass('has-dropdown')) {
            e.preventDefault();
            if (target.hasClass('main-nav-item') && target.parent().hasClass('has-mega-nav')) {
                if (target.parent().hasClass('open')) {
                    this.resetMegaNav();
                    this.$('.navigation li').removeClass('open');
                } else {
                    this.$('.navigation li').removeClass('open');
                    target.parent().addClass('open');
                }
            } else if (target.hasClass('main-nav-item') && target.parent().hasClass('simple-dropdown')) {
                if (target.parent().hasClass('open')) {
                    this.$('.navigation li').removeClass('open');
                } else {
                    this.resetMegaNav();
                    this.$('.navigation li').removeClass('open');
                    target.parent().addClass('open');
                }
            } else {
                target.parent().toggleClass('open');
            }
            return button.attr('aria-expanded', target.parent().hasClass('open'));
        }
    };

    NavigationView.prototype.resetMegaNav = function () {
        return setTimeout((function (_this) {
            return function () {
                _this.megaNav.height('auto');
                return _this.secondaryTier.removeClass('hide');
            };
        })(this), 200);
    };

    NavigationView.prototype.render = function () {
    };

    return NavigationView;

})(Backbone.View);

window.HeaderView = (function () {
    function HeaderView() {
        this.window = $(window);
        this.$document = $(document.body);
        this.el = '[data-main-header]';
        this.headerLogo = '[data-header-logo]';
        this._init();
    }

    HeaderView.prototype._init = function () {
        this.$el = $(this.el);
        this.$drawerMenu = this.$document.find('[data-header-drawer]');
        this.$mainContent = $('[data-main-content]');
        this.$mainHeader = this.$el.find('[data-header-content]');
        this.$headerLogo = $(this.headerLogo);
        this.$searchWrapper = this.$el.find('[data-header-search]');
        this.slideShow = '[data-section-type=slideshow]';
        this.$slideShow = $(this.slideShow);
        this.isHeaderNavigation = this.$el.attr('data-main-header') === 'header';
        this.hasLogo = this.$el.find(this.headerLogo).length;
        this.isHeaderSticky = this.$el.attr('data-sticky-header') != null;
        this.sectionChanges(this.$slideShow, false, null);
        this._bindEvents();
        this.navigation = new NavigationView({
            el: this.$document
        });
        if (this.isHeaderNavigation) {
            this.calculateHeaderWidths();
            this.window.resize((function (_this) {
                return function () {
                    return _this.fitHeader();
                };
            })(this));
        }
        if ($('html').hasClass('lt-ie9')) {
            this.verticallyCenterShopName();
            if (this.hasLogo) {
                return this.verticallyCenterLogo();
            }
        }
    };

    HeaderView.prototype._bindEvents = function () {
        this.$document.on('shopify:section:select.header', (function (_this) {
            return function (event) {
                return _this.sectionChanges(null, true, event.originalEvent.detail.sectionId);
            };
        })(this)).on('shopify:section:deselect.header', (function (_this) {
            return function (event) {
                return _this.sectionChanges(null, true, event.originalEvent.detail.sectionId);
            };
        })(this)).on('click', '.header-search-toggle', (function (_this) {
            return function () {
                return _this.openSearch();
            };
        })(this)).on('blur', '.header-search-input', (function (_this) {
            return function () {
                return _this.closeSearch();
            };
        })(this)).on('click', '[data-drawer-toggle]', (function (_this) {
            return function () {
                return _this.toggleCollapsedNav();
            };
        })(this)).on('toggleStickyHeader', (function (_this) {
            return function (event, $slideshow) {
                return _this.stickyHeader($slideshow);
            };
        })(this)).on('toggleSlideShowHeader', (function (_this) {
            return function (event, $slideshow) {
                return _this.slideShowHeader($slideshow);
            };
        })(this)).on('swapLogo', (function (_this) {
            return function () {
                return _this.swapLogo();
            };
        })(this)).on('mouseenter', '.has-dropdown', (function (_this) {
            return function (event) {
                return _this.openSubNav(event);
            };
        })(this)).on('mouseleave', '.has-dropdown', (function (_this) {
            return function (event) {
                return _this.closeSubNav(event);
            };
        })(this));
        return this.window.on('resize.header', (function (_this) {
            return function () {
                return _this._resizeEvents();
            };
        })(this));
    };

    HeaderView.prototype.unBindEvents = function () {
        this.$document.off('shopify:section:select.header').off('shopify:section:deselect.header').off('.header-search-toggle').off('blur', '.header-search-input').off('click', '[data-drawer-toggle]').off('toggleStickyHeader', this.el).off('toggleSlideShowHeader', this.el).off('swapLogo', this.el);
        this.navigation.undelegateEvents();
        return this.window.off('resize.header');
    };

    HeaderView.prototype._resizeEvents = function () {
        this.stickyHeaderOffset(this.isHeaderSticky);
        if (this.$document.hasClass('navigation-below-header')) {
            this.$document.removeClass('navigation-below-header');
            this.$('.main-header').addClass('collapsed-navigation');
        }
        if (window.ThemeUtils.windowWidth() > 720 && this.$document.hasClass('showing-drawer')) {
            if (this.$document.hasClass('navigation-below-header') || this.$document.hasClass('navigation-header') && !this.$('.main-header').hasClass('collapsed-navigation')) {
                this.toggleCollapsedNav();
            }
        }
        return this.swapLogo();
    };

    HeaderView.prototype.swapLogo = function () {
        var hasFullBleedSlideshow, windowWidth;
        if (!this.$headerLogo.length) {
            return;
        }
        windowWidth = window.ThemeUtils.windowWidth();
        hasFullBleedSlideshow = $('[data-full-bleed-slideshow]').length;
        if (windowWidth <= 720 || !hasFullBleedSlideshow || this.$el.hasClass('sticky-header-scrolled')) {
            this.$headerLogo.attr('src', this.$headerLogo.attr('data-src-original'));
            return this.$headerLogo.attr('srcset', this.$headerLogo.attr('data-src-original'));
        } else if (hasFullBleedSlideshow) {
            this.$headerLogo.attr('src', this.$headerLogo.attr('data-src-alt'));
            return this.$headerLogo.attr('srcset', this.$headerLogo.attr('data-src-alt'));
        }
    };

    HeaderView.prototype.getColorSetting = function () {
        var colorSetting;
        colorSetting = this.$el.attr('class').match(/header-bleed-.+-colors/);
        if (colorSetting != null) {
            return colorSetting[0];
        } else {
            return false;
        }
    };

    HeaderView.prototype.slideShowHeader = function ($slideShow) {
        if ($slideShow == null) {
            $slideShow = $(this.slideShow);
        }
        if ($slideShow.length && ($slideShow.attr('data-full-bleed-slideshow') != null)) {
            return this.$el.addClass('full-bleed-slideshow');
        } else {
            this.$el.removeClass('full-bleed-slideshow');
            return this.$el.removeClass(this.getColorSetting());
        }
    };

    HeaderView.prototype.stickyHeader = function ($slideShow) {
        var colorSetting, hasSlideshow;
        if ($slideShow == null) {
            $slideShow = $(this.slideShow);
        }
        this.stickyHeaderOffset(this.isHeaderSticky, $slideShow);
        if (!this.isHeaderSticky) {
            return;
        }
        hasSlideshow = $slideShow.attr('data-full-bleed-slideshow') != null;
        colorSetting = this.getColorSetting();
        if (hasSlideshow && colorSetting) {
            this.$el.attr('data-header-bleed-color', colorSetting);
        }
        return this.window.on('scroll', (function (_this) {
            return function (e) {
                var scrollPosition;
                scrollPosition = _this.window.scrollTop();
                scrollPosition = scrollPosition < 110 ? 0 : scrollPosition;
                if (scrollPosition > 0) {
                    _this.$el.removeClass('full-bleed-slideshow').addClass('sticky-header-scrolled');
                    if (hasSlideshow) {
                        _this.$el.removeClass(colorSetting);
                    }
                } else if (scrollPosition === 0) {
                    _this.$el.removeClass('sticky-header-scrolled');
                    if (hasSlideshow) {
                        _this.$el.addClass('full-bleed-slideshow').addClass(_this.$el.attr('data-header-bleed-color'));
                    } else {
                        _this.$el.removeClass('full-bleed-slideshow');
                    }
                }
                return _this.swapLogo();
            };
        })(this));
    };

    HeaderView.prototype.stickyHeaderOffset = function (toggleOn, $slideShow) {
        var $promotionBar, $slides, hasFullBleedSlideshow, hasSlideshow,
            offsetHeight, promotionBarHeight, slideOffset;
        if ($slideShow == null) {
            $slideShow = $(this.slideShow);
        }
        offsetHeight = this.$el.outerHeight();
        $promotionBar = this.$el.find('[data-promotion-bar]');
        hasFullBleedSlideshow = ($slideShow != null ? $slideShow.attr('data-full-bleed-slideshow') : void 0) != null;
        hasSlideshow = $slideShow != null ? $slideShow.length : void 0;
        if (hasSlideshow) {
            $slides = $slideShow.find('[data-slide]');
            $slideShow.css({
                paddingTop: '',
                marginTop: ''
            });
            if ($slides.length) {
                $slides.css({
                    paddingTop: '',
                    height: ''
                });
                if (!hasFullBleedSlideshow || window.ThemeUtils.windowWidth() < 720) {
                    $slides.find('.slide-text').css({
                        paddingTop: '',
                        paddingBottom: ''
                    });
                }
            }
        }
        this.$mainContent.css({
            paddingTop: '',
            marginTop: ''
        });
        if (!((toggleOn || hasFullBleedSlideshow) && window.ThemeUtils.windowWidth() > 720)) {
            return;
        }
        if (hasSlideshow) {
            if (hasFullBleedSlideshow) {
                slideOffset = offsetHeight + 50;
                if ($promotionBar.length) {
                    promotionBarHeight = $promotionBar.outerHeight();
                    slideOffset = slideOffset - promotionBarHeight;
                    this.$mainContent.css({
                        paddingTop: promotionBarHeight
                    });
                }
                $slides.find('.slide-text').css({
                    paddingTop: slideOffset,
                    paddingBottom: 100
                });
            } else {
                if ($slideShow.attr('data-product-slideshow') != null) {
                    offsetHeight = offsetHeight + 20;
                }
                $slideShow.css({
                    marginTop: offsetHeight
                });
            }
            return $slideShow.find('[data-slideshow-container]').trigger('heightUpdate');
        } else {
            if ($('.template-index .module-container').length) {
                return this.$mainContent.css({
                    paddingTop: 0
                });
            } else {
                return this.$mainContent.css({
                    marginTop: 0
                });
            }
        }
    };


    /*
      Check to see if the header needs a border beneath it
          - Only apply border if
              - There is no slideshow
              - Header background matches body background
              - The first occurrence of '.module-container' has the default style
   */

    HeaderView.prototype.borderCheck = function () {
        var $mainHeader, bodyBackground, headerBackground;
        $mainHeader = $('[data-main-header]');
        if (Theme.headerSticky || $('[data-section-type=slideshow]').length !== 0) {
            return;
        }
        if ($(document.body).css('background-image') === !'none') {
            return;
        }
        headerBackground = $mainHeader.css('background-color');
        bodyBackground = $(document.body).css('background-color');
        if ($('.module-container:first').hasClass('default-style') && headerBackground === bodyBackground) {
            return $mainHeader.toggleClass('show-border', true);
        } else {
            return $mainHeader.toggleClass('show-border', false);
        }
    };


    /*
      These events need to fire when any section in the TE is reloaded
   */

    HeaderView.prototype.sectionChanges = function ($slideshow, isDocumentEvent, sectionId) {
        if (isDocumentEvent && sectionId === 'general-header') {
            return;
        }
        this.borderCheck();
        this.stickyHeader($slideshow);
        this.slideShowHeader($slideshow);
        return this.$headerLogo.on("rimg:load", (function (_this) {
            return function () {
                return _this.swapLogo();
            };
        })(this));
    };

    HeaderView.prototype.calculateHeaderWidths = function () {
        return this.$el.imagesLoaded((function (_this) {
            return function () {
                var brandingWidth, toolsWidth;
                brandingWidth = _this.$el.find('.branding').outerWidth(true);
                toolsWidth = _this.$el.find('.header-tools').outerWidth(true);
                if (brandingWidth === 0 && _this.$headerLogo.length) {
                    brandingWidth = _this.$headerLogo.width();
                }
                _this.combinedWidth = brandingWidth + toolsWidth;
                return _this.fitHeader();
            };
        })(this));
    };

    HeaderView.prototype.fitHeader = function () {
        var headerWidth;
        headerWidth = this.$mainHeader.width();
        this.$mainHeader.toggleClass('collapsed-navigation', this.combinedWidth + 45 > headerWidth);
        return this.stickyHeaderOffset(this.isHeaderSticky, null);
    };

    HeaderView.prototype.toggleCollapsedNav = function (e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.$document.toggleClass('showing-drawer');
        if (Modernizr.csstransitions) {
            return this.$el.one('transitionend', (function (_this) {
                return function () {
                    return _this.$document.toggleClass('drawer-visible');
                };
            })(this));
        } else {
            return this.$document.toggleClass('drawer-visible');
        }
    };

    HeaderView.prototype.openSearch = function () {
        if (window.innerWidth <= 720) {
            window.location.href = '/search';
            return;
        }
        this.$searchWrapper.addClass('active').find('input').focus();
        return this.$searchWrapper.on('keyup.search', (function (_this) {
            return function (e) {
                if (e.keyCode === 27) {
                    return _this.closeSearch();
                }
            };
        })(this));
    };

    HeaderView.prototype.closeSearch = function () {
        return this.$searchWrapper.removeClass('active').off('keyup.search');
    };

    HeaderView.prototype.verticallyCenterLogo = function () {
        return this.$el.imagesLoaded((function (_this) {
            return function () {
                var logoHeight;
                logoHeight = _this.$headerLogo.height();
                return _this.$('a.logo img').css({
                    marginTop: -1 * logoHeight / 2
                });
            };
        })(this));
    };

    HeaderView.prototype.verticallyCenterShopName = function () {
        var shopNameHeight;
        shopNameHeight = this.$drawerMenu.find('h1 a').height();
        return this.$drawerMenu.find('h1 a').css({
            marginTop: -1 * shopNameHeight / 2
        });
    };

    HeaderView.prototype.openSubNav = function (e) {
        this.checkSubNavVisibillity(e);
        return this.setExpanded(e);
    };

    HeaderView.prototype.closeSubNav = function (e) {
        return this.unsetExpanded(e);
    };

    HeaderView.prototype.checkSubNavVisibillity = function (e) {
        var $subNav, $subNavPosition;
        $subNav = $(e.currentTarget).children('ul').eq(0);
        if ($subNav.length) {
            $subNavPosition = $subNav.offset().left + $subNav.outerWidth();
            if ($subNavPosition > $(window).width()) {
                return $subNav.addClass('open-right');
            }
        }
    };

    HeaderView.prototype.setExpanded = function (e) {
        var $link;
        $link = $(e.currentTarget).find('.dropdown-toggle');
        return $link.attr("aria-expanded", true);
    };

    HeaderView.prototype.unsetExpanded = function (e) {
        var $link;
        $link = $(e.currentTarget).find('.dropdown-toggle');
        return $link.attr("aria-expanded", false);
    };

    HeaderView.prototype.render = function () {
    };

    return HeaderView;

})();

window.ImagesWithText = (function (superClass) {
    extend(ImagesWithText, superClass);

    function ImagesWithText() {
        return ImagesWithText.__super__.constructor.apply(this, arguments);
    }

    ImagesWithText.prototype.initialize = function () {
        this.$window = $(window);
        this.centerText(this.$el);
        return this.$window.on('resize.images-with-text', window.ThemeUtils.debounce((function (_this) {
            return function () {
                return _this.centerText(_this.$el);
            };
        })(this), 10));
    };

    ImagesWithText.prototype.prepareRemove = function () {
        return this.$window.off('resize.images-with-text');
    };

    ImagesWithText.prototype.centerText = function ($container) {
        var $content, containerHeight, contentHeight;
        $container.css({
            minHeight: ''
        });
        if ($container.attr('data-image-with-text-layout') !== 'background') {
            return;
        }
        $content = $container.find('[data-feature-content]');
        containerHeight = $container.outerHeight(true);
        contentHeight = $content.outerHeight(true);
        if (containerHeight > contentHeight) {
            return $content.css({
                top: (containerHeight - contentHeight) / 2
            });
        } else {
            $content.css({
                top: ''
            });
            return $container.css({
                minHeight: contentHeight
            });
        }
    };

    return ImagesWithText;

})(Backbone.View);

window.ZoomView = (function (superClass) {
    extend(ZoomView, superClass);

    function ZoomView() {
        return ZoomView.__super__.constructor.apply(this, arguments);
    }

    ZoomView.prototype.events = {
        'prepare-zoom': 'prepareZoom',
        'click': 'toggleZoom',
        'mouseout .product-image-zoom': 'toggleZoom',
        'mousemove .product-image-zoom': 'zoomImage'
    };

    ZoomView.prototype.initialize = function () {
        this.zoomArea = this.$('.product-image-zoom');
        this.$newImage = null;
        return this.$el.imagesLoaded((function (_this) {
            return function () {
                return _this.prepareZoom();
            };
        })(this));
    };

    ZoomView.prototype.prepareZoom = function () {
        var newImage, photoAreaHeight, photoAreaWidth;
        photoAreaWidth = this.$el.width();
        photoAreaHeight = this.$el.height();
        newImage = new Image();
        this.$newImage = $(newImage);
        this.$newImage.on('load', (function (_this) {
            return function () {
                var ratio, ratios;
                _this.zoomImageWidth = newImage.width;
                _this.zoomImageHeight = newImage.height;
                ratios = new Array();
                ratios[0] = _this.zoomImageWidth / photoAreaWidth;
                ratios[1] = _this.zoomImageHeight / photoAreaHeight;
                ratio = Math.max.apply(Math, ratios);
                if (ratio < 1.4) {
                    _this.$el.removeClass('zoom-enabled');
                } else {
                    _this.$el.addClass('zoom-enabled');
                    return _this.zoomArea.css({
                        backgroundImage: "url(" + newImage.src + ")"
                    });
                }
            };
        })(this));
        return newImage.src = this.$('img').attr('src');
    };

    ZoomView.prototype.toggleZoom = function (e) {
        if (this.$el.hasClass('zoom-enabled')) {
            if (e.type === 'mouseout') {
                this.zoomArea.removeClass('active');
                return;
            }
            if (this.zoomArea.hasClass('active')) {
                this.zoomArea.removeClass('active');
            } else {
                this.zoomArea.addClass('active');
            }
            return this.zoomImage(e);
        }
    };

    ZoomView.prototype.zoomImage = function (e) {
        var bigImageOffset, bigImageX, bigImageY, mousePositionX,
            mousePositionY, newBackgroundPosition, ratioX, ratioY, zoomHeight,
            zoomWidth;
        zoomWidth = this.zoomArea.width();
        zoomHeight = this.zoomArea.height();
        bigImageOffset = this.$el.offset();
        bigImageX = Math.round(bigImageOffset.left);
        bigImageY = Math.round(bigImageOffset.top);
        mousePositionX = e.pageX - bigImageX;
        mousePositionY = e.pageY - bigImageY;
        if (mousePositionX < zoomWidth && mousePositionY < zoomHeight && mousePositionX > 0 && mousePositionY > 0) {
            if (this.zoomArea.hasClass('active')) {
                ratioX = Math.round(mousePositionX / zoomWidth * this.zoomImageWidth - zoomWidth / 2) * -1;
                ratioY = Math.round(mousePositionY / zoomHeight * this.zoomImageHeight - zoomHeight / 2) * -1;
                if (ratioX > 0) {
                    ratioX = 0;
                }
                if (ratioY > 0) {
                    ratioY = 0;
                }
                if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
                    ratioX = -(this.zoomImageWidth - zoomWidth);
                }
                if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
                    ratioY = -(this.zoomImageHeight - zoomHeight);
                }
                newBackgroundPosition = ratioX + "px " + ratioY + "px";
                return this.zoomArea.css({
                    backgroundPosition: newBackgroundPosition
                });
            }
        }
    };

    ZoomView.prototype.prepareRemove = function () {
        return this.$newImage.off('load');
    };

    return ZoomView;

})(Backbone.View);

window.LinkedOptions = (function () {
    function LinkedOptions(options) {
        this.options = options;
        this._init();
    }

    LinkedOptions.prototype._init = function () {
        return this._mapVariants(this.options.productJSON);
    };

    LinkedOptions.prototype._getCurrent = function (optionIndex) {
        var key, option1, option2, selector;
        if (this.options.type === 'select') {
            switch (optionIndex) {
                case 0:
                    key = 'root';
                    selector = this.options.$selector.eq(0);
                    break;
                case 1:
                    key = this.options.$selector.eq(0).val();
                    selector = this.options.$selector.eq(1);
                    break;
                case 2:
                    key = (this.options.$selector.eq(0).val()) + " / " + (this.options.$selector.eq(1).val());
                    selector = this.options.$selector.eq(2);
            }
        }
        if (this.options.type === 'radio') {
            switch (optionIndex) {
                case 0:
                    key = 'root';
                    selector = this.options.$selector.filter('[data-option-index=0]').filter(':checked');
                    break;
                case 1:
                    key = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
                    selector = this.options.$selector.filter('[data-option-index=1]').filter(':checked');
                    break;
                case 2:
                    option1 = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
                    option2 = this.options.$selector.filter('[data-option-index=1]').filter(':checked').val();
                    key = option1 + " / " + option2;
                    selector = this.options.$selector.filter('[data-option-index=2]').filter(':checked');
            }
        }
        return {
            key: key,
            selector: selector
        };
    };

    LinkedOptions.prototype._updateOptions = function (optionIndex, optionsMap) {
        var $nextOption, $option, $selector, $selectorOptions, availableOptions,
            initialValue, j, key, l, len, len1, nextSelector, option, ref,
            selector, updateSelected;
        nextSelector = optionIndex + 1;
        updateSelected = false;
        ref = this._getCurrent(optionIndex), key = ref.key, selector = ref.selector;
        availableOptions = optionsMap[key] || [];
        if (this.options.type === 'select') {
            $selector = this.options.$productForm.find(selector);
            initialValue = $selector.val();
            $selectorOptions = $selector.find('option');
            for (j = 0, len = $selectorOptions.length; j < len; j++) {
                option = $selectorOptions[j];
                $option = $(option);
                if (availableOptions.indexOf(option.value) === -1) {
                    if (option.selected) {
                        updateSelected = true;
                    }
                    $option.prop('disabled', true).prop('selected', false);
                } else {
                    $option.prop('disabled', false);
                }
            }
            if (availableOptions.indexOf(initialValue) !== -1) {
                $selector.val(initialValue);
            }
            if (updateSelected) {
                $selectorOptions.filter(':not(:disabled)').eq(0).prop('selected', true);
            }
        }
        if (this.options.type === 'radio') {
            $selector = this.options.$selector.filter("[data-option-index=" + optionIndex + "]");
            for (l = 0, len1 = $selector.length; l < len1; l++) {
                option = $selector[l];
                $option = $(option);
                if (availableOptions.indexOf(option.value) === -1) {
                    if (option.checked) {
                        updateSelected = true;
                    }
                    $option.prop('disabled', true).prop('checked', false);
                } else {
                    $option.prop('disabled', false);
                }
            }
            if (updateSelected) {
                $selector.filter(':not(:disabled)').eq(0).attr('checked', true).trigger('click');
            }
        }
        $selector.trigger('change');
        $nextOption = this.options.$selector.filter("[data-option-index=" + nextSelector + "]");
        if ($nextOption.length !== 0) {
            return this._updateOptions(nextSelector, optionsMap);
        }
    };

    LinkedOptions.prototype._mapVariants = function (product) {
        var j, key, len, optionsMap, ref, variant;
        optionsMap = [];
        optionsMap['root'] = [];
        ref = product.variants;
        for (j = 0, len = ref.length; j < len; j++) {
            variant = ref[j];
            if (variant.available) {
                optionsMap['root'].push(variant.option1);
                optionsMap['root'] = window.ThemeUtils.unique(optionsMap['root']);
                if (product.options.length > 1) {
                    key = variant.option1;
                    optionsMap[key] = optionsMap[key] || [];
                    optionsMap[key].push(variant.option2);
                    optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
                }
                if (product.options.length > 2) {
                    key = variant.option1 + " / " + variant.option2;
                    optionsMap[key] = optionsMap[key] || [];
                    optionsMap[key].push(variant.option3);
                    optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
                }
            }
        }
        this._updateOptions(0, optionsMap);
        return this.options.$selector.on('change', (function (_this) {
            return function (event) {
                var index, nextSelector;
                index = parseInt($(event.currentTarget).attr('data-option-index'), 10);
                nextSelector = index + 1;
                return _this._updateOptions(nextSelector, optionsMap);
            };
        })(this));
    };

    LinkedOptions.prototype.prepareRemove = function () {
        return this.options.$selector.off('change');
    };

    return LinkedOptions;

})();

window.VariantHelper = (function () {
    function VariantHelper(options) {
        var defaultOptions, isShopify;
        defaultOptions = {
            $addToCartButton: null,
            $priceFields: null,
            $productForm: null,
            $productThumbnails: null,
            $selector: null,
            type: 'select',
            productJSON: null,
            productSettings: null
        };
        this.options = window.ThemeUtils.extend(defaultOptions, options);
        this.$body = $(document.body);
        this.linkedOptions = null;
        this.enableHistory = false;
        this.$masterSelect = this.options.$productForm.find("#product-select-" + this.options.formID);
        isShopify = window.Shopify && window.Shopify.preview_host;
        if (window.history && window.history.replaceState && this.options.productSettings.enableHistory && !isShopify) {
            this.enableHistory = true;
        }
        this._init();
        this._bindEvents();
    }

    VariantHelper.prototype._init = function () {
        var j, len, ref, select;
        if (this.options.type === 'select') {
            ref = this.options.$selector;
            for (j = 0, len = ref.length; j < len; j++) {
                select = ref[j];
                this._setSelectLabel(null, $(select));
            }
        }
        if (this.options.productSettings.linkedOptions) {
            return this.linkedOptions = new LinkedOptions(this.options);
        }
    };

    VariantHelper.prototype._bindEvents = function () {
        return this.options.$selector.on('change', (function (_this) {
            return function (event) {
                return _this._variantChange(event);
            };
        })(this));
    };

    VariantHelper.prototype._setSelectLabel = function (event, $target) {
        var selectedOption;
        if (event == null) {
            event = null;
        }
        if ($target == null) {
            $target = false;
        }
        if (!$target) {
            $target = $(event.currentTarget);
        }
        selectedOption = $target.find('option:selected').val();
        return $target.prev('[data-select-text]').find('[data-selected-option]').text(selectedOption);
    };

    VariantHelper.prototype._getCurrentOptions = function () {
        var $inputs, productOptions;
        productOptions = [];
        $inputs = this.options.$selector;
        if (this.options.type === 'radio') {
            $inputs = $inputs.filter(':checked');
        }
        $inputs.each(function (index, element) {
            return productOptions.push($(element).val());
        });
        return productOptions;
    };

    VariantHelper.prototype._getVariantFromOptions = function (productOptions) {
        var foundVariant, isMatch, j, len, ref, variant;
        if (this.options.productJSON.variants == null) {
            return;
        }
        foundVariant = null;
        ref = this.options.productJSON.variants;
        for (j = 0, len = ref.length; j < len; j++) {
            variant = ref[j];
            isMatch = productOptions.every(function (value, index) {
                return variant.options[index] === value;
            });
            if (isMatch) {
                foundVariant = variant;
            }
        }
        return foundVariant;
    };

    VariantHelper.prototype._updateMasterSelect = function (variant) {
        var ref;
        if (variant == null) {
            return;
        }
        if ((ref = this.$masterSelect.find("[data-variant-id=" + variant.id + "]")) != null) {
            ref.prop('selected', true);
        }
        return this.$masterSelect.trigger('change');
    };

    // ANCHOR: ADD TO CART BUTTON LOGIC
    VariantHelper.prototype._updatePrice = function (variant) {
        var $addToCartButton, $priceFields, productSettings, trialInCart, multipleButtons;
        $addToCartButton = this.options.$addToCartButton;
        $priceFields = this.options.$priceFields;
        productSettings = this.options.productSettings;
        trialInCart = $addToCartButton[0].classList.contains('trial-in-cart');


        function disableButton($button){
            $button.each(function(index, value){
                value.value = productSettings.unavailableText;
                value.classList.add('disabled');
                value.setAttribute('disabled', 'disabled');
            })
        }

        function setBackInStock($button){
            let buttonText = document.querySelector("#product-menu-wrapper .product-form-submit-wrap").getAttribute("data-btntext").trim();
            console.log(buttonText)
            $button.each(function(index, value){
                value.value = buttonText;
                value.classList.add('klaviyo-bis-trigger', 'disabled');
                value.setAttribute('type', 'button');
            })
        }

        function enableButton($button){
            $button.each(function(index, value){
                value.value = productSettings.addToCartText;
                value.classList.remove('klaviyo-bis-trigger', 'disabled');
                value.removeAttribute('type');
                value.setAttribute('type', 'submit');
            })
        }

        function addToCartLogic($button){
            if(variant == null) return disableButton($button)

            if(trialInCart) return
        
            if(!variant.available) return setBackInStock($button)

            if(variant.available) return enableButton($button)

            disableButton($button)
        }
        
        return addToCartLogic($addToCartButton)
    };

    VariantHelper.prototype._updateImages = function (variant) {
        var imageId, ref;
        imageId = variant != null ? (ref = variant.featured_image) != null ? ref.id : void 0 : void 0;
        if (imageId == null) {
            return;
        }
        return this.options.$productThumbnails.filter("[data-image-id='" + imageId + "']").trigger('click');
    };

    VariantHelper.prototype._updateHistory = function (variant) {
        var newUrl, variantUrl;
        if (!(this.enableHistory && (variant != null))) {
            return;
        }
        newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant.id];
        variantUrl = newUrl.join('');
        return window.history.replaceState({
            path: variantUrl
        }, '', variantUrl);
    };

    VariantHelper.prototype._variantChange = function (event) {
        var productOptions, variant;
        if (this.options.type === 'select') {
            this._setSelectLabel(event);
        }
        productOptions = this._getCurrentOptions();
        variant = this._getVariantFromOptions(productOptions);
        this._updateMasterSelect(variant);
        this._updatePrice(variant);
        this._updateImages(variant);
        return this._updateHistory(variant);
    };

    VariantHelper.prototype.prepareRemove = function () {
        var ref;
        this.options.$selector.off('change');
        return (ref = this.linkedOptions) != null ? ref.prepareRemove() : void 0;
    };

    return VariantHelper;

})();

window.ProductView = (function (superClass) {
    extend(ProductView, superClass);

    function ProductView() {
        return ProductView.__super__.constructor.apply(this, arguments);
    }

    ProductView.prototype.events = {
        'click .product-thumbnails img': 'updateProductImage',
        'submit .product-form': 'addToCart'
        
    };

    ProductView.prototype.initialize = function (options) {
        this.variantHelpers = null;
        if (options.bindSection) {
            this.sectionBinding();
        }
        return this.render();
    };

    ProductView.prototype.render = function () {
        var $productJSON, $productSettings;
        this.$slideshow = this.$('[data-slideshow-container]');
        this.$productForm = $('[data-product-form]', this.$el);
        this.formID = this.$productForm.attr('data-product-form');
        this.productForm = "product-form-" + this.formID;
        this.$productThumbnails = $('.product-thumbnails img', this.$el);
        this.$addToCartButton = $('.add-to-cart input', this.$el);
        this.$priceArea = $('.product-price', this.$el);
        this.$productMessage = $('[data-product-message]', this.$el);
        $productJSON = $("[data-product-json-" + this.formID + "]", this.$el);
        $productSettings = $("[data-product-settings-" + this.formID + "]", this.$el);
        if (!$productJSON.length) {
            return;
        }
        this.productJSON = JSON.parse($productJSON.text());
        this.productSettings = JSON.parse($productSettings.text());
        this.$variantDropdowns = $("[data-option-select=" + this.formID + "]", this.$el);
        this.$variantRadio = $("[data-option-input=" + this.formID + "]", this.$el);
        this.options = this.productJSON.options;
        this.variants = this.productJSON.variants;
        if (!this.$slideshow.length) {
            this.noImageURL = $('.product-big-image', this.$el).data('no-image-svg');
            if ($('html').hasClass('no-svg')) {
                this.noImageURL = $('.product-big-image', this.$el).data('no-image-png');
            }
        }
        this.processing = false;
        if (this.productSettings.imageZoom && !this.$slideshow.length) {
            this.zoomView = new ZoomView({
                el: $('.product-big-image', this.$el)
            });
        }
        this.setupVariants();
        return Shopify.onError = (function (_this) {
            return function (XMLHttpRequest) {
                return _this.handleErrors(XMLHttpRequest);
            };
        })(this);
    };

    ProductView.prototype.setupVariants = function () {
        var dropdownSettings, radioSettings, variantHelperDefaults;
        variantHelperDefaults = {
            $addToCartButton: this.$addToCartButton,
            $priceFields: this.$priceArea,
            $productForm: this.$productForm,
            $productThumbnails: this.$productThumbnails,
            formID: this.formID,
            productSettings: this.productSettings,
            productJSON: this.productJSON
        };
        if (this.$variantDropdowns.length) {
            dropdownSettings = {
                $selector: this.$variantDropdowns,
                type: 'select'
            };
            dropdownSettings = window.ThemeUtils.extend(variantHelperDefaults, dropdownSettings);
            this.variantHelpers = new VariantHelper(dropdownSettings);
            this.$variantDropdowns.trigger('change');
        }
        if (this.$variantRadio.length) {
            radioSettings = {
                $selector: this.$variantRadio,
                type: 'radio'
            };
            radioSettings = window.ThemeUtils.extend(variantHelperDefaults, radioSettings);
            this.variantHelpers = new VariantHelper(radioSettings);
            return this.$variantRadio.trigger('change');
        }
    };

    ProductView.prototype.sectionBinding = function () {
        this.$el.on('shopify:section:load', (function (_this) {
            return function (event) {
                if (!$(event.target).hasClass('section-product')) {
                    return;
                }
                _this.delegateEvents();
                return _this.render();
            };
        })(this));
        return this.$el.on('shopify:section:unload', (function (_this) {
            return function (event) {
                var ref, ref1, ref2;
                if (!$(event.target).hasClass('section-product')) {
                    return;
                }
                _this.undelegateEvents();
                if ((ref = _this.variantHelpers) != null) {
                    ref.prepareRemove();
                }
                if ((ref1 = _this.zoomView) != null) {
                    ref1.prepareRemove();
                }
                return (ref2 = _this.zoomView) != null ? ref2.remove() : void 0;
            };
        })(this));
    };

    ProductView.prototype.updateProductImage = function (event) {
        var $target;
        this.$productThumbnails.removeClass('active');
        $target = $(event.currentTarget);
        if (!$target.length) {
            return;
        }
        var paginationPointSelector = '.product-slideshow-pagination-point-' + $target[0].dataset.imageNumber;
        var $paginationPoint = $(paginationPointSelector);
        $('.product-slideshow-pagination-point.active').removeClass('active');
        $paginationPoint.addClass('active');
        $target.addClass('active');
        $('.product-big-image img', this.$el).attr({
            'src': $target.data('high-res'),
            'srcset': $target.data('high-res'),
            'alt': $target.attr('alt')
        });
        if (this.productSettings.imageZoom) {
            return $('.product-big-image', this.$el).trigger('prepare-zoom');
        }
    };

    ProductView.prototype.addToCart = function (e) {
        var quantity;

        if ($(window).width() <= GO_TO_CART_WHEN_ADDING_PRODUCT_TRASHOLD) {
            return;
        }
        e.preventDefault();
        if (this.processing) {
            return;
        }

        $("#" + this.productForm).find('.' + OUT_OF_STOCK_CLASSNAME).remove();

        this.processing = true;
        if (Modernizr.cssanimations) {
            this.$('.add-to-cart').addClass('loading');
        } else {
            this.$addToCartButton.val(this.productSettings.processingText);
        }
        quantity = this.$('input[name="quantity"]').val();
        if (quantity === '' || quantity === '0') {
            return setTimeout((function (_this) {
                return function () {
                    $('input[name="quantity"]', _this.$el).addClass('error');
                    _this.$productMessage.removeClass('success').addClass('error').text(_this.productSettings.setQuantityText);
                    $('.add-to-cart', _this.$el).removeClass('loading');
                    return _this.processing = false;
                };
            })(this), 500);
        } else {
            let self = this;
            var e = {
                type: "POST",
                url: "/cart/add.js",
                data: $("#" + self.productForm).serialize(),
                dataType: "json",
                async: false,
                success: function (r) {
                    cart.openCart();
                    self.processing = false
                },
                error: function (r) {
                    if (r.status === 422) {
                        $("#" + self.productForm).append(`
                            <span class="${OUT_OF_STOCK_CLASSNAME}">${r.responseJSON.description}</span>
                        `);
                    }
                    self.processing = false
                }
            };
            $.ajax(e);
        }
    };

    ProductView.prototype.handleErrors = function (errors) {
        var errorDescription, errorMessage, productTitle;
        errorMessage = $.parseJSON(errors.responseText);
        productTitle = this.productJSON.title;
        errorDescription = errorMessage.description;
        if (errorMessage.description.indexOf(productTitle) > -1) {
            errorDescription = errorDescription.replace(productTitle, "<em>" + productTitle + "</em>");
        }
        if (errorMessage.message === 'Cart Error') {
            return setTimeout((function (_this) {
                return function () {
                    _this.$('input[name="quantity"]').removeClass('error');
                    _this.$productMessage.removeClass('success').addClass('error').html(errorDescription);
                    _this.$('.add-to-cart').removeClass('loading added-success').addClass('added-error');
                    if (!Modernizr.cssanimations) {
                        _this.$addToCartButton.val(_this.productSettings.addToCartText);
                    }
                    return _this.processing = false;
                };
            })(this), 1000);
        }
    };

    return ProductView;

})(Backbone.View);

window.Instagram = (function (superClass) {
    extend(Instagram, superClass);

    function Instagram() {
        return Instagram.__super__.constructor.apply(this, arguments);
    }

    Instagram.prototype.initialize = function () {
        this.initializedClass = 'instagram-initialized';
        return this._validate();
    };

    Instagram.prototype._validate = function () {
        var accessToken, isInitialized;
        this.photoContainer = $('[data-instagram-photos]', this.$el);
        this.onBoarding = $('[data-instagram-photo-onboarding]', this.$el);
        accessToken = $('[data-instagram-token]', this.$el).attr('data-instagram-token');
        isInitialized = this.$el.hasClass(this.initializedClass);
        if (this.photoContainer.length) {
            return this._getPhotos(accessToken, isInitialized);
        } else {
            return this._toggleOnBoarding();
        }
    };

    Instagram.prototype._toggleOnBoarding = function () {
        return this.$el.removeClass('module-hidden').removeClass(this.initializedClass);
    };

    Instagram.prototype._getPhotos = function (accessToken, isInitialized) {
        var url;
        if (!accessToken.length) {
            return this._hasError(false);
        }
        if (isInitialized) {
            return;
        }
        url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + accessToken + "&count=4&callback=";
        return $.ajax({
            type: "GET",
            dataType: "jsonp",
            url: url,
            success: (function (_this) {
                return function (response) {
                    var image, j, len, photo, photos, ref, scale;
                    if (response.meta.code === 200) {
                        photos = [];
                        ref = response.data;
                        for (j = 0, len = ref.length; j < len; j++) {
                            photo = ref[j];
                            image = photo.images.standard_resolution;
                            scale = image.width > image.height ? 'y' : 'x';
                            photos.push("<div class=\"instagram-photo animate animate-item animate-slidein\">\n    <a\n        class=\"instagram-link\"\n        target=\"_blank\"\n        href=\"" + photo.link + "\"\n    >\n        <img\n            class=\"\n                instagram-image\n                instagram-image-scale-" + scale + "\n            \"\n            src=\"" + image.url + "\"\n        />\n    </a>\n</div>");
                        }
                        _this.photoContainer.html(photos.join(''));
                        return _this.$el.removeClass('module-hidden').addClass(_this.initializedClass);
                    } else {
                        return _this._hasError(response);
                    }
                };
            })(this),
            error: (function (_this) {
                return function (response) {
                    return _this._hasError(response);
                };
            })(this)
        });
    };

    Instagram.prototype._hasError = function (response) {
        this.$el.addClass('module-hidden').removeClass(this.initializedClass);
        this.photoContainer.html();
        if (response) {
            return console.log("Instagram error: " + response.meta.error_message);
        }
    };

    Instagram.prototype.update = function () {
        return this._validate();
    };

    return Instagram;

})(Backbone.View);


/*********************************************************************
 * @license
 *  #### Twitter Post Fetcher v17.1.0 ####
 *  Coded by Jason Mayes 2015. A present to all the developers out there.
 *  www.jasonmayes.com
 *  Please keep this disclaimer with my code if you use it. Thanks. :-)
 *  Got feedback or questions, ask here:
 *  http://www.jasonmayes.com/projects/twitterApi/
 *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
 *  Updates will be posted to this site.
 *********************************************************************/
!function (e, t) {
    "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? module.exports = t() : t()
}(0, function () {
    var _ = "", y = 20, T = !0, k = [], C = !1, x = !0, E = !0, N = null,
        A = !0, I = !0, B = null, L = !0, M = !1, i = !1, R = !1, H = !0,
        a = "en", j = !0, q = !1, n = null;

    function P(e) {
        return e.replace(/<b[^>]*>(.*?)<\/b>/gi, function (e, t) {
            return t
        }).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi, "")
    }

    function S(e) {
        for (var t = e.getElementsByTagName("a"), i = t.length - 1; 0 <= i; i--) t[i].setAttribute("target", "_blank")
    }

    function U(e, t) {
        for (var i = [], a = new RegExp("(^| )" + t + "( |$)"), n = e.getElementsByTagName("*"), s = 0, l = n.length; s < l; s++) a.test(n[s].className) && i.push(n[s]);
        return i
    }

    function F(e) {
        if (void 0 !== e && 0 <= e.innerHTML.indexOf("data-image")) {
            var t = e.innerHTML.split('data-image="')[1].split('"')[0];
            return decodeURIComponent(t) + ".jpg"
        }
    }

    var O = {
        fetch: function (e) {
            if (void 0 === e.maxTweets && (e.maxTweets = 20), void 0 === e.enableLinks && (e.enableLinks = !0), void 0 === e.showUser && (e.showUser = !0), void 0 === e.showTime && (e.showTime = !0), void 0 === e.dateFunction && (e.dateFunction = "default"), void 0 === e.showRetweet && (e.showRetweet = !0), void 0 === e.customCallback && (e.customCallback = null), void 0 === e.showInteraction && (e.showInteraction = !0), void 0 === e.showImages && (e.showImages = !1), void 0 === e.showReplies && (e.showReplies = !1), void 0 === e.useEmoji && (e.useEmoji = !1), void 0 === e.linksInNewWindow && (e.linksInNewWindow = !0), void 0 === e.showPermalinks && (e.showPermalinks = !0), void 0 === e.dataOnly && (e.dataOnly = !1), C) k.push(e); else {
                C = !0, _ = e.domId, y = e.maxTweets, T = e.enableLinks, E = e.showUser, x = e.showTime, I = e.showRetweet, N = e.dateFunction, B = e.customCallback, L = e.showInteraction, M = e.showImages, i = e.showReplies, R = e.useEmoji, H = e.linksInNewWindow, j = e.showPermalinks, q = e.dataOnly;
                var t = document.getElementsByTagName("head")[0];
                null !== n && t.removeChild(n), (n = document.createElement("script")).type = "text/javascript", void 0 !== e.list ? n.src = "https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug=" + e.list.listSlug + "&screen_name=" + e.list.screenName + "&suppress_response_codes=true&lang=" + (e.lang || a) + "&rnd=" + Math.random() : void 0 !== e.profile ? n.src = "https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name=" + e.profile.screenName + "&with_replies=" + i + "&suppress_response_codes=true&lang=" + (e.lang || a) + "&rnd=" + Math.random() : void 0 !== e.likes ? n.src = "https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name=" + e.likes.screenName + "&suppress_response_codes=true&lang=" + (e.lang || a) + "&rnd=" + Math.random() : n.src = "https://cdn.syndication.twimg.com/widgets/timelines/" + e.id + "?&lang=" + (e.lang || a) + "&callback=__twttrf.callback&suppress_response_codes=true&rnd=" + Math.random(), t.appendChild(n)
            }
        }, callback: function (e) {
            if (void 0 === e || void 0 === e.body) return C = !1, void (0 < k.length && (O.fetch(k[0]), k.splice(0, 1)));
            R || (e.body = e.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g, "")), M || (e.body = e.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g, "")), E || (e.body = e.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g, ""));
            var t = document.createElement("div");

            function i(e) {
                var t = e.getElementsByTagName("img")[0];
                return t && t.length && (t.src = t.getAttribute("data-src-2x")), e
            }

            t.innerHTML = e.body, void 0 === t.getElementsByClassName && (A = !1);
            var a = [], n = [], s = [], l = [], r = [], o = [], c = [], d = 0;
            if (A) for (var m = t.getElementsByClassName("timeline-Tweet"); d < m.length;) 0 < m[d].getElementsByClassName("timeline-Tweet-retweetCredit").length ? r.push(!0) : r.push(!1), (!r[d] || r[d] && I) && (a.push(m[d].getElementsByClassName("timeline-Tweet-text")[0]), o.push(m[d].getAttribute("data-tweet-id")), E && n.push(i(m[d].getElementsByClassName("timeline-Tweet-author")[0])), s.push(m[d].getElementsByClassName("dt-updated")[0]), c.push(m[d].getElementsByClassName("timeline-Tweet-timestamp")[0]), void 0 !== m[d].getElementsByClassName("timeline-Tweet-media")[0] ? l.push(m[d].getElementsByClassName("timeline-Tweet-media")[0]) : l.push(void 0)), d++; else for (m = U(t, "timeline-Tweet"); d < m.length;) 0 < U(m[d], "timeline-Tweet-retweetCredit").length ? r.push(!0) : r.push(!1), (!r[d] || r[d] && I) && (a.push(U(m[d], "timeline-Tweet-text")[0]), o.push(m[d].getAttribute("data-tweet-id")), E && n.push(i(U(m[d], "timeline-Tweet-author")[0])), s.push(U(m[d], "dt-updated")[0]), c.push(U(m[d], "timeline-Tweet-timestamp")[0]), void 0 !== U(m[d], "timeline-Tweet-media")[0] ? l.push(U(m[d], "timeline-Tweet-media")[0]) : l.push(void 0)), d++;
            a.length > y && (a.splice(y, a.length - y), n.splice(y, n.length - y), s.splice(y, s.length - y), r.splice(y, r.length - y), l.splice(y, l.length - y), c.splice(y, c.length - y));
            var p = [], u = (d = a.length, 0);
            if (q) for (; u < d;) p.push({
                tweet: a[u].innerHTML,
                author: n[u] ? n[u].innerHTML : "Unknown Author",
                author_data: {
                    profile_url: n[u] ? n[u].querySelector('[data-scribe="element:user_link"]').href : null,
                    profile_image: n[u] ? n[u].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-1x") : null,
                    profile_image_2x: n[u] ? n[u].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-2x") : null,
                    screen_name: n[u] ? n[u].querySelector('[data-scribe="element:screen_name"]').title : null,
                    name: n[u] ? n[u].querySelector('[data-scribe="element:name"]').title : null
                },
                time: s[u].textContent,
                timestamp: s[u].getAttribute("datetime").replace("+0000", "Z").replace(/([\+\-])(\d\d)(\d\d)/, "$1$2:$3"),
                image: F(l[u]),
                rt: r[u],
                tid: o[u],
                permalinkURL: void 0 === c[u] ? "" : c[u].href
            }), u++; else for (; u < d;) {
                if ("string" != typeof N) {
                    var h = s[u].getAttribute("datetime"),
                        g = new Date(s[u].getAttribute("datetime").replace(/-/g, "/").replace("T", " ").split("+")[0]),
                        w = N(g, h);
                    if (s[u].setAttribute("aria-label", w), a[u].textContent) if (A) s[u].textContent = w; else {
                        var f = document.createElement("p"),
                            v = document.createTextNode(w);
                        f.appendChild(v), f.setAttribute("aria-label", w), s[u] = f
                    } else s[u].textContent = w
                }
                var b = "";
                T ? (H && (S(a[u]), E && S(n[u])), E && (b += '<div class="user">' + P(n[u].innerHTML) + "</div>"), b += '<p class="tweet">' + P(a[u].innerHTML) + "</p>", x && (b += j ? '<p class="timePosted"><a href="' + c[u] + '">' + s[u].getAttribute("aria-label") + "</a></p>" : '<p class="timePosted">' + s[u].getAttribute("aria-label") + "</p>")) : (a[u].textContent, E && (b += '<p class="user">' + n[u].textContent + "</p>"), b += '<p class="tweet">' + a[u].textContent + "</p>", x && (b += '<p class="timePosted">' + s[u].textContent + "</p>")), L && (b += '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' + o[u] + '" class="twitter_reply_icon"' + (H ? ' target="_blank">' : ">") + 'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' + o[u] + '" class="twitter_retweet_icon"' + (H ? ' target="_blank">' : ">") + 'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' + o[u] + '" class="twitter_fav_icon"' + (H ? ' target="_blank">' : ">") + "Favorite</a></p>"), M && void 0 !== l[u] && void 0 !== F(l[u]) && (b += '<div class="media"><img src="' + F(l[u]) + '" alt="Image from tweet" /></div>'), M ? p.push(b) : !M && a[u].textContent.length && p.push(b), u++
            }
            !function (e) {
                if (null === B) {
                    for (var t = e.length, i = 0, a = document.getElementById(_), n = "<ul>"; i < t;) n += "<li>" + e[i] + "</li>", i++;
                    n += "</ul>", a.innerHTML = n
                } else B(e)
            }(p), C = !1, 0 < k.length && (O.fetch(k[0]), k.splice(0, 1))
        }
    };
    return window.__twttrf = O, window.twitterFetcher = O
});
;

Twitter = (function (superClass) {
    extend(Twitter, superClass);

    function Twitter() {
        return Twitter.__super__.constructor.apply(this, arguments);
    }

    Twitter.prototype.initialize = function () {
        this.initializedClass = 'twitter-initialized';
        return this._validate();
    };

    Twitter.prototype._validate = function () {
        var isInitialized, retweets, username;
        this.tweetContainer = $('[data-twitter-tweets]', this.$el);
        username = $('[data-twitter-username]', this.$el).attr('data-twitter-username');
        retweets = $('[data-show-retweets]', this.$el).length;
        isInitialized = this.$el.hasClass(this.initializedClass);
        if (this.tweetContainer.length) {
            if (!isInitialized) {
                return this._fetchTweets(username, retweets);
            }
        } else {
            return this._toggleOnBoarding();
        }
    };

    Twitter.prototype._toggleOnBoarding = function () {
        return this.$el.removeClass('module-hidden').removeClass(this.initializedClass);
    };

    Twitter.prototype._fetchTweets = function (username, retweets) {
        var config;
        config = {
            'profile': {
                'screenName': username
            },
            'maxTweets': 1,
            'enableLinks': true,
            'showUser': true,
            'showTime': true,
            'showRetweet': retweets,
            'customCallback': (function (_this) {
                return function (tweets) {
                    return _this.renderTweets(tweets);
                };
            })(this),
            'showInteraction': false,
            'useEmoji': true
        };
        return twitterFetcher.fetch(config);
    };

    Twitter.prototype.renderTweets = function (tweets) {
        var $tweet;
        if (tweets.length) {
            $tweet = $(tweets[0]);
            this.tweetContainer.html($tweet[1].innerHTML);
            return this.$el.removeClass('module-hidden').addClass(this.initializedClass);
        } else {
            this.tweetContainer.html();
            this.$el.addClass('module-hidden').removeClass(this.initializedClass);
            return console.log("No tweets to display. Most probable cause is an incorrectly entered username.");
        }
    };

    Twitter.prototype.update = function ($el) {
        this.$el = $el;
        return this._validate();
    };

    return Twitter;

})(Backbone.View);

window.HomeView = (function (superClass) {
    extend(HomeView, superClass);

    function HomeView() {
        return HomeView.__super__.constructor.apply(this, arguments);
    }

    HomeView.prototype.initialize = function () {
        this.sectionBinding();
        this.classHoist();
        return $(document).on('shopify:section:select.home-page', (function (_this) {
            return function () {
                return _this.classHoist();
            };
        })(this)).on('shopify:section:load.home-page', (function (_this) {
            return function () {
                return _this.classHoist();
            };
        })(this)).on('shopify:section:deselect.home-page', (function (_this) {
            return function () {
                return _this.classHoist();
            };
        })(this));
    };

    HomeView.prototype.sectionBinding = function () {
        this.sections = new ThemeEditor();
        this.sections.register('featured-product', this.featuredProduct(this.sections));
        this.sections.register('instagram', this.instagram(this.sections));
        this.sections.register('twitter', this.twitter(this.sections));
        this.sections.register('image-with-text', this.imageWithText(this.sections));
        return this.sections.register('image-with-text-overlay', this.imageWithText(this.sections));
    };

    HomeView.prototype.featuredProduct = function (sections) {
        return {
            instances: {},
            init: function (instance) {
                return this.instances[instance.sectionId] = new ProductView({
                    el: instance.$container
                });
            },
            onSectionLoad: function (event) {
                var instance;
                instance = sections.getInstance(event);
                if (this.instances[instance.sectionId] == null) {
                    return this.init(instance);
                }
            },
            onSectionSelect: function (event) {
                var instance, ref;
                instance = sections.getInstance(event);
                return (ref = this.instances[instance.sectionId]) != null ? ref.setElement(instance.$container) : void 0;
            },
            onSectionUnload: function (event) {
                var instance, ref;
                instance = sections.getInstance(event);
                if ((ref = this.instances[instance.sectionId]) != null) {
                    ref.remove();
                }
                return delete this.instances[instance.sectionId];
            }
        };
    };

    HomeView.prototype.imageWithText = function (sections) {
        return {
            instances: {},
            init: function (instance) {
                return this.instances[instance.sectionId] = new ImagesWithText({
                    el: instance.$container
                });
            },
            onSectionLoad: function (event) {
                var instance;
                instance = sections.getInstance(event);
                if (this.instances[instance.sectionId] == null) {
                    return this.init(instance);
                } else {
                    return this.instances[instance.sectionId].centerText(instance.$container);
                }
            },
            onSectionSelect: function (event) {
                return this.onSectionLoad(event);
            },
            onSectionUnload: function (event) {
                var instance;
                instance = sections.getInstance(event);
                this.instances[instance.sectionId].prepareRemove();
                this.instances[instance.sectionId].remove();
                return delete this.instances[instance.sectionId];
            }
        };
    };

    HomeView.prototype.instagram = function (sections) {
        return {
            instances: {},
            init: function (instance) {
                return this.instances[instance.sectionId] = new Instagram({
                    el: instance.$container
                });
            },
            onSectionLoad: function (event) {
                var instance;
                instance = sections.getInstance(event);
                if (this.instances[instance.sectionId] == null) {
                    return this.init(instance);
                }
            },
            onSectionSelect: function (event) {
                var instance, ref, ref1;
                instance = sections.getInstance(event);
                if ((ref = this.instances[instance.sectionId]) != null) {
                    ref.$el = instance.$container;
                }
                return (ref1 = this.instances[instance.sectionId]) != null ? ref1.update() : void 0;
            },
            onSectionDeselect: function (event) {
                return this.onSectionSelect(event);
            },
            onSectionUnload: function (event) {
                var instance, ref;
                instance = sections.getInstance(event);
                if ((ref = this.instances[instance.sectionId]) != null) {
                    ref.remove();
                }
                return delete this.instances[instance.sectionId];
            }
        };
    };

    HomeView.prototype.twitter = function (sections) {
        return {
            instances: {},
            init: function (instance) {
                return this.instances[instance.sectionId] = new Twitter({
                    el: instance.$container
                });
            },
            onSectionLoad: function (event) {
                var instance;
                instance = sections.getInstance(event);
                if (this.instances[instance.sectionId] == null) {
                    return this.init(instance);
                }
            },
            onSectionDeselect: function (event) {
                var instance, ref, ref1;
                instance = sections.getInstance(event);
                if ((ref = this.instances[instance.sectionId]) != null) {
                    ref.$el = instance.$container;
                }
                return (ref1 = this.instances[instance.sectionId]) != null ? ref1.update() : void 0;
            },
            onSectionUnload: function (event) {
                var instance, ref;
                instance = sections.getInstance(event);
                if ((ref = this.instances[instance.sectionId]) != null) {
                    ref.remove();
                }
                return delete this.instances[instance.sectionId];
            }
        };
    };

    HomeView.prototype.getStyle = function ($el) {
        var styleSetting;
        styleSetting = $el.attr('class').match(/(default|contrast|accent)-style/);
        if (styleSetting != null) {
            return styleSetting[0];
        } else {
            return false;
        }
    };

    HomeView.prototype.classHoist = function () {
        $('.module-container').each((function (_this) {
            return function (index, section) {
                var $parent, $section, parentStyle, sectionStyle;
                $section = $(section);
                $parent = $section.parent();
                sectionStyle = _this.getStyle($section);
                parentStyle = _this.getStyle($parent);
                if (!sectionStyle) {
                    return;
                }
                if (parentStyle) {
                    $parent.removeClass(parentStyle);
                }
                return $parent.addClass(sectionStyle);
            };
        })(this));
        return true;
    };

    HomeView.prototype.render = function () {
    };

    return HomeView;

})(Backbone.View);

window.ListCollectionsView = (function (superClass) {
    extend(ListCollectionsView, superClass);

    function ListCollectionsView() {
        return ListCollectionsView.__super__.constructor.apply(this, arguments);
    }

    ListCollectionsView.prototype.events = {};

    ListCollectionsView.prototype.initialize = function () {
        var collection, collectionDetails, collections, j, len, results;
        if ($('html').hasClass('lt-ie9')) {
            collections = this.$('.collection-list-item');
            results = [];
            for (j = 0, len = collections.length; j < len; j++) {
                collection = collections[j];
                collectionDetails = $(collection).find('.collection-details');
                results.push(this.verticallyAlignText(collectionDetails));
            }
            return results;
        }
    };

    ListCollectionsView.prototype.verticallyAlignText = function (collectionDetails) {
        var textHeight;
        textHeight = collectionDetails.height();
        return collectionDetails.css({
            marginTop: -(textHeight / 2)
        });
    };

    ListCollectionsView.prototype.render = function () {
    };

    return ListCollectionsView;

})(Backbone.View);

window.AddressesView = (function (superClass) {
    extend(AddressesView, superClass);

    function AddressesView() {
        return AddressesView.__super__.constructor.apply(this, arguments);
    }

    AddressesView.prototype.events = {
        'click .delete-address': 'deleteAddress',
        'click .edit-address': 'editAddress',
        'click .cancel-edit': 'cancelEditing',
        'click .toggle-new-address': 'toggleNewAddress',
        'change .select-wrapper select': 'updateSelectedText'
    };

    AddressesView.prototype.initialize = function () {
        return this.prepareAddresses();
    };

    AddressesView.prototype.prepareAddresses = function () {
        var address, addressID, addresses, j, l, len, len1, results, select,
            selectableOptions;
        new Shopify.CountryProvinceSelector('address-country', 'address-province', {
            hideElement: 'address-province-container'
        });
        addresses = this.$('.customer-address');
        if (addresses.length) {
            for (j = 0, len = addresses.length; j < len; j++) {
                address = addresses[j];
                addressID = $(address).data('address-id');
                new Shopify.CountryProvinceSelector("address-country-" + addressID, "address-province-" + addressID, {
                    hideElement: "address-province-container-" + addressID
                });
            }
        }
        selectableOptions = this.$('.select-wrapper select');
        results = [];
        for (l = 0, len1 = selectableOptions.length; l < len1; l++) {
            select = selectableOptions[l];
            results.push(this.updateSelectedText(null, select));
        }
        return results;
    };

    AddressesView.prototype.updateSelectedText = function (e, select) {
        var addressID, selectedValue;
        select = e ? $(e.target) : $(select);
        selectedValue = select.find('option:selected').text();
        if (selectedValue !== '') {
            select.prev('.selected-text').text(selectedValue);
        }
        if (select.attr('name') === 'address[country]') {
            addressID = $(select).attr('id').split('address-country-')[1];
            addressID = addressID ? "#address-province-" + addressID : '.new-address-province';
            return this.updateSelectedText(null, $(addressID));
        }
    };

    AddressesView.prototype.deleteAddress = function (e) {
        var addressID;
        addressID = $(e.target).parents('[data-address-id]').data('address-id');
        return Shopify.CustomerAddress.destroy(addressID);
    };

    AddressesView.prototype.editAddress = function (e) {
        var addressID;
        addressID = $(e.target).parents('[data-address-id]').data('address-id');
        $(".customer-address[data-address-id='" + addressID + "']").addClass('editing');
        return $(".customer-address-edit-form[data-address-id='" + addressID + "']").addClass('show');
    };

    AddressesView.prototype.cancelEditing = function (e) {
        var addressID;
        addressID = $(e.target).parents('[data-address-id]').data('address-id');
        $(".customer-address[data-address-id='" + addressID + "']").removeClass('editing');
        return $(".customer-address-edit-form[data-address-id='" + addressID + "']").removeClass('show');
    };

    AddressesView.prototype.toggleNewAddress = function () {
        this.$('.add-new-address').toggle();
        return this.$('.customer-new-address').toggleClass('show');
    };

    AddressesView.prototype.render = function () {
    };

    return AddressesView;

})(Backbone.View);

window.RTEView = (function (superClass) {
    extend(RTEView, superClass);

    function RTEView() {
        return RTEView.__super__.constructor.apply(this, arguments);
    }

    RTEView.prototype.events = {
        'click .tabs li': 'switchTabs',
        'change .select-wrapper select': 'updateOption'
    };

    RTEView.prototype.initialize = function () {
        var j, len, select, selects;
        this.setupTabs();
        selects = this.$el.find('select');
        for (j = 0, len = selects.length; j < len; j++) {
            select = selects[j];
            if (!$(select).parent('.select-wrapper').length) {
                $(select).wrap('<div class="select-wrapper" />').parent().prepend('<span class="selected-text"></span>');
            }
            this.updateOption(null, select);
        }
        this.$el.fitVids();
        this.mobilifyTables();
        return $(window).resize((function (_this) {
            return function () {
                return _this.mobilifyTables();
            };
        })(this));
    };

    RTEView.prototype.switchTabs = function (e) {
        var position, tab;
        e.preventDefault();
        tab = $(e.currentTarget);
        position = tab.index();
        this.tabs.removeClass('active');
        this.tabsContent.removeClass('active');
        tab.addClass('active');
        return this.tabsContent.eq(position).addClass('active');
    };

    RTEView.prototype.setupTabs = function () {
        this.tabs = this.$('.tabs > li');
        this.tabsContent = this.$('.tabs-content > li');
        this.tabs.first().addClass('active');
        return this.tabsContent.first().addClass('active');
    };

    RTEView.prototype.updateOption = function (e, selector) {
        var newOption, select;
        select = e ? $(e.target) : $(selector);
        newOption = select.find('option:selected').text();
        return select.siblings('.selected-text').text(newOption);
    };

    RTEView.prototype.mobilifyTables = function () {
        return this.$el.find('table').mobileTable();
    };

    return RTEView;

})(Backbone.View);

window.CurrencyView = (function (superClass) {
    extend(CurrencyView, superClass);

    function CurrencyView() {
        return CurrencyView.__super__.constructor.apply(this, arguments);
    }

    CurrencyView.prototype.events = {
        'change [data-currency-converter]': 'convertAll'
    };

    CurrencyView.prototype.convertAll = function (event) {
        CurrencyConverter.setCurrency(event.currentTarget.value);
        return $('.selected-currency', this.$el).text(event.currentTarget.value);
    };

    return CurrencyView;

})(Backbone.View);

window.ThemeEditor = (function (superClass) {
    extend(ThemeEditor, superClass);

    function ThemeEditor() {
        return ThemeEditor.__super__.constructor.apply(this, arguments);
    }

    ThemeEditor.prototype.initialize = function () {
        this.instanceHandlers = {};
        this.instances = {};
        return $(document).on('shopify:section:load', (function (_this) {
            return function (event) {
                return _this._onSectionLoad(event);
            };
        })(this)).on('shopify:section:unload', (function (_this) {
            return function (event) {
                return _this._onSectionUnload(event);
            };
        })(this)).on('shopify:section:select', (function (_this) {
            return function (event) {
                return _this._onSectionSelect(event);
            };
        })(this)).on('shopify:section:deselect', (function (_this) {
            return function (event) {
                return _this._onSectionDeselect(event);
            };
        })(this)).on('shopify:block:select', (function (_this) {
            return function (event) {
                return _this._onBlockSelect(event);
            };
        })(this)).on('shopify:block:deselect', (function (_this) {
            return function (event) {
                return _this._onBlockDeselect(event);
            };
        })(this));
    };

    ThemeEditor.prototype._findInstance = function (event) {
        var $container, instance;
        instance = this.instances[event.originalEvent.detail.sectionId];
        if (instance != null) {
            return instance;
        } else {
            $container = $('[data-section-id]', event.target);
            return this._createInstance($container);
        }
    };

    ThemeEditor.prototype._createInstance = function ($container, instanceHandler) {
        var data, el, instance, sectionId, sectionType;
        el = $container.parent().get(0);
        data = this._loadData(el);
        sectionType = $container.attr('data-section-type');
        sectionId = $container.attr('data-section-id');
        if (sectionType == null) {
            return;
        }
        instanceHandler = instanceHandler || this.instanceHandlers[sectionType];
        instance = {
            el: el,
            data: data,
            instanceHandler: instanceHandler,
            $container: $container,
            sectionId: sectionId
        };
        this.instances[sectionId] = instance;
        return instance;
    };

    ThemeEditor.prototype._loadData = function (el) {
        var data, dataEl, error;
        dataEl = el.querySelector('[data-section-data]');
        if (!dataEl) {
            return {};
        }
        data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
        try {
            return JSON.parse(data);
        } catch (error1) {
            error = error1;
            console.warn("Sections: invalid section data found. " + error.message);
            return {};
        }
    };


    /*
      Action: A section has been added or re-rendered.
      Expected: Re-execute any JavaScript needed for the section to work and
          display properly (as if the page had just been loaded).
   */

    ThemeEditor.prototype._onSectionLoad = function (event) {
        var $container, ref, ref1;
        $container = $('[data-section-id]', event.target);
        if (!$container.length) {
            return;
        }
        return (ref = this._createInstance($container)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionLoad === "function" ? ref1.onSectionLoad(event) : void 0 : void 0 : void 0;
    };


    /*
      Action: A section has been deleted or is being re-rendered.
      Expected: Clean up any event listeners, variables, etc., so that
          nothing breaks when the page is interacted with and no memory leaks occur.
   */

    ThemeEditor.prototype._onSectionUnload = function (event) {
        var instance, ref;
        instance = this._findInstance(event);
        if (instance != null) {
            if ((ref = instance.instanceHandler) != null) {
                if (typeof ref.onSectionUnload === "function") {
                    ref.onSectionUnload(event);
                }
            }
        }
        if (instance) {
            return delete this.instances[instance.sectionId];
        }
    };


    /*
      Action: User has selected the section in the sidebar.
      Expected: Make sure the section is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Could be used to pause a slideshow
   */

    ThemeEditor.prototype._onSectionSelect = function (event) {
        var ref, ref1;
        return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionSelect === "function" ? ref1.onSectionSelect(event) : void 0 : void 0 : void 0;
    };


    /*
      Action: User has deselected the section in the sidebar.
      Expected: (None)
      Example: Could be used to restart slideshows that are no longer being interacted with.
   */

    ThemeEditor.prototype._onSectionDeselect = function (event) {
        var ref, ref1;
        return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionDeselect === "function" ? ref1.onSectionDeselect(event) : void 0 : void 0 : void 0;
    };


    /*
      Action: User has selected the block in the sidebar.
      Expected: Make sure the block is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Can be used to to trigger a slideshow to bring a slide/block into view
   */

    ThemeEditor.prototype._onBlockSelect = function (event) {
        var ref, ref1;
        return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockSelect === "function" ? ref1.onBlockSelect(event) : void 0 : void 0 : void 0;
    };


    /*
      Action: User has deselected the block in the sidebar.
      Expected: (None)
      Example: Resume a slideshow
   */

    ThemeEditor.prototype._onBlockDeselect = function (event) {
        var ref, ref1;
        return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockDeselect === "function" ? ref1.onBlockDeselect(event) : void 0 : void 0 : void 0;
    };


    /*
      Auto initialisation of a section for the store front
   */

    ThemeEditor.prototype._sectionInit = function (instance) {
        var ref;
        return instance != null ? (ref = instance.instanceHandler) != null ? typeof ref.init === "function" ? ref.init(instance) : void 0 : void 0 : void 0;
    };


    /*
      Registration of a section
          - Takes a string parameter as the first argument which
            matches to `[data-section-type]`

       * Example
          @sections = new Sections()
          @sections.register('some-section-type', @someSectionClass)
   */

    ThemeEditor.prototype.register = function (type, instanceHandler) {

        /*
        Storage of a instanceHandler based on the sectionType allows _onSectionLoad
           to connect a new section to it's registered instanceHandler
     */
        this.instanceHandlers[type] = instanceHandler;
        return $("[data-section-type=" + type + "]").each((function (_this) {
            return function (index, container) {
                var $container;
                $container = $(container);
                return _this._sectionInit(_this._createInstance($container, instanceHandler));
            };
        })(this));
    };


    /*
      Public method to retrieve information on an instance based on the
      bubbled `event`
   */

    ThemeEditor.prototype.getInstance = function (event) {
        return this._findInstance(event);
    };

    return ThemeEditor;

})(Backbone.View);

window.SlideshowView = (function (superClass) {
    extend(SlideshowView, superClass);

    function SlideshowView() {
        return SlideshowView.__super__.constructor.apply(this, arguments);
    }

    SlideshowView.prototype.initialize = function () {
        this.$window = $(window);
        this.$document = $(document.body);
        this.mainHeader = $('[data-main-header]');
        this.headerLogo = $('[data-header-logo]', this.mainHeader);
        this.slideShow = null;
        this.$viewport = null;
        this.slideContainer = '[data-slideshow-container]';
        this.$slideContainer = $(this.slideContainer);
        this.slideSelector = '[data-slide]';
        this.enableNavigation = $(this.slideSelector).length > 1;
        this.$paginationContainer = $('[data-slideshow-pagination]');
        this.paginationItem = '[data-pagination-slide]';
        this.hasThumbnailPagination = this.$paginationContainer.length !== 0;
        this.slideShowDuration = parseInt(this.$el.attr('data-autoplay'), 10);
        this.sectionStyle = this.$el.attr('data-section-style') != null ? this.$el.attr('data-section-style') : false;
        this.setupHeader(this.$el);
        return this._init();
    };

    SlideshowView.prototype._init = function () {
        var flickityOptions;
        flickityOptions = {
            autoPlay: this.enableNavigation ? this.slideShowDuration : 0,
            cellSelector: this.slideSelector,
            cellAlign: 'center',
            draggable: this.enableNavigation,
            freeScroll: false,
            pageDots: !this.hasThumbnailPagination && this.enableNavigation,
            prevNextButtons: this.enableNavigation,
            setGallerySize: false,
            wrapAround: true
        };
        this.slideShow = new Flickity(this.slideContainer, flickityOptions);
        this.$slideShow = $(this.slideShow.element);
        this.$viewport = this.$slideShow.find('.flickity-viewport');
        this._bindSlideshow();
        if (this.sectionStyle) {
            this._sectionStyle(true);
        }
        if (this.hasThumbnailPagination) {
            this._bindPagination();
            return this._updatePagination(this.slideShow.selectedIndex);
        }
    };

    SlideshowView.prototype._bindSlideshow = function () {

        /*
        On slide change, find the new height of the slide and set it as the
        height of the slider

        TODO: On upgrade to Flickity 2, change this to `select`
     */
        this.slideShow.on('cellSelect', (function (_this) {
            return function () {
                _this.$slideShow.trigger('heightUpdate');
                return _this._updatePagination(_this.slideShow.selectedIndex);
            };
        })(this));
        this.$slideShow.on('heightUpdate', (function (_this) {
            return function () {
                return _this._setSlideHeight();
            };
        })(this));
        this.$slideShow.trigger('heightUpdate');
        return this.$window.on('resize.slideshow', window.ThemeUtils.debounce((function (_this) {
            return function () {
                return _this.$slideShow.trigger('heightUpdate');
            };
        })(this), 10));
    };

    SlideshowView.prototype._bindPagination = function () {
        return this.$paginationContainer.on('click', this.paginationItem, (function (_this) {
            return function (event) {
                var $target, slideTarget;
                event.preventDefault();
                $target = $(event.currentTarget);
                slideTarget = parseInt($target.attr('data-pagination-slide'), 10) - 1;
                _this.slideShow.select(slideTarget);
                return _this._updatePagination(slideTarget, $target);
            };
        })(this));
    };

    SlideshowView.prototype._updatePagination = function (slideTarget, $target) {
        if ($target == null) {
            $target = null;
        }
        if (typeof target === "undefined" || target === null) {
            $target = this.$paginationContainer.find(this.paginationItem).eq(slideTarget);
        }
        return $target.addClass('is-selected').siblings('.is-selected').removeClass('is-selected');
    };

    SlideshowView.prototype._setSlideHeight = function (minHeight) {
        var $element, $elementImage, $elementText, $pagination, $promotionBar,
            height, heights, imageHeight, isDesktop, isOpeningScreen,
            textHeight;
        if (minHeight == null) {
            minHeight = null;
        }
        isOpeningScreen = this.$el.hasClass('opening-screen');
        isDesktop = window.ThemeUtils.windowWidth() > 720;
        $element = $(this.slideShow.selectedElement);
        $elementImage = $element.find('.slide-image');
        $elementText = $element.find('.slide-text');
        $pagination = this.$el.find('.flickity-prev-next-button');
        if (isDesktop) {
            $pagination.height('');
        }
        if (isDesktop && isOpeningScreen) {
            $promotionBar = $('[data-promotion-bar]');
            if (!$promotionBar.length) {
                return;
            }
            height = window.innerHeight - $promotionBar.outerHeight();
            if (this.hasThumbnailPagination) {
                height = height - this.$paginationContainer.outerHeight(true);
            }
            $element.height(height);
            this.$viewport.height(height);
            this.$slideContainer.height(height);
            return this.$el.height(height);
        } else {
            heights = [];
            heights.push(minHeight);
            heights.push($element.height());
            imageHeight = $elementImage.outerHeight(true);
            textHeight = $elementText.length ? $elementText.outerHeight(true) : 0;
            if (isDesktop) {
                heights.push(imageHeight);
                heights.push(textHeight);
            }
            height = Math.max.apply(null, heights);
            if ((imageHeight <= textHeight || $('.full-slideshow-wrapper').hasClass('content-width')) && isDesktop) {
                height = imageHeight;
            }
            if (isOpeningScreen) {
                this.$slideContainer.height('');
                this.$el.height('');
            }
            if (isDesktop) {
                $element.height(height);
            } else {
                $element.height('');
                $pagination.height(textHeight ? imageHeight : height);
            }
            return this.$viewport.height(height);
        }
    };

    SlideshowView.prototype._sectionStyle = function (force) {
        var $section;
        $section = this.$el.parent('.shopify-section');
        return $section.toggleClass(this.sectionStyle, force);
    };


    /*
      Public method for SlideshowSection
          - Pauses the slideshow
          - Brings the current slide into view
   */

    SlideshowView.prototype.lockSlide = function (event) {
        var index;
        this.slideShow.pausePlayer();
        this.$el.toggleClass('slider-locked', true);
        index = parseInt($(event.target).attr('data-slide'), 10) - 1;
        return this.slideShow.select(index, false, true);
    };


    /*
      Public method for SlideshowSection
          - Unpause the slideshow
   */

    SlideshowView.prototype.unlockSlide = function () {
        this.slideShow.unpausePlayer();
        return this.$el.toggleClass('slider-locked', false);
    };


    /*
      Public method for SlideshowSection
          - Destroy the slideshow
          - Unbind events
   */

    SlideshowView.prototype.prepareRemove = function () {
        if (this.$paginationContainer.length) {
            this.$paginationContainer.off('click', this.paginationItem);
        }
        if (this.sectionStyle) {
            this._sectionStyle(false);
        }
        this.$window.off('resize.slideshow');
        this.$slideShow.off('heightUpdate');
        this.slideShow.off('cellSelect');
        return this.slideShow.destroy();
    };


    /*
      Triggers Logo swapping, or sticky header offsets
   */

    SlideshowView.prototype.setupHeader = function ($el) {
        if (this.headerLogo.length) {
            $(document.body).trigger('swapLogo');
        }
        if ($el && ($el.attr('data-full-bleed-slideshow') != null)) {
            this.mainHeader.addClass('full-bleed-slideshow');
        } else {
            this.mainHeader.removeClass('full-bleed-slideshow');
        }
        return $(document.body).trigger('toggleStickyHeader', [$el]).trigger('toggleSlideShowHeader', [$el]);
    };

    SlideshowView.prototype.render = function () {
    };

    return SlideshowView;

})(Backbone.View);

window.SlideshowSection = (function (superClass) {
    extend(SlideshowSection, superClass);

    function SlideshowSection() {
        return SlideshowSection.__super__.constructor.apply(this, arguments);
    }

    SlideshowSection.prototype.initialize = function () {
        this.sections = new ThemeEditor();
        return this.sections.register('slideshow', this.slideShow(this.sections));
    };

    SlideshowSection.prototype.slideShow = function (sections) {
        return {
            instances: {},
            el: '[data-section-type="slideshow"]',
            init: function (instance) {
                return this.instances[instance.sectionId] = new SlideshowView({
                    el: $(this.el)
                });
            },
            onSectionLoad: function (event) {
                var instance, ref;
                instance = sections.getInstance(event);
                if (!this.instances[instance.sectionId]) {
                    this.init(instance);
                    return (ref = this.instances[instance.sectionId]) != null ? typeof ref.setupHeader === "function" ? ref.setupHeader(null) : void 0 : void 0;
                }
            },
            onSectionUnload: function (event) {
                var instance, ref, ref1, ref2;
                instance = sections.getInstance(event);
                if ((ref = this.instances[instance.sectionId]) != null) {
                    if (typeof ref.prepareRemove === "function") {
                        ref.prepareRemove();
                    }
                }
                if ((ref1 = this.instances[instance.sectionId]) != null) {
                    if (typeof ref1.remove === "function") {
                        ref1.remove();
                    }
                }
                if ((ref2 = this.instances[instance.sectionId]) != null) {
                    if (typeof ref2.setupHeader === "function") {
                        ref2.setupHeader(null);
                    }
                }
                return delete this.instances[instance.sectionId];
            },
            onSectionSelect: function (event) {
                var instance, ref;
                instance = sections.getInstance(event);
                return (ref = this.instances[instance.sectionId]) != null ? typeof ref.setupHeader === "function" ? ref.setupHeader(null) : void 0 : void 0;
            },
            onBlockSelect: function (event) {
                var instanceHandler;
                instanceHandler = this.instances[sections.getInstance(event).sectionId];
                return instanceHandler.lockSlide(event);
            },
            onBlockDeselect: function (event) {
                var instance, instanceHandler;
                instance = sections.getInstance(event);
                instanceHandler = this.instances[instance.sectionId];
                return instanceHandler.unlockSlide();
            }
        };
    };

    return SlideshowSection;

})(Backbone.View);



/*!
 * pxs-map v2.0.0
 * (c) 2018 undefined
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('jquery')) :
        typeof define === 'function' && define.amd ? define(['jquery'], factory) :
            (global.PxsMap = factory(global.$));
}(this, (function ($) {
    'use strict';

    $ = $ && $.hasOwnProperty('default') ? $['default'] : $;

    var justDebounce = debounce;

    function debounce(fn, delay, at_start, guarantee) {
        var timeout;
        var args;
        var self;

        return function debounced() {
            self = this;
            args = Array.prototype.slice.call(arguments);

            if (timeout && (at_start || guarantee)) {
                return;
            } else if (!at_start) {
                clear();

                timeout = setTimeout(run, delay);
                return timeout;
            }

            timeout = setTimeout(clear, delay);
            fn.apply(self, args);

            function run() {
                clear();
                fn.apply(self, args);
            }

            function clear() {
                clearTimeout(timeout);
                timeout = null;
            }
        };
    }

    var classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    };

    var createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var PxsMap = function () {
        function PxsMap(section) {
            var _this = this;

            classCallCheck(this, PxsMap);

            this.$el = $('[data-map]', section.el);
            this.settings = section.data;
            this.map = null;
            this.center = null;

            this.$container = $('[data-map-container]', this.$el);

            // Scale so range is 12 ~ 17, rather than 1 to 6
            this.zoom = 11 + parseInt(this.settings.zoom, 10);
            if (isNaN(this.zoom)) this.zoom = 13;

            this.colors = null;

            if (this.settings.colors) {
                this.colors = this.settings.colors;
            }

            this.resize = this.resize.bind(this);

            this.address = this.settings.address;
            this.apiKey = this.settings.api_key;

            if (this.apiKey) {
                if (window.googleMaps === undefined) {
                    window.googleMaps = true;

                    $.getScript('https://maps.googleapis.com/maps/api/js?key=' + this.apiKey).done(function () {
                        _this._createMap();
                    }).fail(function (status) {
                        console.error(status);
                    });
                } else {
                    this._createMap();
                }
            }
        }

        createClass(PxsMap, [{
            key: '_createMap',
            value: function _createMap() {
                var _this2 = this;

                return this.geolocate().done(function (results) {
                    _this2.map = new google.maps.Map(_this2.$container.get(0), {
                        center: results[0].geometry.location,
                        clickableIcons: false,
                        disableDefaultUI: true,
                        disableDoubleClickZoom: true,
                        gestureHandling: 'none',
                        keyboardShortcuts: false,
                        maxZoom: _this2.zoom,
                        minZoom: _this2.zoom,
                        scrollWheel: false,
                        styles: _this2._getMapStyles(),
                        zoom: _this2.zoom,
                        zoomControl: false
                    });
                    _this2.center = _this2.map.getCenter();
                    _this2.map.panBy(0, 0);

                    new google.maps.Marker({
                        clickable: false,
                        map: _this2.map,
                        position: _this2.center
                    });

                    google.maps.event.addDomListener(window, 'resize', justDebounce(_this2.resize, 250, true, true));
                }).fail(function (status) {
                    var usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
                    var errorMessage = void 0;

                    switch (status) {
                        case 'ZERO_RESULTS':
                            errorMessage = '<p>Unable to find the address:</p> ' + _this2.address;
                            break;
                        case 'OVER_QUERY_LIMIT':
                            errorMessage = '\n              <p>Unable to load Google Maps, you have reached your usage limit.</p>\n              <p>\n                Please visit\n                <a href="' + usageLimits + '" target="_blank">' + usageLimits + '</a>\n                for more details.\n              </p>\n            ';
                            break;
                        default:
                            errorMessage = 'Unable to load Google Maps.';
                            break;
                    }

                    _this2.displayErrorInThemeEditor(errorMessage, status);
                });
            }
        }, {
            key: 'geolocate',
            value: function geolocate() {
                var deferred = $.Deferred();
                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({address: this.address}, function (results, status) {
                    if (status !== google.maps.GeocoderStatus.OK) {
                        deferred.reject(status);
                    }

                    deferred.resolve(results);
                });

                return deferred;
            }
        }, {
            key: 'resize',
            value: function resize() {
                if (this.map) {
                    google.maps.event.trigger(this.map, 'resize');
                    this.map.setCenter(this.center);
                    this.map.panBy(0, 100);
                }
            }
        }, {
            key: 'onSectionUnload',
            value: function onSectionUnload() {
                if (this.map) {
                    google.maps.event.clearListeners(this.map, 'resize');
                }
            }
        }, {
            key: '_getMapStyles',
            value: function _getMapStyles() {
                if (!this.colors) {
                    return;
                }

                return [{
                    elementType: 'geometry',
                    stylers: [{color: this.colors.e}]
                }, {
                    elementType: 'labels.icon',
                    stylers: [{visibility: 'off'}]
                }, {
                    elementType: 'labels.text.fill',
                    stylers: [{color: this.colors.a}]
                }, {
                    elementType: 'labels.text.stroke',
                    stylers: [{color: this.colors.e}]
                }, {
                    featureType: 'administrative',
                    elementType: 'geometry',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'administrative.country',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'administrative.land_parcel',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'administrative.neighborhood',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'administrative.locality',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'poi',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'road',
                    elementType: 'geometry.fill',
                    stylers: [{color: this.colors.d}]
                }, {
                    featureType: 'road',
                    elementType: 'labels.icon',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'road.arterial',
                    elementType: 'geometry',
                    stylers: [{color: this.colors.c}]
                }, {
                    featureType: 'road.highway',
                    elementType: 'geometry',
                    stylers: [{color: this.colors.b}]
                }, {
                    featureType: 'road.highway.controlled_access',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'road.local',
                    elementType: 'labels.text.fill',
                    stylers: [{color: this.colors.b}]
                }, {
                    featureType: 'road.local',
                    elementType: 'labels.text.stroke',
                    stylers: [{color: this.colors.e}]
                }, {
                    featureType: 'transit',
                    stylers: [{visibility: 'off'}]
                }, {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [{color: this.colors.f}]
                }];
            }
        }, {
            key: 'displayErrorInThemeEditor',
            value: function displayErrorInThemeEditor(errorMessage) {
                var isThemeEditor = window.Shopify && window.Shopify.designMode;

                if (!isThemeEditor) {
                    return;
                }

                this.$container.html('<div class="map-error-message">' + errorMessage + '</div>');
            }
        }]);
        return PxsMap;
    }();

    return PxsMap;

})));

;


/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function (window, document) {
    'use strict';


    // Exits early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
            Object.defineProperty(window.IntersectionObserverEntry.prototype,
                'isIntersecting', {
                    get: function () {
                        return this.intersectionRatio > 0;
                    }
                });
        }
        return;
    }


    /**
     * An IntersectionObserver registry. This registry exists to hold a strong
     * reference to IntersectionObserver instances currently observing a target
     * element. Without this registry, instances without another reference may be
     * garbage collected.
     */
    var registry = [];


    /**
     * Creates the global IntersectionObserverEntry constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
     * @param {Object} entry A dictionary of instance properties.
     * @constructor
     */
    function IntersectionObserverEntry(entry) {
        this.time = entry.time;
        this.target = entry.target;
        this.rootBounds = entry.rootBounds;
        this.boundingClientRect = entry.boundingClientRect;
        this.intersectionRect = entry.intersectionRect || getEmptyRect();
        this.isIntersecting = !!entry.intersectionRect;

        // Calculates the intersection ratio.
        var targetRect = this.boundingClientRect;
        var targetArea = targetRect.width * targetRect.height;
        var intersectionRect = this.intersectionRect;
        var intersectionArea = intersectionRect.width * intersectionRect.height;

        // Sets intersection ratio.
        if (targetArea) {
            // Round the intersection ratio to avoid floating point math issues:
            // https://github.com/w3c/IntersectionObserver/issues/324
            this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
        } else {
            // If area is zero and is intersecting, sets to 1, otherwise to 0
            this.intersectionRatio = this.isIntersecting ? 1 : 0;
        }
    }


    /**
     * Creates the global IntersectionObserver constructor.
     * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
     * @param {Function} callback The function to be invoked after intersection
     *     changes have queued. The function is not invoked if the queue has
     *     been emptied by calling the `takeRecords` method.
     * @param {Object=} opt_options Optional configuration options.
     * @constructor
     */
    function IntersectionObserver(callback, opt_options) {

        var options = opt_options || {};

        if (typeof callback != 'function') {
            throw new Error('callback must be a function');
        }

        if (options.root && options.root.nodeType != 1) {
            throw new Error('root must be an Element');
        }

        // Binds and throttles `this._checkForIntersections`.
        this._checkForIntersections = throttle(
            this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

        // Private properties.
        this._callback = callback;
        this._observationTargets = [];
        this._queuedEntries = [];
        this._rootMarginValues = this._parseRootMargin(options.rootMargin);

        // Public properties.
        this.thresholds = this._initThresholds(options.threshold);
        this.root = options.root || null;
        this.rootMargin = this._rootMarginValues.map(function (margin) {
            return margin.value + margin.unit;
        }).join(' ');
    }


    /**
     * The minimum interval within which the document will be checked for
     * intersection changes.
     */
    IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


    /**
     * The frequency in which the polyfill polls for intersection changes.
     * this can be updated on a per instance basis and must be set prior to
     * calling `observe` on the first target.
     */
    IntersectionObserver.prototype.POLL_INTERVAL = null;

    /**
     * Use a mutation observer on the root element
     * to detect intersection changes.
     */
    IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


    /**
     * Starts observing a target element for intersection changes based on
     * the thresholds values.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.observe = function (target) {
        var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
            return item.element == target;
        });

        if (isTargetAlreadyObserved) {
            return;
        }

        if (!(target && target.nodeType == 1)) {
            throw new Error('target must be an Element');
        }

        this._registerInstance();
        this._observationTargets.push({element: target, entry: null});
        this._monitorIntersections();
        this._checkForIntersections();
    };


    /**
     * Stops observing a target element for intersection changes.
     * @param {Element} target The DOM element to observe.
     */
    IntersectionObserver.prototype.unobserve = function (target) {
        this._observationTargets =
            this._observationTargets.filter(function (item) {

                return item.element != target;
            });
        if (!this._observationTargets.length) {
            this._unmonitorIntersections();
            this._unregisterInstance();
        }
    };


    /**
     * Stops observing all target elements for intersection changes.
     */
    IntersectionObserver.prototype.disconnect = function () {
        this._observationTargets = [];
        this._unmonitorIntersections();
        this._unregisterInstance();
    };


    /**
     * Returns any queue entries that have not yet been reported to the
     * callback and clears the queue. This can be used in conjunction with the
     * callback to obtain the absolute most up-to-date intersection information.
     * @return {Array} The currently queued entries.
     */
    IntersectionObserver.prototype.takeRecords = function () {
        var records = this._queuedEntries.slice();
        this._queuedEntries = [];
        return records;
    };


    /**
     * Accepts the threshold value from the user configuration object and
     * returns a sorted array of unique threshold values. If a value is not
     * between 0 and 1 and error is thrown.
     * @private
     * @param {Array|number=} opt_threshold An optional threshold value or
     *     a list of threshold values, defaulting to [0].
     * @return {Array} A sorted list of unique and valid threshold values.
     */
    IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
        var threshold = opt_threshold || [0];
        if (!Array.isArray(threshold)) threshold = [threshold];

        return threshold.sort().filter(function (t, i, a) {
            if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
                throw new Error('threshold must be a number between 0 and 1 inclusively');
            }
            return t !== a[i - 1];
        });
    };


    /**
     * Accepts the rootMargin value from the user configuration object
     * and returns an array of the four margin values as an object containing
     * the value and unit properties. If any of the values are not properly
     * formatted or use a unit other than px or %, and error is thrown.
     * @private
     * @param {string=} opt_rootMargin An optional rootMargin value,
     *     defaulting to '0px'.
     * @return {Array<Object>} An array of margin objects with the keys
     *     value and unit.
     */
    IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
        var marginString = opt_rootMargin || '0px';
        var margins = marginString.split(/\s+/).map(function (margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
            if (!parts) {
                throw new Error('rootMargin must be specified in pixels or percent');
            }
            return {value: parseFloat(parts[1]), unit: parts[2]};
        });

        // Handles shorthand.
        margins[1] = margins[1] || margins[0];
        margins[2] = margins[2] || margins[0];
        margins[3] = margins[3] || margins[1];

        return margins;
    };


    /**
     * Starts polling for intersection changes if the polling is not already
     * happening, and if the page's visibility state is visible.
     * @private
     */
    IntersectionObserver.prototype._monitorIntersections = function () {
        if (!this._monitoringIntersections) {
            this._monitoringIntersections = true;

            // If a poll interval is set, use polling instead of listening to
            // resize and scroll events or DOM mutations.
            if (this.POLL_INTERVAL) {
                this._monitoringInterval = setInterval(
                    this._checkForIntersections, this.POLL_INTERVAL);
            } else {
                addEvent(window, 'resize', this._checkForIntersections, true);
                addEvent(document, 'scroll', this._checkForIntersections, true);

                if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
                    this._domObserver = new MutationObserver(this._checkForIntersections);
                    this._domObserver.observe(document, {
                        attributes: true,
                        childList: true,
                        characterData: true,
                        subtree: true
                    });
                }
            }
        }
    };


    /**
     * Stops polling for intersection changes.
     * @private
     */
    IntersectionObserver.prototype._unmonitorIntersections = function () {
        if (this._monitoringIntersections) {
            this._monitoringIntersections = false;

            clearInterval(this._monitoringInterval);
            this._monitoringInterval = null;

            removeEvent(window, 'resize', this._checkForIntersections, true);
            removeEvent(document, 'scroll', this._checkForIntersections, true);

            if (this._domObserver) {
                this._domObserver.disconnect();
                this._domObserver = null;
            }
        }
    };


    /**
     * Scans each observation target for intersection changes and adds them
     * to the internal entries queue. If new entries are found, it
     * schedules the callback to be invoked.
     * @private
     */
    IntersectionObserver.prototype._checkForIntersections = function () {
        var rootIsInDom = this._rootIsInDom();
        var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

        this._observationTargets.forEach(function (item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);
            var rootContainsTarget = this._rootContainsTarget(target);
            var oldEntry = item.entry;
            var intersectionRect = rootIsInDom && rootContainsTarget &&
                this._computeTargetAndRootIntersection(target, rootRect);

            var newEntry = item.entry = new IntersectionObserverEntry({
                time: now(),
                target: target,
                boundingClientRect: targetRect,
                rootBounds: rootRect,
                intersectionRect: intersectionRect
            });

            if (!oldEntry) {
                this._queuedEntries.push(newEntry);
            } else if (rootIsInDom && rootContainsTarget) {
                // If the new entry intersection ratio has crossed any of the
                // thresholds, add a new entry.
                if (this._hasCrossedThreshold(oldEntry, newEntry)) {
                    this._queuedEntries.push(newEntry);
                }
            } else {
                // If the root is not in the DOM or target is not contained within
                // root but the previous entry for this target had an intersection,
                // add a new record indicating removal.
                if (oldEntry && oldEntry.isIntersecting) {
                    this._queuedEntries.push(newEntry);
                }
            }
        }, this);

        if (this._queuedEntries.length) {
            this._callback(this.takeRecords(), this);
        }
    };


    /**
     * Accepts a target and root rect computes the intersection between then
     * following the algorithm in the spec.
     * TODO(philipwalton): at this time clip-path is not considered.
     * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
     * @param {Element} target The target DOM element
     * @param {Object} rootRect The bounding rect of the root after being
     *     expanded by the rootMargin value.
     * @return {?Object} The final intersection rect object or undefined if no
     *     intersection is found.
     * @private
     */
    IntersectionObserver.prototype._computeTargetAndRootIntersection =
        function (target, rootRect) {

            // If the element isn't displayed, an intersection can't happen.
            if (window.getComputedStyle(target).display == 'none') return;

            var targetRect = getBoundingClientRect(target);
            var intersectionRect = targetRect;
            var parent = getParentNode(target);
            var atRoot = false;

            while (!atRoot) {
                var parentRect = null;
                var parentComputedStyle = parent.nodeType == 1 ?
                    window.getComputedStyle(parent) : {};

                // If the parent isn't displayed, an intersection can't happen.
                if (parentComputedStyle.display == 'none') return;

                if (parent == this.root || parent == document) {
                    atRoot = true;
                    parentRect = rootRect;
                } else {
                    // If the element has a non-visible overflow, and it's not the <body>
                    // or <html> element, update the intersection rect.
                    // Note: <body> and <html> cannot be clipped to a rect that's not also
                    // the document rect, so no need to compute a new intersection.
                    if (parent != document.body &&
                        parent != document.documentElement &&
                        parentComputedStyle.overflow != 'visible') {
                        parentRect = getBoundingClientRect(parent);
                    }
                }

                // If either of the above conditionals set a new parentRect,
                // calculate new intersection data.
                if (parentRect) {
                    intersectionRect = computeRectIntersection(parentRect, intersectionRect);

                    if (!intersectionRect) break;
                }
                parent = getParentNode(parent);
            }
            return intersectionRect;
        };


    /**
     * Returns the root rect after being expanded by the rootMargin value.
     * @return {Object} The expanded root rect.
     * @private
     */
    IntersectionObserver.prototype._getRootRect = function () {
        var rootRect;
        if (this.root) {
            rootRect = getBoundingClientRect(this.root);
        } else {
            // Use <html>/<body> instead of window since scroll bars affect size.
            var html = document.documentElement;
            var body = document.body;
            rootRect = {
                top: 0,
                left: 0,
                right: html.clientWidth || body.clientWidth,
                width: html.clientWidth || body.clientWidth,
                bottom: html.clientHeight || body.clientHeight,
                height: html.clientHeight || body.clientHeight
            };
        }
        return this._expandRectByRootMargin(rootRect);
    };


    /**
     * Accepts a rect and expands it by the rootMargin value.
     * @param {Object} rect The rect object to expand.
     * @return {Object} The expanded rect.
     * @private
     */
    IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
        var margins = this._rootMarginValues.map(function (margin, i) {
            return margin.unit == 'px' ? margin.value :
                margin.value * (i % 2 ? rect.width : rect.height) / 100;
        });
        var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3]
        };
        newRect.width = newRect.right - newRect.left;
        newRect.height = newRect.bottom - newRect.top;

        return newRect;
    };


    /**
     * Accepts an old and new entry and returns true if at least one of the
     * threshold values has been crossed.
     * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
     *    particular target element or null if no previous entry exists.
     * @param {IntersectionObserverEntry} newEntry The current entry for a
     *    particular target element.
     * @return {boolean} Returns true if a any threshold has been crossed.
     * @private
     */
    IntersectionObserver.prototype._hasCrossedThreshold =
        function (oldEntry, newEntry) {

            // To make comparing easier, an entry that has a ratio of 0
            // but does not actually intersect is given a value of -1
            var oldRatio = oldEntry && oldEntry.isIntersecting ?
                oldEntry.intersectionRatio || 0 : -1;
            var newRatio = newEntry.isIntersecting ?
                newEntry.intersectionRatio || 0 : -1;

            // Ignore unchanged ratios
            if (oldRatio === newRatio) return;

            for (var i = 0; i < this.thresholds.length; i++) {
                var threshold = this.thresholds[i];

                // Return true if an entry matches a threshold or if the new ratio
                // and the old ratio are on the opposite sides of a threshold.
                if (threshold == oldRatio || threshold == newRatio ||
                    threshold < oldRatio !== threshold < newRatio) {
                    return true;
                }
            }
        };


    /**
     * Returns whether or not the root element is an element and is in the DOM.
     * @return {boolean} True if the root element is an element and is in the DOM.
     * @private
     */
    IntersectionObserver.prototype._rootIsInDom = function () {
        return !this.root || containsDeep(document, this.root);
    };


    /**
     * Returns whether or not the target element is a child of root.
     * @param {Element} target The target element to check.
     * @return {boolean} True if the target element is a child of root.
     * @private
     */
    IntersectionObserver.prototype._rootContainsTarget = function (target) {
        return containsDeep(this.root || document, target);
    };


    /**
     * Adds the instance to the global IntersectionObserver registry if it isn't
     * already present.
     * @private
     */
    IntersectionObserver.prototype._registerInstance = function () {
        if (registry.indexOf(this) < 0) {
            registry.push(this);
        }
    };


    /**
     * Removes the instance from the global IntersectionObserver registry.
     * @private
     */
    IntersectionObserver.prototype._unregisterInstance = function () {
        var index = registry.indexOf(this);
        if (index != -1) registry.splice(index, 1);
    };


    /**
     * Returns the result of the performance.now() method or null in browsers
     * that don't support the API.
     * @return {number} The elapsed time since the page was requested.
     */
    function now() {
        return window.performance && performance.now && performance.now();
    }


    /**
     * Throttles a function and delays its execution, so it's only called at most
     * once within a given time period.
     * @param {Function} fn The function to throttle.
     * @param {number} timeout The amount of time that must pass before the
     *     function can be called again.
     * @return {Function} The throttled function.
     */
    function throttle(fn, timeout) {
        var timer = null;
        return function () {
            if (!timer) {
                timer = setTimeout(function () {
                    fn();
                    timer = null;
                }, timeout);
            }
        };
    }


    /**
     * Adds an event handler to a DOM node ensuring cross-browser compatibility.
     * @param {Node} node The DOM node to add the event handler to.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to add.
     * @param {boolean} opt_useCapture Optionally adds the even to the capture
     *     phase. Note: this only works in modern browsers.
     */
    function addEvent(node, event, fn, opt_useCapture) {
        if (typeof node.addEventListener == 'function') {
            node.addEventListener(event, fn, opt_useCapture || false);
        } else if (typeof node.attachEvent == 'function') {
            node.attachEvent('on' + event, fn);
        }
    }


    /**
     * Removes a previously added event handler from a DOM node.
     * @param {Node} node The DOM node to remove the event handler from.
     * @param {string} event The event name.
     * @param {Function} fn The event handler to remove.
     * @param {boolean} opt_useCapture If the event handler was added with this
     *     flag set to true, it should be set to true here in order to remove it.
     */
    function removeEvent(node, event, fn, opt_useCapture) {
        if (typeof node.removeEventListener == 'function') {
            node.removeEventListener(event, fn, opt_useCapture || false);
        } else if (typeof node.detatchEvent == 'function') {
            node.detatchEvent('on' + event, fn);
        }
    }


    /**
     * Returns the intersection between two rect objects.
     * @param {Object} rect1 The first rect.
     * @param {Object} rect2 The second rect.
     * @return {?Object} The intersection rect or undefined if no intersection
     *     is found.
     */
    function computeRectIntersection(rect1, rect2) {
        var top = Math.max(rect1.top, rect2.top);
        var bottom = Math.min(rect1.bottom, rect2.bottom);
        var left = Math.max(rect1.left, rect2.left);
        var right = Math.min(rect1.right, rect2.right);
        var width = right - left;
        var height = bottom - top;

        return (width >= 0 && height >= 0) && {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        };
    }


    /**
     * Shims the native getBoundingClientRect for compatibility with older IE.
     * @param {Element} el The element whose bounding rect to get.
     * @return {Object} The (possibly shimmed) rect of the element.
     */
    function getBoundingClientRect(el) {
        var rect;

        try {
            rect = el.getBoundingClientRect();
        } catch (err) {
            // Ignore Windows 7 IE11 "Unspecified error"
            // https://github.com/w3c/IntersectionObserver/pull/205
        }

        if (!rect) return getEmptyRect();

        // Older IE
        if (!(rect.width && rect.height)) {
            rect = {
                top: rect.top,
                right: rect.right,
                bottom: rect.bottom,
                left: rect.left,
                width: rect.right - rect.left,
                height: rect.bottom - rect.top
            };
        }
        return rect;
    }


    /**
     * Returns an empty rect object. An empty rect is returned when an element
     * is not in the DOM.
     * @return {Object} The empty rect.
     */
    function getEmptyRect() {
        return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
        };
    }

    /**
     * Checks to see if a parent element contains a child element (including inside
     * shadow DOM).
     * @param {Node} parent The parent element.
     * @param {Node} child The child element.
     * @return {boolean} True if the parent node contains the child node.
     */
    function containsDeep(parent, child) {
        var node = child;
        while (node) {
            if (node == parent) return true;

            node = getParentNode(node);
        }
        return false;
    }


    /**
     * Gets the parent node of an element or its host element if the parent node
     * is a shadow root.
     * @param {Node} node The node whose parent to get.
     * @return {Node|null} The parent node or null if no parent exists.
     */
    function getParentNode(node) {
        var parent = node.parentNode;

        if (parent && parent.nodeType == 11 && parent.host) {
            // If the parent is a shadow root, return the host element.
            return parent.host;
        }
        return parent;
    }


    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));

/*!
     * rimg v2.1.0
     * (c) 2018 Pixel Union
     */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global.rimg = factory());
}(this, (function () {
    'use strict';

    /**
     * The default template render function. Turns a template string into an image
     * URL.
     *
     * @param {String} template
     * @param {Size} size
     * @returns {String}
     */
    function defaultTemplateRender(template, size) {
        return template.replace('{size}', size.width + 'x' + size.height);
    }

    /**
     * @type Settings
     */
    var defaults = {
        scale: 1,
        template: false,
        templateRender: defaultTemplateRender,
        max: {width: Infinity, height: Infinity},
        round: 32,
        placeholder: false
    };

    /**
     * Get a data attribute value from an element, with a default fallback and
     * sanitization step.
     *
     * @param {Element} el
     *
     * @param {String} name
     *        The data attribute name.
     *
     * @param {Object} options
     *        An object holding fallback values if the data attribute does not
     *        exist. If this object doesn't have the property, we further fallback
     *        to our defaults.
     *
     * @param {Function} [sanitize]
     *        A function to sanitize the data attribute value with.
     *
     * @returns {String|*}
     */
    function getData(el, name, options, sanitize) {
        var attr = 'data-rimg-' + name;
        if (!el.hasAttribute(attr)) return options[name] || defaults[name];

        var value = el.getAttribute(attr);

        return sanitize ? sanitize(value) : value;
    }

    /**
     * Sanitize data attributes that represent a size (in the form of `10x10`).
     *
     * @param {String} value
     * @returns {Object} An object with `width` and `height` properties.
     */
    function parseSize(value) {
        value = value.split('x');
        return {width: parseInt(value[0], 10), height: parseInt(value[1], 10)};
    }

    /**
     * Loads information about an element.
     *
     * Options can be set on the element itself using data attributes, or through
     * the `options` parameter. Data attributes take priority.
     *
     * @param {HTMLElement} el
     * @param {Settings} options
     * @returns {Item}
     */
    function parseItem(el) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var isImage = el.hasAttribute('data-rimg-template');

        /**
         * @typedef {Settings} Item
         */
        return {
            el: el,

            // Type of element
            isImage: isImage,
            isBackgroundImage: isImage && el.tagName !== 'IMG',

            // Image scale
            scale: getData(el, 'scale', options),

            // Device density
            density: window.devicePixelRatio || 1,

            // Image template URL
            template: getData(el, 'template', options),
            templateRender: options.templateRender || defaults.templateRender,

            // Maximum image dimensions
            max: getData(el, 'max', options, parseSize),

            // Round image dimensions to the nearest multiple
            round: getData(el, 'round', options),

            // Placeholder image dimensions
            placeholder: getData(el, 'placeholder', options, parseSize)
        };
    }

    /**
     * Round to the nearest multiple.
     *
     * This is so we don't tax the image server too much.
     *
     * @param {Number} size The size, in pixels.
     * @param {Number} multiple The multiple to round to the nearest.
     * @returns {Number}
     */
    function roundSize(size, multiple) {
        return Math.ceil(size / multiple) * multiple;
    }

    /**
     * Get the size of an element.
     *
     * If it is too small, it's parent element is checked, and so on. This helps
     * avoid the situation where an element doesn't have a size yet or is positioned
     * out of the layout.
     *
     * @param {HTMLElement} el
     * @return {Object} size
     * @return {Number} size.width The width, in pixels.
     * @return {Number} size.height The height, in pixels.
     */
    function getElementSize(el) {
        var size = {width: 0, height: 0};

        while (el) {
            size.width = el.offsetWidth;
            size.height = el.offsetHeight;
            if (size.width > 20 && size.height > 20) break;
            el = el.parentNode;
        }

        return size;
    }

    /**
     * Trigger a custom event.
     *
     * Note: this approach is deprecated, but still required to support older
     * browsers such as IE 10.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
     *
     * @param {HTMLElement} el
     *        The element to trigger the event on.
     *
     * @param {String} name
     *        The event name.
     *
     * @returns {Boolean}
     *          True if the event was canceled.
     */
    function trigger(el, name) {
        var event = document.createEvent('Event');
        event.initEvent(name, true, true);
        return !el.dispatchEvent(event);
    }

    /**
     * Return the maximum supported density of the image, given the container.
     *
     * @param {Item} item
     * @param {Size} size
     */
    function supportedDensity(item, size) {
        return Math.min(Math.min(Math.max(item.max.width / size.width, 1), item.density), Math.min(Math.max(item.max.height / size.height, 1), item.density)).toFixed(2);
    }

    /**
     * Set the image URL on the element. Supports background images and `srcset`.
     *
     * @param {Item} item
     * @param {Size} size
     * @param {Boolean} isPlaceholder
     */
    function setImage(item, size, isPlaceholder, onLoad) {
        var render = item.templateRender;
        var density = isPlaceholder ? 1 : supportedDensity(item, size);
        var round = isPlaceholder ? 1 : item.round;

        var width = roundSize(size.width * density, round);
        var height = roundSize(size.height * density, round);
        var displaySize = width > item.max.width || height > item.max.height ? {
            width: item.max.width,
            height: item.max.height
        } : {width: width, height: height};

        var url = render(item.template, displaySize);

        // On load callback
        var image = new Image();
        image.onload = onLoad;
        image.src = url;

        // Set image
        if (item.isBackgroundImage) {
            item.el.style.backgroundImage = 'url(\'' + url + '\')';
        } else {
            item.el.setAttribute('srcset', url + ' ' + density + 'x');
        }
    }

    /**
     * Load the image, set loaded status, and trigger the load event.
     *
     * @fires rimg:load
     * @fires rimg:error
     * @param {Item} item
     * @param {Size} size
     */
    function loadFullImage(item, size) {
        var el = item.el;

        setImage(item, size, false, function (event) {
            if (event.type === 'load') {
                el.setAttribute('data-rimg', 'loaded');
            } else {
                el.setAttribute('data-rimg', 'error');
                trigger(el, 'rimg:error');
            }

            trigger(el, 'rimg:load');
        });
    }

    /**
     * Load in a responsive image.
     *
     * Sets the image's `srcset` attribute to the final image URLs, calculated based
     * on the actual size the image is being shown at.
     *
     * @fires rimg:loading
     *        The image URLs have been set and we are waiting for them to load.
     *
     * @fires rimg:loaded
     *        The final image has loaded.
     *
     * @fires rimg:error
     *        The final image failed loading.
     *
     * @param {Item} item
     */
    function loadImage(item) {
        var el = item.el;

        // Already loaded?
        var status = el.getAttribute('data-rimg');
        if (status === 'loading' || status === 'loaded') return;

        // Is the SVG loaded?
        if (!el.complete && !item.isBackgroundImage) {
            // Wait for the load event, then call load image
            el.addEventListener('load', function cb() {
                el.removeEventListener('load', cb);
                loadImage(item);
            });

            return;
        }

        // Trigger loading event, and stop if cancelled
        if (trigger(el, 'rimg:loading')) return;

        // Mark as loading
        el.setAttribute('data-rimg', 'loading');

        // Get element size. This is used as the ideal display size.
        var size = getElementSize(item.el);

        size.width *= item.scale;
        size.height *= item.scale;

        if (item.placeholder) {
            // Load a placeholder image first, followed by the full image. Force the
            // element to keep its dimensions while it loads. If the image is smaller
            // than the element size, use the image's size. Density is taken into account
            // for HiDPI devices to avoid blurry images.
            if (!item.isBackgroundImage) {
                el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
                el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
            }

            setImage(item, item.placeholder, true, function () {
                return loadFullImage(item, size);
            });
        } else {
            loadFullImage(item, size);
        }
    }

    /**
     * Prepare an element to be displayed on the screen.
     *
     * Images have special logic applied to them to swap out the different sources.
     *
     * @fires rimg:enter
     *        The element is entering the viewport.
     *
     * @param {HTMLElement} el
     * @param {Settings} options
     */
    function load(el, options) {
        if (!el) return;
        trigger(el, 'rimg:enter');

        var item = parseItem(el, options);
        if (item.isImage) {
            if (!item.isBackgroundImage) {
                el.setAttribute('data-rimg-template-svg', el.getAttribute('srcset'));
            }

            loadImage(item);
        }
    }

    /**
     * Prepare an element to be displayed on the screen.
     *
     * Images have special logic applied to them to swap out the different sources.
     *
     * @fires rimg:enter
     *        The element is entering the viewport.
     *
     * @param {HTMLElement} el
     * @param {Settings} options
     */
    function update(el, options) {
        if (!el) return;
        trigger(el, 'rimg:update');

        var item = parseItem(el, options);

        if (item.isImage) {
            if (!item.isBackgroundImage) {
                el.setAttribute('data-rimg', 'lazy');
                el.setAttribute('srcset', el.getAttribute('data-rimg-template-svg'));
            }

            loadImage(item);
        }
    }

    /**
     * @typedef {Object} Size
     * @property {Number} width
     * @property {Number} height
     */

    /**
     * A function to turn a template string into a URL.
     *
     * @callback TemplateRenderer
     * @param {String} template
     * @param {Size} size
     * @returns {String}
     */

    /**
     * @typedef {Object} Settings
     *
     * @property {String} [template]
     *           A template string used to generate URLs for an image. This allows us to
     *           dynamically load images with sizes to match the container's size.
     *
     * @property {TemplateRenderer} [templateRender]
     *           A function to turn a template string into a URL.
     *
     * @property {Size} [max]
     *           The maximum available size for the image. This ensures we don't
     *           try to load an image larger than is possible.
     *
     * @property {Number} [round]
     *           Round image dimensions to the nearest multiple. This is intended to
     *           tax the image server less by lowering the number of possible image
     *           sizes requested.
     *
     * @property {Size} [placeholder]
     *           The size of the lo-fi image to load before the full image.
     */

    /**
     * Initialize the responsive image handler.
     *
     * @param {String|HTMLElement|NodeList} selector
     *        The CSS selector, element, or elements to track for lazy-loading.
     *
     * @param {Settings} options
     *
     * @returns {PublicApi}
     */
    function rimg() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // Intersections
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    io.unobserve(entry.target);
                    load(entry.target, options);
                }
            });
        }, {
            // Watch the viewport, with 20% vertical margins
            rootMargin: '20% 0px'
        });

        /**
         * @typedef {Object} PublicApi
         */
        var api = {
            /**
             * Track a new selector, element, or nodelist for lazy-loading.
             * @type Function
             * @param {String|HTMLElement|NodeList} selector
             */
            track: function track() {
                var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';

                var els = querySelector(selector);
                for (var i = 0; i < els.length; i++) {
                    io.observe(els[i]);
                }
            },
            update: function update$$1() {
                var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="loaded"]';

                var els = querySelector(selector);
                for (var i = 0; i < els.length; i++) {
                    update(els[i], options);
                }
            },


            /**
             * Stop tracking element(s) for lazy-loading.
             * @type Function
             * @param {String|HTMLElement|NodeList} selector
             */
            untrack: function untrack() {
                var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';

                var els = querySelector(selector);
                for (var i = 0; i < els.length; i++) {
                    io.unobserve(els[i]);
                }
            },


            /**
             * Unload all event handlers and observers.
             * @type Function
             */
            unload: function unload() {
                io.disconnect();
            }
        };

        // Add initial elements
        api.track(selector);

        return api;
    }

    /**
     * Finds a group of elements on the page.
     *
     * @param {String|HTMLElement|NodeList} selector
     * @returns {Object} An array-like object.
     */
    function querySelector(selector) {
        if (typeof selector === 'string') {
            return document.querySelectorAll(selector);
        }

        if (selector instanceof HTMLElement) {
            return [selector];
        }

        if (selector instanceof NodeList) {
            return selector;
        }

        return [];
    }

    return rimg;

})));

/*!
     * rimg-shopify v2.2.0
     * (c) 2018 Pixel Union
     */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('rimg')) :
        typeof define === 'function' && define.amd ? define(['rimg'], factory) :
            (global.rimg = global.rimg || {}, global.rimg.shopify = factory(global.rimg));
}(this, (function (rimg) {
    'use strict';

    rimg = rimg && rimg.hasOwnProperty('default') ? rimg['default'] : rimg;

    /**
     * Polyfill for Element.matches().
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
     */
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {
            }
            return i > -1;
        };
    }

    var state = {
        init: init,
        watch: watch,
        unwatch: unwatch
    };

    function init() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        state.selector = selector;
        state.instance = rimg(selector, options);
        state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        // Listen for Shopify theme editor events
        document.addEventListener('shopify:section:load', function (event) {
            return watch(event.target);
        });

        window.addEventListener('resize', function () {
            return _update();
        });

        document.addEventListener('shopify:section:unload', function (event) {
            return unwatch(event.target);
        });

        // Listen for custom events to allow themes to hook into rimg
        document.addEventListener('theme:rimg:watch', function (event) {
            return watch(event.target);
        });

        document.addEventListener('theme:rimg:unwatch', function (event) {
            return unwatch(event.target);
        });

        // Support custom events triggered through jQuery
        // See: https://github.com/jquery/jquery/issues/3347
        if (window.jQuery) {
            jQuery(document).on({
                'theme:rimg:watch': function themeRimgWatch(event) {
                    return watch(event.target);
                },
                'theme:rimg:unwatch': function themeRimgUnwatch(event) {
                    return unwatch(event.target);
                }
            });
        }
    }

    /**
     * Track an element, and its children.
     *
     * @param {HTMLElement} el
     */
    function watch(el) {
        // Track element
        if (typeof el.matches === 'function' && el.matches(state.selector)) {
            state.instance.track(el);
        }

        // Track element's children
        state.instance.track(el.querySelectorAll(state.selector));
    }

    /**
     * Untrack an element, and its children
     *
     * @param {HTMLElement} el
     * @private
     */
    function unwatch(el) {
        // Untrack element's children
        state.instance.untrack(el.querySelectorAll(state.selector));

        // Untrack element
        if (typeof el.matches === 'function' && el.matches(state.selector)) {
            state.instance.untrack(el);
        }
    }

    /**
     * Update an element, and its children.
     *
     * @param {HTMLElement} el
     */
    function _update() {
        var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        // Return if we're not 2x smaller, or larger than the existing loading size
        if (currentWidth / state.loadedWidth > 0.5 && currentWidth / state.loadedWidth < 2) {
            return;
        }

        state.loadedWidth = currentWidth;
        state.instance.update();
    }

    return state;

})));


/*!
     * pxs-video v2.0.1
     * (c) 2018 Pixel Union
     */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global.PxsVideo = factory());
}(this, (function () {
    'use strict';

    function createCommonjsModule(fn, module) {
        return module = {exports: {}}, fn(module, module.exports), module.exports;
    }

    var script = createCommonjsModule(function (module) {
        /*!
      * $script.js JS loader & dependency manager
      * https://github.com/ded/script.js
      * (c) Dustin Diaz 2014 | License MIT
      */

        (function (name, definition) {
            if ('object' != 'undefined' && module.exports) module.exports = definition(); else if (typeof undefined == 'function' && undefined.amd) undefined(definition); else this[name] = definition();
        })('$script', function () {
            var doc = document,
                head = doc.getElementsByTagName('head')[0],
                s = 'string',
                f = false,
                push = 'push',
                readyState = 'readyState',
                onreadystatechange = 'onreadystatechange',
                list = {},
                ids = {},
                delay = {},
                scripts = {},
                scriptpath,
                urlArgs;

            function every(ar, fn) {
                for (var i = 0, j = ar.length; i < j; ++i) {
                    if (!fn(ar[i])) return f;
                }
                return 1;
            }

            function each(ar, fn) {
                every(ar, function (el) {
                    return !fn(el);
                });
            }

            function $script(paths, idOrDone, optDone) {
                paths = paths[push] ? paths : [paths];
                var idOrDoneIsDone = idOrDone && idOrDone.call,
                    done = idOrDoneIsDone ? idOrDone : optDone,
                    id = idOrDoneIsDone ? paths.join('') : idOrDone,
                    queue = paths.length;

                function loopFn(item) {
                    return item.call ? item() : list[item];
                }

                function callback() {
                    if (!--queue) {
                        list[id] = 1;
                        done && done();
                        for (var dset in delay) {
                            every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
                        }
                    }
                }

                setTimeout(function () {
                    each(paths, function loading(path, force) {
                        if (path === null) return callback();

                        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
                            path = path.indexOf('.js') === -1 ? scriptpath + path + '.js' : scriptpath + path;
                        }

                        if (scripts[path]) {
                            return scripts[path] == 2 ? callback() : setTimeout(function () {
                                loading(path, true);
                            }, 0);
                        }

                        scripts[path] = 1;
                        create(path, callback);
                    });
                }, 0);
                return $script;
            }

            function create(path, fn) {
                var el = doc.createElement('script'),
                    loaded;
                el.onload = el.onerror = el[onreadystatechange] = function () {
                    if (el[readyState] && !/^c|loade/.test(el[readyState]) || loaded) return;
                    el.onload = el[onreadystatechange] = null;
                    loaded = 1;
                    scripts[path] = 2;
                    fn();
                };
                el.async = 1;
                el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
                head.insertBefore(el, head.lastChild);
            }

            $script.get = create;

            $script.order = function (scripts, id, done) {
                (function callback(s) {
                    s = scripts.shift();
                    !scripts.length ? $script(s, id, done) : $script(s, callback);
                })();
            };

            $script.path = function (p) {
                scriptpath = p;
            };
            $script.urlArgs = function (str) {
                urlArgs = str;
            };
            $script.ready = function (deps, ready, req) {
                deps = deps[push] ? deps : [deps];
                var missing = [];
                !each(deps, function (dep) {
                    list[dep] || missing[push](dep);
                }) && every(deps, function (dep) {
                    return list[dep];
                }) ? ready() : !function (key) {
                    delay[key] = delay[key] || [];
                    delay[key][push](ready);
                    req && req(missing);
                }(deps.join('|'));
                return $script;
            };

            $script.done = function (idOrDone) {
                $script([null], idOrDone);
            };

            return $script;
        });
    });

    var classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    };

    var createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var api = 'https://www.youtube.com/iframe_api';
    var apiLoadedCallbacks = [];
    var apiLoaded = false;

    window.onYouTubeIframeAPIReady = function () {
        apiLoadedCallbacks.forEach(function (apiLoadedCallback) {
            return apiLoadedCallback();
        });
        apiLoadedCallbacks = [];
        apiLoaded = true;
    };

    var Youtube = function () {
        function Youtube(el, id) {
            classCallCheck(this, Youtube);

            this.el = el;
            this.id = id;

            this.iframeEl = document.createElement('div');
            this.el.appendChild(this.iframeEl);

            this.onApiLoaded = this._onApiLoaded.bind(this);

            this.isReady = false;
            this.onReady = this._onReady.bind(this);
            this.onReadyCallback = null;

            this.onStateChange = this._onStateChange.bind(this);
            this.onPlayCallback = null;

            if (apiLoaded) {
                this._onApiLoaded();
            } else {
                apiLoadedCallbacks.push(this.onApiLoaded);
                script(api);
            }
        }

        createClass(Youtube, [{
            key: 'play',
            value: function play() {
                var _this = this;

                return new Promise(function (resolve) {
                    _this.onPlayCallback = resolve;

                    if (_this.isReady) {
                        _this.player.playVideo();
                    } else {
                        _this.onReadyCallback = function () {
                            return _this.player.playVideo();
                        };
                    }
                });
            }
        }, {
            key: 'unload',
            value: function unload() {
                this.player.destroy();
            }
        }, {
            key: '_onApiLoaded',
            value: function _onApiLoaded() {
                this.player = new YT.Player(this.iframeEl, {
                    videoId: this.id,
                    playerVars: {
                        modestbranding: true,
                        showinfo: false,
                        controls: false
                    },
                    events: {
                        onReady: this.onReady,
                        onStateChange: this.onStateChange
                    }
                });
            }
        }, {
            key: '_onReady',
            value: function _onReady() {
                this.isReady = true;

                if (this.onReadyCallback) {
                    this.onReadyCallback();
                }
            }
        }, {
            key: '_onStateChange',
            value: function _onStateChange(event) {
                var state = event.data;

                if (this.onPlayCallback && state === YT.PlayerState.PLAYING) {
                    this.onPlayCallback();
                    this.onPlayCallback = null;
                }
            }
        }]);
        return Youtube;
    }();

    var api$1 = 'https://player.vimeo.com/api/player.js';
    var apiLoaded$1 = false;

    var VimeoPlayer = function () {
        function VimeoPlayer(el, id) {
            classCallCheck(this, VimeoPlayer);

            this.el = el;
            this.id = id;

            this.onApiLoaded = this._onApiLoaded.bind(this);

            this.onProgress = this._onProgress.bind(this);
            this.onProgressCallback = null;

            if (apiLoaded$1) {
                this._onApiLoaded();
            } else {
                script(api$1, this.onApiLoaded);
            }
        }

        createClass(VimeoPlayer, [{
            key: 'play',
            value: function play() {
                var _this = this;

                return new Promise(function (resolve) {
                    _this.onProgressCallback = resolve;
                    _this.player.on('progress', _this.onProgress);
                    _this.player.play();
                });
            }
        }, {
            key: 'unload',
            value: function unload() {
                this.player.unload().catch();
            }
        }, {
            key: '_onApiLoaded',
            value: function _onApiLoaded() {
                this.player = new window.Vimeo.Player(this.el, {id: this.id});

                this.player.ready().catch();

                apiLoaded$1 = true;
            }
        }, {
            key: '_onProgress',
            value: function _onProgress() {
                this.player.off('progress', this.onProgress);

                if (this.onProgressCallback) {
                    this.onProgressCallback();
                    this.onProgressCallback = null;
                }
            }
        }]);
        return VimeoPlayer;
    }();

    var optionsDefaults = {
        autoplay: false
    };

    var Video = function () {
        function Video(el) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            classCallCheck(this, Video);

            this.el = el;
            this.playButton = el.querySelector('[data-video-play-button]');
            this.onPlayButtonClick = this._play.bind(this);
            this.video = null;

            var autoplay = options.autoplay || optionsDefaults.autoplay;

            var videoEl = el.querySelector('[data-video]');
            var type = videoEl.getAttribute('data-video');
            var id = videoEl.getAttribute('data-video-id');

            switch (type) {
                case 'youtube':
                    this.video = new Youtube(videoEl, id);
                    break;
                case 'vimeo':
                    this.video = new VimeoPlayer(videoEl, id);
                    break;
                default:
                    this.video = null;
                    break;
            }

            if (this.playButton) {
                this.playButton.addEventListener('click', this.onPlayButtonClick);
            }

            if (autoplay) {
                this._play();
            }
        }

        createClass(Video, [{
            key: '_play',
            value: function _play() {
                var _this = this;

                this.el.classList.add('video-loading');

                this.video.play().then(function () {
                    _this.el.classList.add('video-transitioning');

                    setTimeout(function () {
                        _this.el.classList.remove('video-loading');
                        _this.el.classList.remove('video-transitioning');
                        _this.el.classList.add('video-playing');
                    }, 200);
                });
            }
        }, {
            key: 'unload',
            value: function unload() {
                if (this.playButton) {
                    this.playButton.removeEventListener('click', this.onPlayClick);
                }

                if (this.video) {
                    this.video.unload();
                }
            }
        }]);
        return Video;
    }();

    var PxsVideo = function () {
        function PxsVideo(section) {
            classCallCheck(this, PxsVideo);

            this.video = null;

            var el = section.el.querySelector('[data-video-container]');
            var data = section.data;

            if (!el) {
                return;
            }

            this.video = new Video(el, {
                autoplay: data.autoplay
            });
        }

        createClass(PxsVideo, [{
            key: 'onSectionUnload',
            value: function onSectionUnload() {
                if (this.video) {
                    this.video.unload();
                }
            }
        }]);
        return PxsVideo;
    }();

    return PxsVideo;

})));


!function (o, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : o.CurrencyConverter = t()
}(this, function () {
    "use strict";

    function o(o) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
            m = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
            n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
        if (isNaN(o) || !o) return 0;
        var r = (o / 100).toFixed(t).split(m);
        return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + m) + (r[1] ? n + r[1] : "")
    }

    function t(t, m) {
        "string" == typeof t && (t = t.replace(".", ""));
        var n = "", r = /\{\{\s*(\w+)\s*\}\}/;
        switch (m.match(r)[1]) {
            case"amount":
                n = o(t, 2, ",", ".");
                break;
            case"amount_with_space_separator":
                n = o(t, 2, " ", ".");
                break;
            case"amount_with_comma_separator":
                n = o(t, 2, ".", ",");
                break;
            case"amount_with_apostrophe_separator":
                n = o(t, 2, "'", ".");
                break;
            case"amount_no_decimals":
                n = o(t, 0, ",", ".");
                break;
            case"amount_no_decimals_with_space_separator":
                n = o(t, 0, " ", ".");
                break;
            case"amount_no_decimals_with_comma_separator":
                n = o(t, 0, ",", ".")
        }
        return m.replace(r, n)
    }

    var m = {
        USD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} USD"
        },
        EUR: {
            money_format: "&euro;{{amount}}",
            money_with_currency_format: "&euro;{{amount}} EUR"
        },
        GBP: {
            money_format: "&pound;{{amount}}",
            money_with_currency_format: "&pound;{{amount}} GBP"
        },
        CAD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} CAD"
        },
        ALL: {
            money_format: "Lek {{amount}}",
            money_with_currency_format: "Lek {{amount}} ALL"
        },
        DZD: {
            money_format: "DA {{amount}}",
            money_with_currency_format: "DA {{amount}} DZD"
        },
        AOA: {
            money_format: "Kz{{amount}}",
            money_with_currency_format: "Kz{{amount}} AOA"
        },
        ARS: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} ARS"
        },
        AMD: {
            money_format: "{{amount}} AMD",
            money_with_currency_format: "{{amount}} AMD"
        },
        AWG: {
            money_format: "Afl{{amount}}",
            money_with_currency_format: "Afl{{amount}} AWG"
        },
        AUD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} AUD"
        },
        BBD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} Bds"
        },
        AZN: {
            money_format: "m.{{amount}}",
            money_with_currency_format: "m.{{amount}} AZN"
        },
        BDT: {
            money_format: "Tk {{amount}}",
            money_with_currency_format: "Tk {{amount}} BDT"
        },
        BSD: {
            money_format: "BS${{amount}}",
            money_with_currency_format: "BS${{amount}} BSD"
        },
        BHD: {
            money_format: "{{amount}}0 BD",
            money_with_currency_format: "{{amount}}0 BHD"
        },
        BYR: {
            money_format: "Br {{amount}}",
            money_with_currency_format: "Br {{amount}} BYR"
        },
        BZD: {
            money_format: "BZ${{amount}}",
            money_with_currency_format: "BZ${{amount}} BZD"
        },
        BTN: {
            money_format: "Nu {{amount}}",
            money_with_currency_format: "Nu {{amount}} BTN"
        },
        BAM: {
            money_format: "KM {{amount_with_comma_separator}}",
            money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
        },
        BRL: {
            money_format: "R$ {{amount_with_comma_separator}}",
            money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
        },
        BOB: {
            money_format: "Bs{{amount_with_comma_separator}}",
            money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
        },
        BWP: {
            money_format: "P{{amount}}",
            money_with_currency_format: "P{{amount}} BWP"
        },
        BND: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} BND"
        },
        BGN: {
            money_format: "{{amount}} лв",
            money_with_currency_format: "{{amount}} лв BGN"
        },
        MMK: {
            money_format: "K{{amount}}",
            money_with_currency_format: "K{{amount}} MMK"
        },
        KHR: {
            money_format: "KHR{{amount}}",
            money_with_currency_format: "KHR{{amount}}"
        },
        KYD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} KYD"
        },
        XAF: {
            money_format: "FCFA{{amount}}",
            money_with_currency_format: "FCFA{{amount}} XAF"
        },
        CLP: {
            money_format: "${{amount_no_decimals}}",
            money_with_currency_format: "${{amount_no_decimals}} CLP"
        },
        CNY: {
            money_format: "&#165;{{amount}}",
            money_with_currency_format: "&#165;{{amount}} CNY"
        },
        COP: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} COP"
        },
        CRC: {
            money_format: "&#8353; {{amount_with_comma_separator}}",
            money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
        },
        HRK: {
            money_format: "{{amount_with_comma_separator}} kn",
            money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
        },
        CZK: {
            money_format: "{{amount_with_comma_separator}} K&#269;",
            money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
        },
        DKK: {
            money_format: "{{amount_with_comma_separator}}",
            money_with_currency_format: "kr.{{amount_with_comma_separator}}"
        },
        DOP: {
            money_format: "RD$ {{amount}}",
            money_with_currency_format: "RD$ {{amount}}"
        },
        XCD: {
            money_format: "${{amount}}",
            money_with_currency_format: "EC${{amount}}"
        },
        EGP: {
            money_format: "LE {{amount}}",
            money_with_currency_format: "LE {{amount}} EGP"
        },
        ETB: {
            money_format: "Br{{amount}}",
            money_with_currency_format: "Br{{amount}} ETB"
        },
        XPF: {
            money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
            money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
        },
        FJD: {
            money_format: "${{amount}}",
            money_with_currency_format: "FJ${{amount}}"
        },
        GMD: {
            money_format: "D {{amount}}",
            money_with_currency_format: "D {{amount}} GMD"
        },
        GHS: {
            money_format: "GH&#8373;{{amount}}",
            money_with_currency_format: "GH&#8373;{{amount}}"
        },
        GTQ: {
            money_format: "Q{{amount}}",
            money_with_currency_format: "{{amount}} GTQ"
        },
        GYD: {
            money_format: "G${{amount}}",
            money_with_currency_format: "${{amount}} GYD"
        },
        GEL: {
            money_format: "{{amount}} GEL",
            money_with_currency_format: "{{amount}} GEL"
        },
        HNL: {
            money_format: "L {{amount}}",
            money_with_currency_format: "L {{amount}} HNL"
        },
        HKD: {
            money_format: "${{amount}}",
            money_with_currency_format: "HK${{amount}}"
        },
        HUF: {
            money_format: "{{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
        },
        ISK: {
            money_format: "{{amount_no_decimals}} kr",
            money_with_currency_format: "{{amount_no_decimals}} kr ISK"
        },
        INR: {
            money_format: "Rs. {{amount}}",
            money_with_currency_format: "Rs. {{amount}}"
        },
        IDR: {
            money_format: "{{amount_with_comma_separator}}",
            money_with_currency_format: "Rp {{amount_with_comma_separator}}"
        },
        ILS: {
            money_format: "{{amount}} NIS",
            money_with_currency_format: "{{amount}} NIS"
        },
        JMD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} JMD"
        },
        JPY: {
            money_format: "&#165;{{amount_no_decimals}}",
            money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
        },
        JEP: {
            money_format: "&pound;{{amount}}",
            money_with_currency_format: "&pound;{{amount}} JEP"
        },
        JOD: {
            money_format: "{{amount}}0 JD",
            money_with_currency_format: "{{amount}}0 JOD"
        },
        KZT: {
            money_format: "{{amount}} KZT",
            money_with_currency_format: "{{amount}} KZT"
        },
        KES: {
            money_format: "KSh{{amount}}",
            money_with_currency_format: "KSh{{amount}}"
        },
        KWD: {
            money_format: "{{amount}}0 KD",
            money_with_currency_format: "{{amount}}0 KWD"
        },
        KGS: {
            money_format: "лв{{amount}}",
            money_with_currency_format: "лв{{amount}}"
        },
        LVL: {
            money_format: "Ls {{amount}}",
            money_with_currency_format: "Ls {{amount}} LVL"
        },
        LBP: {
            money_format: "L&pound;{{amount}}",
            money_with_currency_format: "L&pound;{{amount}} LBP"
        },
        LTL: {
            money_format: "{{amount}} Lt",
            money_with_currency_format: "{{amount}} Lt"
        },
        MGA: {
            money_format: "Ar {{amount}}",
            money_with_currency_format: "Ar {{amount}} MGA"
        },
        MKD: {
            money_format: "ден {{amount}}",
            money_with_currency_format: "ден {{amount}} MKD"
        },
        MOP: {
            money_format: "MOP${{amount}}",
            money_with_currency_format: "MOP${{amount}}"
        },
        MVR: {
            money_format: "Rf{{amount}}",
            money_with_currency_format: "Rf{{amount}} MRf"
        },
        MXN: {
            money_format: "$ {{amount}}",
            money_with_currency_format: "$ {{amount}} MXN"
        },
        MYR: {
            money_format: "RM{{amount}} MYR",
            money_with_currency_format: "RM{{amount}} MYR"
        },
        MUR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} MUR"
        },
        MDL: {
            money_format: "{{amount}} MDL",
            money_with_currency_format: "{{amount}} MDL"
        },
        MAD: {
            money_format: "{{amount}} dh",
            money_with_currency_format: "Dh {{amount}} MAD"
        },
        MNT: {
            money_format: "{{amount_no_decimals}} &#8366",
            money_with_currency_format: "{{amount_no_decimals}} MNT"
        },
        MZN: {
            money_format: "{{amount}} Mt",
            money_with_currency_format: "Mt {{amount}} MZN"
        },
        NAD: {
            money_format: "N${{amount}}",
            money_with_currency_format: "N${{amount}} NAD"
        },
        NPR: {
            money_format: "Rs{{amount}}",
            money_with_currency_format: "Rs{{amount}} NPR"
        },
        ANG: {
            money_format: "&fnof;{{amount}}",
            money_with_currency_format: "{{amount}} NA&fnof;"
        },
        NZD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} NZD"
        },
        NIO: {
            money_format: "C${{amount}}",
            money_with_currency_format: "C${{amount}} NIO"
        },
        NGN: {
            money_format: "&#8358;{{amount}}",
            money_with_currency_format: "&#8358;{{amount}} NGN"
        },
        NOK: {
            money_format: "kr {{amount_with_comma_separator}}",
            money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
        },
        OMR: {
            money_format: "{{amount_with_comma_separator}} OMR",
            money_with_currency_format: "{{amount_with_comma_separator}} OMR"
        },
        PKR: {
            money_format: "Rs.{{amount}}",
            money_with_currency_format: "Rs.{{amount}} PKR"
        },
        PGK: {
            money_format: "K {{amount}}",
            money_with_currency_format: "K {{amount}} PGK"
        },
        PYG: {
            money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
        },
        PEN: {
            money_format: "S/. {{amount}}",
            money_with_currency_format: "S/. {{amount}} PEN"
        },
        PHP: {
            money_format: "&#8369;{{amount}}",
            money_with_currency_format: "&#8369;{{amount}} PHP"
        },
        PLN: {
            money_format: "{{amount_with_comma_separator}} zl",
            money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
        },
        QAR: {
            money_format: "QAR {{amount_with_comma_separator}}",
            money_with_currency_format: "QAR {{amount_with_comma_separator}}"
        },
        RON: {
            money_format: "{{amount_with_comma_separator}} lei",
            money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
        },
        RUB: {
            money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
            money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
        },
        RWF: {
            money_format: "{{amount_no_decimals}} RF",
            money_with_currency_format: "{{amount_no_decimals}} RWF"
        },
        WST: {
            money_format: "WS$ {{amount}}",
            money_with_currency_format: "WS$ {{amount}} WST"
        },
        SAR: {
            money_format: "{{amount}} SR",
            money_with_currency_format: "{{amount}} SAR"
        },
        STD: {
            money_format: "Db {{amount}}",
            money_with_currency_format: "Db {{amount}} STD"
        },
        RSD: {
            money_format: "{{amount}} RSD",
            money_with_currency_format: "{{amount}} RSD"
        },
        SCR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} SCR"
        },
        SGD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} SGD"
        },
        SYP: {
            money_format: "S&pound;{{amount}}",
            money_with_currency_format: "S&pound;{{amount}} SYP"
        },
        ZAR: {
            money_format: "R {{amount}}",
            money_with_currency_format: "R {{amount}} ZAR"
        },
        KRW: {
            money_format: "&#8361;{{amount_no_decimals}}",
            money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
        },
        LKR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} LKR"
        },
        SEK: {
            money_format: "{{amount_no_decimals}} kr",
            money_with_currency_format: "{{amount_no_decimals}} kr SEK"
        },
        CHF: {
            money_format: "SFr. {{amount}}",
            money_with_currency_format: "SFr. {{amount}} CHF"
        },
        TWD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} TWD"
        },
        THB: {
            money_format: "{{amount}} &#xe3f;",
            money_with_currency_format: "{{amount}} &#xe3f; THB"
        },
        TZS: {
            money_format: "{{amount}} TZS",
            money_with_currency_format: "{{amount}} TZS"
        },
        TTD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} TTD"
        },
        TND: {
            money_format: "{{amount}}",
            money_with_currency_format: "{{amount}} DT"
        },
        TRY: {
            money_format: "{{amount}}TL",
            money_with_currency_format: "{{amount}}TL"
        },
        UGX: {
            money_format: "Ush {{amount_no_decimals}}",
            money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
        },
        UAH: {
            money_format: "₴{{amount}}",
            money_with_currency_format: "₴{{amount}} UAH"
        },
        AED: {
            money_format: "Dhs. {{amount}}",
            money_with_currency_format: "Dhs. {{amount}} AED"
        },
        UYU: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} UYU"
        },
        VUV: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}}VT"
        },
        VEF: {
            money_format: "Bs. {{amount_with_comma_separator}}",
            money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
        },
        VND: {
            money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
            money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
        },
        XBT: {
            money_format: "{{amount_no_decimals}} BTC",
            money_with_currency_format: "{{amount_no_decimals}} BTC"
        },
        XOF: {
            money_format: "CFA{{amount}}",
            money_with_currency_format: "CFA{{amount}} XOF"
        },
        ZMW: {
            money_format: "K{{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
        }
    }, n = function (o, t) {
        if (!(o instanceof t)) throw new TypeError("Cannot call a class as a function")
    }, r = function () {
        function o(o, t) {
            for (var m = 0; m < t.length; m++) {
                var n = t[m];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(o, n.key, n)
            }
        }

        return function (t, m, n) {
            return m && o(t.prototype, m), n && o(t, n), t
        }
    }();
    return new (function () {
        function o() {
            n(this, o), this.defaults = {
                switcherSelector: "[data-currency-converter]",
                priceSelector: ".money",
                shopCurrency: "",
                defaultCurrency: "",
                displayFormat: "",
                moneyFormat: "",
                moneyFormatNoCurrency: "",
                moneyFormatCurrency: ""
            }, this.options = {}, this.moneyFormats = m, this.storage = "currency", this.currentCurrency = null, this.isInitialised = !1
        }

        return r(o, [{
            key: "init", value: function (o) {
                var t = this;
                window.Currency && !this.isInitialised && (Object.keys(this.defaults).forEach(function (m) {
                    t.options[m] = o[m] || t.defaults[m]
                }), this.currentCurrency = this._getStoredCurrency() || this.options.defaultCurrency, this.moneyFormats[this.options.shopCurrency].money_with_currency_format = this.options.moneyFormatCurrency, this.moneyFormats[this.options.shopCurrency].money_format = this.options.moneyFormatNoCurrency, this.isInitialised = !0, this._current())
            }
        }, {
            key: "setCurrency", value: function (o) {
                this.isInitialised && this._convertAll(this.currentCurrency, o)
            }
        }, {
            key: "update", value: function (o) {
                if (this.isInitialised) {
                    for (var t = o.attributes, m = 0; m < t.length; m++) {
                        var n = t[m];
                        0 === n.name.indexOf("data-currency") && o.setAttribute(n.name, "")
                    }
                    this._convertEl(o, this.options.shopCurrency, this.currentCurrency)
                }
            }
        }, {
            key: "_getStoredCurrency", value: function () {
                try {
                    return localStorage.getItem(this.storage)
                } catch (o) {
                    return console.warn(o), this.options.defaultCurrency
                }
            }
        }, {
            key: "_setStoredCurrency", value: function (o) {
                try {
                    localStorage.setItem(this.storage, o)
                } catch (o) {
                    console.warn(o)
                }
            }
        }, {
            key: "_current", value: function () {
                for (var o = document.querySelectorAll(this.options.switcherSelector), t = 0; t < o.length; t += 1) for (var m = o[t].querySelectorAll("option"), n = 0; n < m.length; n += 1) {
                    var r = m[n];
                    r.selected && r.value !== this.currentCurrency && (r.selected = !1), r.value === this.currentCurrency && (r.selected = !0)
                }
                this._convertAll(this.options.shopCurrency, this.currentCurrency)
            }
        }, {
            key: "_convertEl", value: function (o, m, n) {
                if (o.getAttribute("data-currency") !== n) {
                    if (o.getAttribute("data-currency-" + n)) o.innerHTML = o.getAttribute("data-currency-" + n); else {
                        var r = this.moneyFormats[m][this.options.displayFormat],
                            a = this.moneyFormats[n][this.options.displayFormat],
                            e = function (o, t, m) {
                                return -1 !== t.indexOf("amount_no_decimals") ? 100 * o : "JOD" === m || "KWD" === m || "BHD" === m ? o / 10 : o
                            }(function (o) {
                                var t = o.textContent,
                                    m = parseInt(t.replace(/[^0-9]/g, ""), 10);
                                return isNaN(m) ? "" : m
                            }(o), r, m);
                        if ("" === e) return;
                        var _ = window.Currency.convert(e, m, n), u = t(e, r),
                            c = t(_, a);
                        o.setAttribute("data-currency-" + m, u), o.setAttribute("data-currency-" + n, c), o.innerHTML = c
                    }
                    o.setAttribute("data-currency", n)
                }
            }
        }, {
            key: "_convertAll", value: function (o, t) {
                var m = document.querySelectorAll(this.options.priceSelector);
                if (m) {
                    this.currentCurrency = t, this._setStoredCurrency(t);
                    for (var n = 0; n < m.length; n += 1) this._convertEl(m[n], o, t)
                }
            }
        }]), o
    }())
});


;

window.ThemeView = (function (superClass) {
    extend(ThemeView, superClass);

    function ThemeView() {
        return ThemeView.__super__.constructor.apply(this, arguments);
    }

    ThemeView.prototype.el = document.body;

    ThemeView.prototype.initialize = function () {
        var body;
        body = $(document.body);
        this.isCollection = body.hasClass('template-collection');
        this.isListCollections = body.hasClass('template-list-collections');
        this.isProduct = body.hasClass('template-product') || body.hasClass('template-product-voucher') || body.hasClass('template-product-merch') || body.hasClass('template-product-trial') || body.hasClass('template-product-wetbag') || body.hasClass('template-product-pack') || body.hasClass('template-product-wash') || body.hasClass('template-product-panties') || body.hasClass('template-product-seeding') || body.hasClass('template-product-pack_limited');
        this.isCart = body.hasClass('template-cart');
        return this.currencySettings = JSON.parse(document.querySelector('[data-currency-data]').textContent);
    };

    ThemeView.prototype.render = function () {
        var switcherSelector;
        this.sections = new ThemeEditor();
        this.sections.register('header', this.headerSetup(this.sections));
        this.sections.register('pxs-map', this.mapSetup(this.sections));
        this.sections.register('pxs-video', this.videoSetup(this.sections));
        rimg.shopify.init();
        this.slideshowSection = new SlideshowSection({
            el: this.$el
        });
        if (this.isListCollections) {
            this.listCollectionsView = new ListCollectionsView({
                el: $('.collections-list')
            });
            this.listCollectionsView.render();
        }
        if (this.isProduct) {
            new ProductView({
                el: this.$el,
                bindSection: true
            });
        }
        if (this.isCart) {
            let cartPage = new CartPage();
            cartPage.ini($);

            document.addEventListener("limoniapps:discountninja:cart:updated", function (event) {
                let ninjaCart = event.detail.data[0];

                Shopify.getCart(function (cart) {
                    cartPage.updateDiscountCenterMessage(cart.item_count);
                    cartPage.updateHeadshipping(cart.total_price);
                });
            });
        }
        if (this.currencySettings.enable) {
            switcherSelector = '[data-currency-converter]';
            CurrencyConverter.init({
                switcherSelector: switcherSelector,
                priceSelector: '.money',
                shopCurrency: this.currencySettings.shopCurrency,
                defaultCurrency: this.currencySettings.defaultCurrency,
                displayFormat: this.currencySettings.displayFormat,
                moneyFormat: this.currencySettings.moneyFormat,
                moneyFormatNoCurrency: this.currencySettings.moneyFormatNoCurrency,
                moneyFormatCurrency: this.currencySettings.moneyFormatCurrency
            });
            $('.selected-currency', this.$el).text($(switcherSelector).val());
            this.currencyView = new CurrencyView({
                el: this.$el
            });
        }
        if ($('html').hasClass('lt-ie10')) {
            this.inputPlaceholderFix();
        }
        this.rteViews = [];
        this.richTextInit();
        window.ThemeUtils.externalLinks(this.$el);
        $(document).on('shopify:section:load', (function (_this) {
            return function (event) {
                window.ThemeUtils.externalLinks($(event.target));
                return _this.richTextInit();
            };
        })(this));
        return $(document).on('shopify:section:unload', (function (_this) {
            return function () {
                var j, len, ref, results, rte;
                ref = _this.rteViews;
                results = [];
                for (j = 0, len = ref.length; j < len; j++) {
                    rte = ref[j];
                    results.push(rte.undelegateEvents());
                }
                return results;
            };
        })(this));
    };

    ThemeView.prototype.richTextInit = function () {
        var j, len, ref, results, rte;
        ref = $('.rte');
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
            rte = ref[j];
            results.push(this.rteViews.push(new RTEView({
                el: rte
            })));
        }
        return results;
    };

    ThemeView.prototype.inputPlaceholderFix = function () {
        var input, j, len, placeholders, text;
        placeholders = $('[placeholder]');
        for (j = 0, len = placeholders.length; j < len; j++) {
            input = placeholders[j];
            input = $(input);
            if (!(input.val().length > 0)) {
                text = input.attr('placeholder');
                input.attr('value', text);
                input.data('original-text', text);
            }
        }
        placeholders.focus(function () {
            input = $(this);
            if (input.val() === input.data('original-text')) {
                return input.val('');
            }
        });
        return placeholders.blur(function () {
            input = $(this);
            if (input.val().length === 0) {
                return input.val(input.data('original-text'));
            }
        });
    };

    ThemeView.prototype.headerSetup = function (sections) {
        return {
            instances: {},
            init: function (instance) {
                return this.instances[instance.sectionId] = new HeaderView();
            },
            onSectionLoad: function (event) {
                var instance;
                instance = sections.getInstance(event);
                if (!this.instances[instance.sectionId]) {
                    return this.init(instance);
                }
            },
            onSectionUnload: function (event) {
                var instance, ref;
                instance = sections.getInstance(event);
                if ((ref = this.instances[instance.sectionId]) != null) {
                    ref.unBindEvents();
                }
                return delete this.instances[instance.sectionId];
            }
        };
    };

    ThemeView.prototype.mapSetup = function (sections) {
        return {
            instances: {},
            init: function (instance) {
                return this.instances[instance.sectionId] = new PxsMap({
                    el: instance.el,
                    data: instance.data
                });
            },
            onSectionLoad: function (event) {
                var instance;
                instance = sections.getInstance(event);
                if (!this.instances[instance.sectionId]) {
                    return this.init(instance);
                }
            },
            onSectionUnload: function (event) {
                var instance;
                instance = sections.getInstance(event);
                this.instances[instance.sectionId].onSectionUnload();
                return delete this.instances[instance.sectionId];
            }
        };
    };

    ThemeView.prototype.videoSetup = function (sections) {
        return {
            instances: {},
            init: function (instance) {
                return this.instances[instance.sectionId] = new PxsVideo({
                    el: instance.el,
                    data: instance.data
                });
            },
            onSectionLoad: function (event) {
                var instance;
                instance = sections.getInstance(event);
                if (!this.instances[instance.sectionId]) {
                    return this.init(instance);
                }
            },
            onSectionUnload: function (event) {
                var instance;
                instance = sections.getInstance(event);
                this.instances[instance.sectionId].onSectionUnload();
                return delete this.instances[instance.sectionId];
            }
        };
    };

    return ThemeView;

})(Backbone.View);

$(function () {
    window.theme = new ThemeView();
    return theme.render();
});

$(document).ready(function () {

    var enableOn = window.innerWidth > 320;
    var $items = $('.animate');

    var offset = 120

    var visibleSectionsInit = function () {
        visibleSection();
    }

    var visibleSection = function () {
        var top = window.pageYOffset + window.innerHeight - offset;

        // active items
        $items.each(function () {
            var $el = $(this);
            var animationStart = $el.offset().top;
            var elOffsetTop = $el.data('offset-top');
            var elOffsetBottom = $el.data('offset-bottom');

            if (elOffsetTop || elOffsetTop == 0) {
                animationStart = animationStart - offset + elOffsetTop;
            }

            if (elOffsetBottom || elOffsetBottom == 0) {
                var elHeight = $el.outerHeight();

                animationStart = animationStart - offset + elHeight - elOffsetBottom;
            }

            if (top > animationStart) {
                $el.addClass('is-visible');
            } else {
                // $el.removeClass('is-visible')
            }

        });
    }

    if (enableOn) {

        window.addEventListener('scroll', function () {
            window.requestAnimationFrame(visibleSection);
        });
        // initial call
        visibleSectionsInit();
    } else {
        $items.addClass('is-visible');
    }

});
// Commented out by Vojta S. --> Rivyio review app didnt work properly

// $(document).on('click', 'a[href^="#"]', function (event) {
//     event.preventDefault();

//     $('html, body').animate({
//         scrollTop: $($.attr(this, 'href')).offset().top - 70
//     }, 500);
// });

// Comment bellow added by Lenka T from noIT 28. 5. 2020


//Open mobile menu
var menuOpenBtn = document.getElementById('snuggs-nav-open');
var menuCloseBtn = document.getElementById('snuggs-nav-close');
var vueLinkSelector = document.querySelectorAll(".snuggs-nav-mobile__nav a[href*='#']")
var navbar = document.getElementById('nav');
var bodySelector = document.querySelector('html');

menuOpenBtn.addEventListener('click', menuToggle);
menuCloseBtn.addEventListener('click', menuToggle);
menuCloseBtn.addEventListener('click', menuToggle);

vueLinkSelector.forEach( link => {
    link.addEventListener('click', menuToggle);
})

function menuToggle() {
    if (navbar.classList.contains('menu-open')) {
        navbar.classList.remove('menu-open');
        bodySelector.classList.remove('no-scroll');


    } else {
        navbar.classList.add('menu-open');
        bodySelector.classList.add('no-scroll');
    }
}

//Open size chart on pruduct page
var sizechartLink = document.querySelector("a[href='#sizePopUp']");
var sizechartPopUp = document.getElementById('snuggs-sizechart');
var sizechartTable = document.querySelector('.snuggs-sizechart-inner');
var sizechartPopUpClose = document.getElementById('snuggs-sizechart-close');

if (sizechartLink && sizechartPopUpClose) {
    sizechartLink.addEventListener('click', sizechartToggle);
    sizechartPopUp.addEventListener('click', sizechartToggle);
    sizechartPopUpClose.addEventListener('click', sizechartToggle);
    sizechartTable.addEventListener('click', function (e) {
        e.stopPropagation();
    })
    document.addEventListener('keypress', function (e) {
        if (e.keyCode == 27) {
            sizechartToggle();
        }
    });

}

//Footer toggle
var footerTabs = document.querySelectorAll('.snuggs-footer-columns > h1');

footerTabs.forEach(function (currentItem) {
    currentItem.addEventListener('click', footerToggle.bind(currentItem));
})

function footerToggle() {
    this.parentElement.classList.toggle('open')
}

//Product slideshow pagination
$('.product-slideshow-pagination-point').click(function () {
    var imageSelector = '.product-image-' + $(this).attr('data-imagenumber');
    $(imageSelector).click();
})



// sold out variant on product
var soldoutchartLink = document.querySelector("a[href='#soldoutPopUp']");
var soldoutchartPopUp = document.getElementById('snuggs-soldoutchart');
var soldoutchartTable = document.querySelector('.snuggs-soldoutchart-inner');
var soldoutchartPopUpClose = document.getElementById('snuggs-soldoutchart-close');

if (soldoutchartLink && soldoutchartPopUpClose) {
    soldoutchartLink.addEventListener('click', soldoutchartToggle);
    soldoutchartPopUp.addEventListener('click', soldoutchartToggle);
    soldoutchartPopUpClose.addEventListener('click', soldoutchartToggle);
    soldoutchartTable.addEventListener('click', function (e) {
        e.stopPropagation();
    })
    document.addEventListener('keypress', function (e) {
        if (e.keyCode == 27) {
            soldoutchartToggle();
        }
    });

}

function soldoutchartToggle() {
    if (soldoutchartPopUp.classList.contains('open')) {
        soldoutchartPopUp.classList.remove('open');
    } else {
        soldoutchartPopUp.classList.add('open');
    }
}

//Open size chart on pruduct page
var sizechartLink2 = document.querySelector("a[href='#sizePopUp2']");
var sizechartPopUp2 = document.getElementById('snuggs-sizechart');
var sizechartTable2 = document.querySelector('.snuggs-sizechart-inner');
var sizechartPopUpClose2 = document.getElementById('snuggs-sizechart-close');

if (sizechartLink2 && sizechartPopUpClose2) {
    sizechartLink2.addEventListener('click', sizechartToggle);
    sizechartPopUp2.addEventListener('click', sizechartToggle);
    sizechartPopUpClose2.addEventListener('click', sizechartToggle);
    sizechartTable2.addEventListener('click', function (e) {
        e.stopPropagation();
    })
    document.addEventListener('keypress', function (e) {
        if (e.keyCode == 27) {
            sizechartToggle();
        }
    });

}

function sizechartToggle() {
    if (sizechartPopUp.classList.contains('open')) {
        sizechartPopUp.classList.remove('open');
    } else {
        sizechartPopUp.classList.add('open');
    }
}


///////
////////////////////////////
///////

const QUANTITY_ID = 'quantity';
const QUANTITY_ADD_ID = 'quantity-add';
const QUANTITY_SUB_ID = 'quantity-sub';

let quantityElement = document.getElementById(QUANTITY_ID);
let quantityAddElement = document.getElementById(QUANTITY_ADD_ID);
let quantitySubElement = document.getElementById(QUANTITY_SUB_ID);

if (elementExists(quantityElement) && elementExists(quantityAddElement)
    && elementExists(quantitySubElement)) {

    quantityAddElement.addEventListener("click", function () {
        quantityElement.value = parseInt(quantityElement.value) + 1;
    });

    quantitySubElement.addEventListener("click", function () {
        quantityElement.value = parseInt(quantityElement.value) - 1;
        if (quantityElement.value < 0) {
            quantityElement.value = 0;
        }
    });
}

/**
 * @param {HTMLElement} element
 * @return {boolean}
 */
function elementExists(element) {
    return typeof (element) != 'undefined' && element != null
}

///////
////////////////////////////


function Cart() {
    const MONEY_FORMAT = Theme.moneyFormat;
    const WRAPPER_SELECTOR = '#nav-cart__wrapper';
    const ITEMS_WRAPPER = '#cart';
    const HANDLER_SELECTOR = '.js-cart-handler';
    const OPEN_CLASS = 'drawer-open';
    const DISCOUNT_HIDDEN_ELEMENTS_SELECTOR = '.cart-price--discounts';
    const MONEY_DESCRIPTION_SELECTOR = '.cart-price--mezi .money__description';
    const SUBTOTAL_SELECTOR = '.cart-price--mezi .money';
    const DISCOUNT_SELECTOR = '.cart-drawer .cart-price--discounts .money';
    const TOTAL_SELECTOR = '.cart-price--total .money';
    const LOGISTICS_DESCRIPTION = '.cart-price--logistics .money__description';
    const LOGISTICS_VALUE = '.cart-price--logistics .money';
    const HIDDEN_CLASS = 'hidden';
    const DISCOUNT_CENTER_SELECTOR = '.cart-discount-center';
    const BADGE_CLASSNAME = 'cart-link__count';
    const ITEM_QUANTITY_SELECTOR = '.cart-item-quantity-display';
    const UPDATE_QUANTITY_BUTTONS_SELECTOR = '.cart-item-increase,.cart-item-decrease';
    const REMOVE_ITEM_BUTTON = '.js-cart-item-remove';
    const ADD_ITEM_BUTTON_CLASS = 'cart-item-increase';

    const NON_MENSTRUAL_TYPE = ['Wash', 'Pack', 'Merch', 'Panties', 'Gift Card', 'Accessory', 'Trial', 'Seeding', 'Bra']

    this.jquery = null;
    this.config = {};

    /**
     * @param {jQuery} jquery
     */
    this.ini = function (jquery) {
        this.jquery = jquery;

        let wrapper = $(WRAPPER_SELECTOR);
        this.config = {
            freeShippingTrashold: wrapper.data('freeShippingTrashold'),
            freeShippingDescription: wrapper.data('freeShippingDescription'),
            freeShippingValue: wrapper.data('freeShippingValue'),
            heading: wrapper.data('heading'),
            cartIsEmpty: wrapper.data('cartIsEmpty'),
            totalHeading: wrapper.data('totalHeading'),
            subtotalHeading: wrapper.data('subtotalHeading'),
            discountHeading: wrapper.data('discountHeading'),
            completeOrder: wrapper.data('completeOrder'),
            pcs: wrapper.data('pcs'),
            showCart: wrapper.data('showCart'),
            estimatedShippingHeading: wrapper.data('estimatedShippingHeading'),
            logisticsPrice: wrapper.data('logisticsPrice'),
            discountCounter: wrapper.data('discountCounter'),
            size: wrapper.data('size'),
            productSuggestion: wrapper.data('productSuggestion'),
            removeItem: wrapper.data('removeItem'),
            menstrualPants: wrapper.data('menstrualPants')
        };
    }

    this.openCart = function() {
        $(HANDLER_SELECTOR).addClass(OPEN_CLASS);
        $("#shopify-section-snuggs-promotion").addClass('hide');
    }

    this.updateQuantity = function (e) {
        var newQuantity, oldQuantity, productPrice, productQuantity, productRow,
            productTitle, variant;
        productRow = $(e.target).parents('tr');
        productTitle = productRow.find('.cart-title').text();
        productPrice = productRow.find('td.cart-item-total .money');
        productQuantity = productRow.find(ITEM_QUANTITY_SELECTOR);
        variant = productRow.data('variant');
        oldQuantity = parseInt(productQuantity.val(), 10);
        if ($(e.target).hasClass(ADD_ITEM_BUTTON_CLASS)) {
            newQuantity = oldQuantity + 1;
        } else {
            newQuantity = oldQuantity <= 1 ? 0 : oldQuantity - 1;
        }
        if (
            variantAvailability[variant].policy === INVENTORY_POLICY_DENY
            && newQuantity > variantAvailability[variant].quantity
            && newQuantity > oldQuantity
        ) {
            return;
        }

        productRow.find(ITEM_QUANTITY_SELECTOR).val(newQuantity);

        let self = this;
        let target = $(e.target);

        return Shopify.changeItem(variant, newQuantity, (function (_this) {
            return function (cart) {
                if (!self.jquery('body').hasClass('template-cart')) {
                    // Serves cart at cart page only, not in dropdown
                    return;
                }

                if (newQuantity === 0) {
                    return location.reload();
                } else {
                    let item = cart.items.filter(function (item) {
                        return item.id === variant;
                    })[0];
                    self.updateRowAmount(item, target);

                    let outOfStockContainer = target.closest('.cart-item-product__information');
                    let button = target.closest('div').find('.' + ADD_ITEM_BUTTON_CLASS);
                    if (
                        variantAvailability[item.id].policy === INVENTORY_POLICY_DENY
                        && item.quantity >= variantAvailability[item.id].quantity
                    ) {
                        button.addClass(INCREASE_BUTTON_DISABLED_CLASSNAME);
                        addOutOfStockMessage(outOfStockContainer, variantAvailability[item.id].quantity);
                    } else {
                        button.removeClass(INCREASE_BUTTON_DISABLED_CLASSNAME);
                        removeOutOfStockMessage(outOfStockContainer);
                    }
                }
            };
        })(this));
    };

    this.renderCart = function (ninjaCart) {
        if (ninjaCart.items.length === 0) {
            this.renderEmptyCart();
            this.updateItemsCountBadge(0);
            return;
        }

        if (this.jquery(ITEMS_WRAPPER).length < 1) {
            this.renderCartWithGoods(ninjaCart);
        }

        self = this;
        Shopify.getCart(function (cart) {
            console.log(cart, ninjaCart);
            self.renderAllItems(cart.items,ninjaCart.items);
            self.updateItemsCountBadge(cart.item_count);
            self.addDiscountCenterMessage(cart.item_count);
            if (ninjaCart.total_discount > 0) {
                $(DISCOUNT_HIDDEN_ELEMENTS_SELECTOR).removeClass(HIDDEN_CLASS);
            } else {
                $(DISCOUNT_HIDDEN_ELEMENTS_SELECTOR).addClass(HIDDEN_CLASS);
            }

            self.updateMoneyDescription(cart.item_count);
            self.updateAmounts(
                100 * ninjaCart.total_original_price,
                100 * ninjaCart.total_discount,
                100 * ninjaCart.total_discounted_price
            );
            self.productSuggestion(cart.items);
        });
    }

    this.renderEmptyCart = function () {
        let wrapper = $(WRAPPER_SELECTOR);
        wrapper.html(buildEmptyCart(
            this.config.heading,
            this.config.cartIsEmpty
        ));
    }

    this.renderCartWithGoods = function (ninjaCart) {
        let wrapper = $(WRAPPER_SELECTOR);
        wrapper.html(buildCart(    {
            heading: this.config.heading,
            totalHeading: this.config.totalHeading,
            subtotalHeading: this.config.subtotalHeading,
            discountHeading: this.config.discountHeading,
            subtotal: Shopify.formatMoney(100 * ninjaCart.total_original_price, MONEY_FORMAT).replace(/\s/g, '&nbsp;'),
            total: Shopify.formatMoney(100 * ninjaCart.total_discounted_price, MONEY_FORMAT).replace(/\s/g, '&nbsp;'),
            discount: Shopify.formatMoney(100 * ninjaCart.total_discount, MONEY_FORMAT).replace(/\s/g, '&nbsp;'),
            subtotalBeforeDiscount: Shopify.formatMoney(100 * (ninjaCart.total_discounted_price + ninjaCart.total_discount), MONEY_FORMAT).replace(/\s/g, '&nbsp;'),
            itemCount: ninjaCart.items.length,
            pcs: this.config.pcs,
            show: this.config.showCart,
            completeOrder: this.config.completeOrder,
            productSuggestion: this.config.productSuggestion,
            currency: ninjaCart.Currency
        }));
    }

    this.renderAllItems = function (items, originalItems) {
        self = this;
        this.jquery(ITEMS_WRAPPER).html('');
        this.jquery.each(items, function (index, item) {
            self.addItem(item, originalItems.find(original=>original.Product.VariantId == item.id ));
        });
    }

    this.addItem = function (item, originalItem) {
        let self = this;
        let row = buildCartRow({
            variantId: item.id,
            title: item.product_title,
            getTitle: function() { 
                if (!NON_MENSTRUAL_TYPE.includes(item.product_type) && !item.product_type.includes('Swimwear') && !item.product_type.includes('Everyday')) {
                    return `${self.config.menstrualPants } – ${ item.product_title }`;
                } else { 
                    return item.product_title;
                };
            },
            description: item.product_description,
            getDescription: function(){
                if(!NON_MENSTRUAL_TYPE.includes(item.product_type)) return item.product_description
                else return ""
            },
            url: item.url,
            imgSrc: item.image,
//            limoniappsDiscountninjaCartKey: '32528584409191:308a1ea3eac3f3cb68a4320ab8ddf318',
            price: Shopify.formatMoney(item.line_price, Theme.moneyFormat),
            priceOriginal: (originalItem.Product.OriginalCompareAtPrice * item.quantity * 100) > item.line_price ? Shopify.formatMoney((originalItem.Product.OriginalCompareAtPrice * item.quantity * 100), Theme.moneyFormat) : "",
            type: item.product_type,
            quantity: item.quantity,
            getVariantText: function() {
                if (item.product_type == "Accessory") {
                    return "";
                } else if (item.product_type == "Gift Card" || item.product_type == "Wash") {
                    return item.variant_title;
                } else {
                    return self.config.size + " " + item.variant_title;
                }
            }
        });

        $('#cart').append(row);

        $(document)
            .off('click', UPDATE_QUANTITY_BUTTONS_SELECTOR)
            .on('click', UPDATE_QUANTITY_BUTTONS_SELECTOR, function(e){
                self.updateQuantity(e);
            })
            .off('click', REMOVE_ITEM_BUTTON)
            .on('click', REMOVE_ITEM_BUTTON, function(e){
                self.removeItem(e);
            })

        ;
    }

    this.updateItemsCountBadge = function (count) {
        let badges = document.getElementsByClassName(BADGE_CLASSNAME);
        for (let i = 0; i < badges.length; ++i) {
            let badge = badges[i];
            if (count > 0) {
                badge.classList.remove(HIDDEN_CLASS);
            } else {
                badge.classList.add(HIDDEN_CLASS);
            }
            badge.innerHTML = count;
        }
    }

    this.addDiscountCenterMessage = function (count) {
        if (this.config.discountCounter.hasOwnProperty(count) ) {
            this.jquery(DISCOUNT_CENTER_SELECTOR).text(
                this.config.discountCounter[count]
            ).removeClass(HIDDEN_CLASS);
        } else {
            this.jquery(DISCOUNT_CENTER_SELECTOR).text('').addClass(HIDDEN_CLASS);
        }
    }

    this.getProductTypes = function (){
        let array = []
        discountNinjaContext.Cart.items.forEach(e=> { array.push(e.product_type)})

        return array
    }

    this.updateMoneyDescription = function (count) {
        let elements = document.querySelectorAll(MONEY_DESCRIPTION_SELECTOR);
        
        for (let i = 0; i < elements.length; ++i) {
            let element = elements[i];
            element.innerHTML = `${this.config.subtotalHeading} (${count} ${this.config.pcs}):`;
        }
    }

    this.updateAmounts = function (subtotal, discount, total) {
        let elements = document.querySelectorAll(SUBTOTAL_SELECTOR);
        let productTypes = this.getProductTypes()

        for (let i = 0; i < elements.length; ++i) {
            let element = elements[i];
            element.innerHTML = Shopify.formatMoney(subtotal, MONEY_FORMAT).replace(/\s/g, '&nbsp;');
        }

        elements = document.querySelectorAll(DISCOUNT_SELECTOR);
        for (let i = 0; i < elements.length; ++i) {
            let element = elements[i];
            element.innerHTML = Shopify.formatMoney(discount, MONEY_FORMAT).replace(/\s/g, '&nbsp;');
        }
        if (total >= this.config.freeShippingTrashold || productTypes.includes('Wash') || (productTypes.includes("Trial") && location.href.includes("snuggs.de")) || productTypes == 'Gift Card' ) {
            this.jquery(LOGISTICS_DESCRIPTION).html(this.config.freeShippingDescription);
            this.jquery(LOGISTICS_VALUE).html(this.config.freeShippingValue);
        } else {
            this.jquery(LOGISTICS_DESCRIPTION).html(this.config.estimatedShippingHeading);
            this.jquery(LOGISTICS_VALUE).html(
                Shopify.formatMoney(this.config.logisticsPrice, MONEY_FORMAT).replace(/\s/g, '&nbsp;')
            );
        }

        if (total < this.config.freeShippingTrashold && !productTypes.includes('Wash') && productTypes != 'Gift Card' && (productTypes.includes("Trial") && location.href.includes("snuggs.de"))) {
            total += this.config.logisticsPrice;
        }
        elements = document.querySelectorAll(TOTAL_SELECTOR);
        for (let i = 0; i < elements.length; ++i) {
            let element = elements[i];
            element.innerHTML = Shopify.formatMoney(total, MONEY_FORMAT).replace(/\s/g, '&nbsp;');
        }
        countSubtotalCart(subtotal);
    }

    /**
     * @param {Object} cartItem
     * @param {jQuery} target
     */
    this.updateRowAmount = function (cartItem, target) {
        const row = target.parents("tr");
        const comparePrice = row[0].dataset["comparePrice"];
        let moneyWrapper = target.parents('tr').find('.cart-item-total-wrap');
        // moneyWrapper.find('.money--original')[0].innerHTML = '';
        // moneyWrapper.find('.money:not(.money--original)')[0].innerHTML =
        // Shopify.formatMoney(cartItem.line_price, MONEY_FORMAT).replace(/\s/g, '&nbsp;');
        const comparePriceWrapper = moneyWrapper.find('.money--original')[0];
        if (!!comparePrice && !!comparePriceWrapper) {
            comparePriceWrapper.innerHTML = Shopify.formatMoney(parseInt(comparePrice) * cartItem.quantity, MONEY_FORMAT).replace(/\s/g, '&nbsp;');
        }
        moneyWrapper.find('.money:not(.money--original)')[0].innerHTML = Shopify.formatMoney(cartItem.line_price, MONEY_FORMAT).replace(/\s/g, '&nbsp;');
    }

    this.removeItem = function (e) {
        let variant = $(e.target).parents('tr').data('variant');

        return Shopify.removeItem(variant, (function (_this) {
            return function (cart) {
            };
        })(this));
    }

    this.productSuggestion = function(itemsInCart){
        let productTypesToNotSuggest = ['Wash', 'Accessory'];
        let elementToShow = document.querySelectorAll('.drawer-suggestion')

        function isNotSuggestion(product, arrayToCheck){
            for(const {product_type: pt } of product){
                if(arrayToCheck.includes(pt)) return true;
            }
        }
        elementToShow.forEach(el => {
            isNotSuggestion(itemsInCart, productTypesToNotSuggest) ? el.style.display = 'none' : el.style.display = 'flex';
        })
    }
}

/**
 * Handle popup behavior
 *
 * Popup classes and ids can be absolutely arbitrary. The JS is independent on it.
 *
 * An element to fire popup must have two properties:
 * - a TRIGGER_CLASS as classname
 * - DATA_POPUP_SELECTOR attribute, which must contain CSS selector defining
 *   related popup (for example .xyz)
 *
 * Fire popup
 * ==========
 * If an element with a classname TRIGGER_CLASS is clicked, then:
 * - OPEN_CLASS is added to a related popup (.xyz; defined in its DATA_POPUP_SELECTOR)
 *
 * Close popup
 * ===========
 * Popup can have more closers marked by the class CLOSER_CLASS. They must
 * be a DATA_POPUP_SELECTOR's (.xyz) children.
 *
 * If an element with class CLOSER_CLASS is clicked, then:
 * - OPEN_CLASS is removed from the related popup (.xyz; defined in its DATA_POPUP_SELECTOR)
 *
 * An example showing only JS functionality:
 * =========================================
 * <div class="xyz"><!-- in an active state the POPUP_OPEN_CLASS is added -->
 *     popup content
 *     <span class="popup__closer">close</span>
 * </div>
 *
 * <span class="popup__trigger" data-popup-selector=".xyz">popup trigger</span>
 *
 *
 * More realistic example:
 * =======================
 * <div class="popup popup-xyz"><!-- in the active state the POPUP_OPEN_CLASS is removed -->
 *     <div class="popup__inner">
 *          popup content
 *          <span class="popup__closer">close</span>
 *     </div>
 * </div>
 *
 * <span class="popup__trigger" data-popup-selector=".popup-xyz">popup trigger</span>
 *
 * All popups are intializet by Popup.ini() call.
 */
function Popup () {
    const OPEN_CLASS = 'open';

    const TRIGGER_CLASS = 'popup__trigger';
    const CLOSER_CLASS = 'popup__closer';
    const DATA_POPUP_SELECTOR = 'data-popup-selector';

    this.ini = function () {
        this.addListeners();
    }

    this.addListeners = function () {
        let handlers = document.querySelectorAll('.' + TRIGGER_CLASS);
        for (let i = 0; i < handlers.length; ++i) {
            let handler = handlers[i];
            let popupSelector = handler.getAttribute(DATA_POPUP_SELECTOR);
            this.addListenerToOpener(handler, popupSelector);
            this.addListenersToClosers(popupSelector);
        }
    }

    this.addListenerToOpener = function (handler, popupSelector) {
        let self = this;
        handler.addEventListener('click', function() {
            self.open(popupSelector);
        });
    }

    this.addListenersToClosers = function (popupSelector) {
        let self = this;
        let popup = document.querySelector(popupSelector);
        popup.addEventListener('click', function (event) {
            if (event.target.matches(popupSelector)) {
                self.close(popupSelector);
            }
        });

        let closers = popup.querySelectorAll('.' + CLOSER_CLASS);
        for (let i = 0; i < closers.length; ++i) {
            let closer = closers[i];
            closer.addEventListener('click', function () {
                self.close(popupSelector);
            });
        }
    }

    this.open = function (popupSelector) {
        document.querySelector(popupSelector).classList.add(OPEN_CLASS);
    }

    this.close = function (popupSelector) {
        document.querySelector(popupSelector).classList.remove(OPEN_CLASS);
    }
}

/**
 * Handle an accordion with only one fold open at a time
 *
 *   <div class="accordion">
 *       <div class="accordion__fold">
 *           <h3>aaaa</h3>
 *           <div class="accordion__fold__inner">AAAA</div>
 *       </div>
 *       <div class="accordion__fold">
 *           <h3>bbb</h3>
 *           <div class="accordion__fold__inner">BBB</div>
 *       </div>
 *       <div class="accordion__fold">
 *           <h3>ccc</h3>
 *           <div class="accordion__fold__inner">CCC</div>
 *       </div>
 *   </div>
 */

function Accordion () {
    const ACCORDION_CONTAINER_CLASS = 'accordion';
    const ACCORDION_FOLD_CLASS = 'accordion__fold';
    const ACTIVE_FOLD_CLASS = 'active';

    this.ini = function () {
        let accordions = document.querySelectorAll('.' + ACCORDION_CONTAINER_CLASS);
        for (let i = 0; i < accordions.length; ++i) {
            let accordion = accordions[i];
            this.addListeners(accordion);
        }
    }

    this.addListeners = function (accordion) {
        let self = this;
        let folds = accordion.querySelectorAll('.' + ACCORDION_FOLD_CLASS);
        for (let i = 0; i < folds.length; ++i) {
            let fold = folds[i];

            fold.addEventListener('click', function () {
                self.toggleFold(accordion, fold);
            });
        }
    }

    this.toggleFold = function (accordion, fold) {
        let open = fold.classList.contains(ACTIVE_FOLD_CLASS);
        let folds = accordion.querySelectorAll('.' + ACCORDION_FOLD_CLASS);
        for (let i = 0; i < folds.length; ++i) {
            folds[i].classList.remove(ACTIVE_FOLD_CLASS);
        }
        if (!open) {
            fold.classList.add(ACTIVE_FOLD_CLASS);
        }
    }
}

function ProductFilters() {
    const WRAPPER_ID = 'product-filters';
    const OPEN_ON_MOBILE_CLASS = 'mobile-open';
    const OPEN_MOBILE_TRIGGER_ID = 'snuggs-mobile-menu-product-filters';
    const CLOSE_MOBILE_TRIGGER_ID = 'close-filters-on-mobile';

    const DATA_TAGS = 'data-tags';
    const DATA_PRODUCT_FILTER = 'data-product-filter';

    // If some tag is not present on a page at all related filter is disabled.
    // Its deactivation is made by adding the FILTER_HIDE_CLASS to an element
    // which is closest heading toward the document root and which matches to the
    // FILTER_WRAPPER_SELECTOR.
    const FILTER_WRAPPER_SELECTOR = 'li';       // CSS selector
    const FILTER_HIDE_CLASS = 'unused-filter';  // CSS class name

    const HIDE_PRODUCT_CLASS = 'hidden-product';
    const VISIBLE_PRODUCT_COUNTER_CLASS = 'product-number__count';

    const REVIEW_LIST_ID = 'product-filters-review__list';
    const REVIEW_ID = 'product-filters-review';
    const REVIEW_DELETE_ALL_ID = 'product-filters-review__delete-all';
    const REVIEW_ACTIVE_CLASS = 'active';

    const EMPTY_STATE_CONTAINER_ID = 'no-products';
    const EMPTY_STATE_CONTAINER_ACTIVE_CLASS = 'no-products--open';

    const GROUP_PREFIXES = ['strih', 'absorbce', 'material', 'barva'];

    this.products = [];
    this.filters = [];
    this.jquery = null;
    this.visibleProductCounters = [];
    this.emptyStateElement = null;
    this.filterDeleter = null;

    /**
     * @param {jQuery} jquery
     */
    this.ini = function (jquery) {
        this.jquery = jquery;
        this.visibleProductCounters =
            document.getElementsByClassName(VISIBLE_PRODUCT_COUNTER_CLASS);
        this.emptyStateElement =
            document.getElementById(EMPTY_STATE_CONTAINER_ID);
        this.filterDeleter = document.getElementById(REVIEW_DELETE_ALL_ID);

        if (
            document.getElementById(WRAPPER_ID) === null
            || this.visibleProductCounters === null
            || this.emptyStateElement === null
            || this.filterDeleter === null
        ) {
            return;
        }

        this.initializeVariables();
        this.disableUnusedFilters(
            this.findUsedTags()
        );

        this.addHandlers();
        this.updateCounter();
    }

    this.addHandlers = function () {
        let self = this;
        for (let i = 0; i < this.filters.length; ++i) {
            this.filters[i].addEventListener('click', function() {
                self.updateFilters();
            });
        }

        this.filterDeleter.addEventListener('click', function() {
            self.deleteAllFilters();
        });

        let mobileOpenTrigger = document.getElementById(OPEN_MOBILE_TRIGGER_ID);
        mobileOpenTrigger.addEventListener('click', function() {
            self.toggleOnMobile();
        });

        let mobileCloseTrigger = document.getElementById(CLOSE_MOBILE_TRIGGER_ID);
        mobileCloseTrigger.addEventListener('click', function() {
            self.closeOnMobile();
        });
    }

    this.updateFilters = function () {
        this.evaluateFilters();
        this.udateProductReviews();
    }

    this.initializeVariables = function () {
        this.products = document.querySelectorAll('[' + DATA_TAGS + ']');
        this.filters = document.querySelectorAll('[' + DATA_PRODUCT_FILTER + ']');

        for (let i = 0; i < this.filters.length; ++i) {
            let filter = this.filters[i];
            filter.setAttribute("id", filter.getAttribute(DATA_PRODUCT_FILTER));
        }
    }

    this.findUsedTags = function () {
        let usedTags = [];
        for (let i = 0; i < this.products.length; ++i) {
            let product = this.products[i];
            let tags = JSON.parse(product.getAttribute(DATA_TAGS));
            usedTags = this.setUsedTags(usedTags, tags);
        }

        return usedTags;
    }

    this.setUsedTags = function (usedTags, tags) {
        for (let i = 0; i < tags.length; ++i) {
            usedTags[tags[i]] = true;
        }

        return usedTags;
    }

    this.disableUnusedFilters = function  (usedTags) {
        for (let i = 0; i < this.filters.length; ++i) {
            let filter = this.filters[i];
            let tag = filter.getAttribute(DATA_PRODUCT_FILTER);

            if (! usedTags.hasOwnProperty(tag)) {
                this.disableFilter(filter);
            }
        }
    }

    this.disableFilter = function (filter) {
        let wrapper = filter.closest(FILTER_WRAPPER_SELECTOR);
        wrapper.classList.add(FILTER_HIDE_CLASS);
    }

    this.evaluateFilters = function () {
        let activeFilters = this.getActiveFilters();
        this.setAllProductsVisible();
        this.hideFilteredProducts(activeFilters);
        let visible = this.updateCounter();
        this.displayEmptyState(visible);
    }

    this.displayEmptyState = function (visible) {
        if (visible > 0) {
            this.emptyStateElement.classList.remove(EMPTY_STATE_CONTAINER_ACTIVE_CLASS);
        } else {
            this.emptyStateElement.classList.add(EMPTY_STATE_CONTAINER_ACTIVE_CLASS);
        }
    }

    this.setAllProductsVisible = function () {
        for (let i = 0; i < this.products.length; ++i) {
            this.products[i].classList.remove(HIDE_PRODUCT_CLASS);
        }
    }

    this.hideFilteredProducts = function (activeFilters) {
        let filterGroups = this.groupFilters(activeFilters);

        for (let i = 0; i < GROUP_PREFIXES.length; ++i) {
            let prefix = GROUP_PREFIXES[i];
            this.applyFilterGroup(filterGroups[prefix]);
        }
    }

    this.applyFilterGroup = function (filterGroup) {
        if (filterGroup.length === 0) {
            return;
        }

        for (let i = 0; i < this.products.length; ++i) {
            let product = this.products[i];

            if (product.classList.contains(HIDE_PRODUCT_CLASS)) {
                continue;
            }

            let tags = JSON.parse(product.getAttribute(DATA_TAGS));

            if (this.isProductVisible(filterGroup, tags)) {
                product.classList.remove(HIDE_PRODUCT_CLASS);
            } else {
                product.classList.add(HIDE_PRODUCT_CLASS);
            }
        }
    }

    this.groupFilters = function (activeFilters) {
        let groupedFilters = {};
        for (let i = 0; i < GROUP_PREFIXES.length; ++i) {
            let prefix = GROUP_PREFIXES[i];
            groupedFilters[prefix] = [];
            for (let j = 0; j < activeFilters.length; ++j) {
                let filter = activeFilters[j];
                if (filter.indexOf(prefix) === 0) {
                    groupedFilters[prefix].push(filter);
                }
            }
        }

        return groupedFilters;
    }

    this.updateCounter = function () {
        let hidden = this.getHiddenProducts();
        let visible = this.products.length - hidden.length;
        for (let i=0; i < this.visibleProductCounters.length; ++i) {
            let visibleProductCounter = this.visibleProductCounters[i];
            visibleProductCounter.innerHTML = visible.toString();
        }

        return visible;
    }

    this.getHiddenProducts = function () {
        return document.querySelectorAll('.' + HIDE_PRODUCT_CLASS);
    }

    this.isProductVisible = function (activeFilters, tags) {
        return this.intersect(activeFilters, tags).length > 0;
    }

    this.intersect = function (array1, array2) {
        return array1.filter(function(n) {
            return array2.indexOf(n) !== -1;
        });
    }

    this.getActiveFilters = function () {
        let activeFilter = [];

        for (let i = 0; i < this.filters.length; ++i) {
            if (this.filters[i].checked) {
                activeFilter.push(this.filters[i].getAttribute(DATA_PRODUCT_FILTER));
            }
        }

        return activeFilter;
    }

    this.udateProductReviews = function () {
        let anyFilterChecked = false;
        let filterReviewList = document.getElementById(REVIEW_LIST_ID);
        filterReviewList.innerHTML = '';

        for (let i = 0; i < this.filters.length; ++i) {
            let filter = this.filters[i];
            if (filter.checked) {
                this.addFilterToReview(filterReviewList, filter.id);
                anyFilterChecked = true;
            }
        }

        filterReviewList.appendChild(this.filterDeleter);

        let filterReview = document.getElementById(REVIEW_ID);
        if (anyFilterChecked) {
            filterReview.classList.add(REVIEW_ACTIVE_CLASS);
        } else {
            filterReview.classList.remove(REVIEW_ACTIVE_CLASS);
        }
    }

    this.addFilterToReview = function (ul, id) {
        let text = this.findFilterName(id);
        let li = document.createElement("li");
        li.appendChild(document.createTextNode(text));
        ul.appendChild(li);

        let self = this;
        li.addEventListener('click', function() {
            document.getElementById(id).checked = false;
            self.updateFilters();
        });
    }

    this.findFilterName = function (id) {
        let element = document.getElementById(id).closest('label');
        return document.getElementById(id).closest('label').innerText;
    }

    this.deleteAllFilters = function () {
        for (let i = 0; i < this.filters.length; ++i) {
            let filter = this.filters[i];
            filter.checked = false;
        }
        this.updateFilters();
    }

    this.toggleOnMobile = function () {
        document.getElementById(WRAPPER_ID).classList.toggle(OPEN_ON_MOBILE_CLASS);
    }

    this.closeOnMobile = function () {
        document.getElementById(WRAPPER_ID).classList.remove(OPEN_ON_MOBILE_CLASS);
    }
}

function CartPage() {
    const WRAPPER_SELECTOR = '#cart__config';
    const HEADBUTTON_SELECTOR = '.cart__headbutton';
    const HEADSHIPPING_SELECTOR = '.cart__headshipping';
    const HIDDEN_CLASS = 'hidden';

    this.jquery = null;
    this.config = {};

    /**
     * @param {jQuery} jquery
     */
    this.ini = function (jquery) {
        this.jquery = jquery;

        let wrapper = $(WRAPPER_SELECTOR);
        this.config = {
            discountCounter: wrapper.data('discountCounter'),
            freeShippingBreak: wrapper.data('freeShippingBreak')
        };
    }

    this.updateDiscountCenterMessage = function (count) {
        if (this.config.discountCounter.hasOwnProperty(count) ) {
            this.jquery(HEADBUTTON_SELECTOR).text(
                this.config.discountCounter[count]
            ).removeClass(HIDDEN_CLASS);
        } else {
            this.jquery(HEADBUTTON_SELECTOR).text('').addClass(HIDDEN_CLASS);
        }
    }

    this.updateHeadshipping = function (totalPrice) {
        if (totalPrice >= this.config.freeShippingBreak ) {
            this.jquery(HEADSHIPPING_SELECTOR).addClass(HIDDEN_CLASS);
        } else {
            this.jquery(HEADSHIPPING_SELECTOR).removeClass(HIDDEN_CLASS);
        }
    }
}


function addReviewStars() {
    const PARENT_SELECTOR = ".wc_average_review_stars_lyt_2";
    const DATA_SELECTOR = ".wc_average_review_count_lyt_2";
    const SVG_STARS = `
    <svg width="132" height="24" viewBox="0 0 132 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0L15.5267 7.1459L23.4127 8.2918L17.7063 13.8541L19.0534 21.7082L12 18L4.94658 21.7082L6.29366 13.8541L0.587322 8.2918L8.47329 7.1459L12 0Z" fill="#FE5B00"/>
    <path d="M39 0L42.5267 7.1459L50.4127 8.2918L44.7063 13.8541L46.0534 21.7082L39 18L31.9466 21.7082L33.2937 13.8541L27.5873 8.2918L35.4733 7.1459L39 0Z" fill="#FE5B00"/>
    <path d="M66 0L69.5267 7.1459L77.4127 8.2918L71.7063 13.8541L73.0534 21.7082L66 18L58.9466 21.7082L60.2937 13.8541L54.5873 8.2918L62.4733 7.1459L66 0Z" fill="#FE5B00"/>
    <path d="M93 0L96.5267 7.1459L104.413 8.2918L98.7063 13.8541L100.053 21.7082L93 18L85.9466 21.7082L87.2937 13.8541L81.5873 8.2918L89.4733 7.1459L93 0Z" fill="#FE5B00"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M121.999 4.0513L120 0L116.473 7.1459L108.587 8.2918L114.294 13.8541L112.947 21.7082L120 18L121.999 19.0512V4.0513Z" fill="#FE5B00"/>
    <path d="M120 1.12978L123.078 7.36718L123.195 7.6029L123.455 7.6407L130.338 8.64092L125.357 13.4961L125.169 13.6795L125.214 13.9386L126.389 20.7942L120.233 17.5574L120 17.4351L119.767 17.5574L113.611 20.7942L114.786 13.9386L114.831 13.6795L114.643 13.4961L109.662 8.64092L116.545 7.6407L116.805 7.6029L116.922 7.36718L120 1.12978Z" stroke="#FE5B00"/>
    </svg>    
`

let data = ""


    
    this.ini = function(){
        this.getData(DATA_SELECTOR)
    }

    // Interval function 
    this.getData = function(data_selector) {
        var timer = setInterval( () => {
            let loaded = document.querySelector(data_selector)

            if(loaded){
                clearInterval(timer)
                data = loaded.innerHTML
                return this.createStars()
            }
        }, 300) 
    }

    this.createStars = function(){
        INSERT_HERE = document.querySelector(PARENT_SELECTOR)
        $(INSERT_HERE).append(SVG_STARS);

        return this.colorStarsAccordingToData(data)
    }

    this.colorStarsAccordingToData = function(data) {
        const svg = document.querySelector(PARENT_SELECTOR + " > svg") 
        console.log(svg.children);

        // switch (parseInt(data)){
        //     case 1:
        //     case 2:
        //     case 3:
        //     case 4:
        //     case 5:
        // }
    }
}


// Delete unknown characters from product review app

function ReplaceReviewCharacters() {
    const DESCRIPTION_SELECTOR = ".wc_review_text p[itemprop='description']"
    const WEIRD_CHARACTERS = /�/g
    const BUTTON_SELECTOR = "button.wc_review_btn.wc_review_load_more"
    
    this.ini  = function(){

            this.replaceCharacters(DESCRIPTION_SELECTOR, WEIRD_CHARACTERS);
            
            let buttonNode = document.querySelector(BUTTON_SELECTOR)

            if (buttonNode){
                buttonNode.addEventListener("click", e => {
                    
                    // Wait for reviews load
                    setTimeout( e => {
                        this.replaceCharacters(DESCRIPTION_SELECTOR, WEIRD_CHARACTERS);
                    }, 300)
                    
                })
            }
    }

    this.replaceCharacters = function(nodes_selector, characters){
        let nodesToReplace = document.querySelectorAll(nodes_selector)
        
        if(nodesToReplace){
            nodesToReplace.forEach(element => {
                element.innerHTML = element.innerHTML.replace(characters, "")
            });
        }
    }
}    


// Shopify builders custom scripts
const SB = {
    // Add class .toggle-click on a element
    // Inside the .toggle-click element must be .toggle-hide part that will be hidden on click
    // If you want toggle to be hidden on start add .toggle-hidden-on-start class to parent element (.toggle-click)
    // Rotate an icon -> put .toggle-icon-rotate class to an icon element
    
    toggle(){
        let toggles = document.querySelectorAll('.toggle-click')

        if(toggles){
            toggles.forEach(toggle => {

                if(toggle.classList.contains('toggle-hidden-on-start')){
                    toggle.classList.add('toggle-hidden');
                }

                toggle.onclick = function() {

                    // Do not propagate to hidden content
                    toggle.querySelector('.toggle-hide').addEventListener('click', e => {
                        e.stopPropagation();
                    })

                    toggle.classList.toggle('toggle-hidden');
                }
            })
        }
    }
}

$(document).ready(function () {
    SB.toggle()
});





let cart = null;

// Wait for DOM ready
$(document).ready(function () {

    let productFilters = new ProductFilters();
    productFilters.ini($);

    let popup = new Popup();
    popup.ini();

    let accordion = new Accordion();
    accordion.ini();

    cart = new Cart();
    cart.ini($);

    document.addEventListener("limoniapps:discountninja:cart:updated", function (event) {
        let ninjaCart = event.detail.data[0];
        cart.renderCart(ninjaCart);
    });
});

// Wait for content to load
window.onload = function(){
    let ReplaceCharacters = new ReplaceReviewCharacters();
    ReplaceCharacters.ini();
}


// New grid restart filter
    var gridButtons = document.querySelectorAll(".products-menu__filter-button, .all_products_button, .snuggs-mobile-menu-parent__childs a[href='/products#/period-underwear']")
   
    if(gridButtons){
    
        let popup = new Popup();
        let productFilters = new ProductFilters();
        let accordion = new Accordion();
    
            gridButtons.forEach(button => {
                button.addEventListener("click", e => {
                    setTimeout(e=> {
                        productFilters.ini($);
                
                        popup.ini();
                
                        accordion.ini();
                    }, 100)
                })
            })
        }


// product cell swiper JS
function renderCellSwipers(){
    const productsCellSwiper = document.querySelectorAll('.ie-product-cell');
    productsCellSwiper.forEach(product => {
      const productId = product.dataset.productId;
      const swiper = new Swiper(product.querySelector('.swiper-product-cell'), {
        slidesPerView: 'auto', 
        spaceBetween: 10,
        centerInsufficientSlides: true,
        navigation: { 
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
        })
    });
}

renderCellSwipers()


//open quick buy on mobile
function openModalQuick(modalId) {
    var modal = document.getElementById(modalId);
    var body = document.querySelector("body");
    modal.style.display = "flex";
    body.style.overflow = "hidden";
    window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      body.style.overflow = "auto";
    }
  }
  }
  
  function closeModalQuick(modalId) {
    var modal = document.getElementById(modalId);
    var body = document.querySelector("body");
    modal.style.display = "none";
    body.style.overflow = "auto";
  }

  //change checked radio button on grid with the change of the variant
  function quickMobileLoad(){
      const quickBuyMobile = document.querySelectorAll('.quick-buy-mobile');
      
      quickBuyMobile.forEach(form =>{
        const formInputs = form.querySelectorAll('input[type=radio]')
        for(let input of formInputs){
            if(!input.disabled){
                input.setAttribute('checked','');
                input.parentElement.classList.add('!tw-bg-base-green');
                input.parentElement.classList.add('tw-text-[#fff]');
                break;
            }
        }
        formInputs.forEach(input =>{
            input.addEventListener('change', function(e){
                formInputs.forEach(inputClick =>{
                    if (e.target === inputClick){
                        inputClick.setAttribute('checked','');
                        inputClick.parentElement.classList.add('!tw-bg-base-green');
                        inputClick.parentElement.classList.add('tw-text-[#fff]');
                    } else {
                        inputClick.removeAttribute('checked','');
                        inputClick.parentElement.classList.remove('!tw-bg-base-green');
                        inputClick.parentElement.classList.remove('tw-text-[#fff]');
                    }
                })
                // const priceInput = document.querySelector('.quickbuy-variant-option');
                // if (priceInput) {
                // const price = priceInput.getAttribute('price');
                // console.log(price); // logs the value of the price attribute
                // } else {
                // console.log('Element not found');
                // }
                // const variantPrice = form.querySelector('.variant-price-grid');
                // console.log(variantPrice);
                const priceNew = input.getAttribute('price');
                const priceNewEdited = Number(String(priceNew).slice(0, -2));
                const priceElement = input.parentNode.parentNode.parentNode.parentNode.previousElementSibling.querySelector('.variant-price-grid');
                if (priceElement) {
                    const priceText = priceElement.textContent;
                    const replacedText = priceText.replace(/\d+(,\d+)?(\.\d+)?/g, priceNewEdited);
                    priceElement.textContent = replacedText;
                  }
            })
        })
      })
  }

  quickMobileLoad()

//connect SVG icon based on the provided blocks in facets-values.liquid
function loadFacetsIcons(){
    const filterFacet = document.querySelectorAll('.ie-custom-facet');
    filterFacet.forEach(facet =>{
        if(facet.previousElementSibling.tagName !== 'svg'){
            const filterValues = document.querySelectorAll('.ie-facets-values');
        filterValues.forEach(value =>{
            const rowValue = value.querySelectorAll('.ie-facets-value');
            rowValue.forEach(row =>{
                if (facet.textContent.replace(/\s/g, '') === value.textContent.replace(/\s/g, '')){
                    const rowIcon = row.querySelector('.ie-facets-icon svg');
                    if(rowIcon){
                        facet.parentNode.insertBefore(rowIcon.cloneNode(true), facet);
                    }
                }
            })
        })
        }
        
    })
}

